export const position = [
  {
    pid: 110000,
    name: '北京市',
    cityList: [
      {
        areaList: [
          {
            name: '东城区',
            did: 110101
          },
          {
            name: '西城区',
            did: 110102
          },
          {
            name: '朝阳区',
            did: 110105
          },
          {
            name: '丰台区',
            did: 110106
          },
          {
            name: '石景山区',
            did: 110107
          },
          {
            name: '海淀区',
            did: 110108
          },
          {
            name: '门头沟区',
            did: 110109
          },
          {
            name: '房山区',
            did: 110111
          },
          {
            name: '通州区',
            did: 110112
          },
          {
            name: '顺义区',
            did: 110113
          },
          {
            name: '昌平区',
            did: 110114
          },
          {
            name: '大兴区',
            did: 110115
          },
          {
            name: '怀柔区',
            did: 110116
          },
          {
            name: '平谷区',
            did: 110117
          },
          {
            name: '密云县',
            did: 110228
          },
          {
            name: '延庆县',
            did: 110229
          }
        ],
        name: '北京市',
        cid: 110000
      }
    ]
  },
  {
    pid: 120000,
    name: '天津市',
    cityList: [
      {
        areaList: [
          {
            name: '和平区',
            did: 120101
          },
          {
            name: '河东区',
            did: 120102
          },
          {
            name: '河西区',
            did: 120103
          },
          {
            name: '南开区',
            did: 120104
          },
          {
            name: '河北区',
            did: 120105
          },
          {
            name: '红桥区',
            did: 120106
          },
          {
            name: '东丽区',
            did: 120110
          },
          {
            name: '西青区',
            did: 120111
          },
          {
            name: '津南区',
            did: 120112
          },
          {
            name: '北辰区',
            did: 120113
          },
          {
            name: '武清区',
            did: 120114
          },
          {
            name: '宝坻区',
            did: 120115
          },
          {
            name: '滨海新区',
            did: 120116
          },
          {
            name: '宁河县',
            did: 120221
          },
          {
            name: '静海县',
            did: 120223
          },
          {
            name: '蓟县',
            did: 120225
          }
        ],
        name: '天津市',
        cid: 120000
      }
    ]
  },
  {
    pid: 130000,
    name: '河北省',
    cityList: [
      {
        areaList: [
          {
            name: '市辖区',
            did: 130101
          },
          {
            name: '长安区',
            did: 130102
          },
          {
            name: '桥东区',
            did: 130103
          },
          {
            name: '桥西区',
            did: 130104
          },
          {
            name: '新华区',
            did: 130105
          },
          {
            name: '井陉矿区',
            did: 130107
          },
          {
            name: '裕华区',
            did: 130108
          },
          {
            name: '井陉县',
            did: 130121
          },
          {
            name: '正定县',
            did: 130123
          },
          {
            name: '栾城县',
            did: 130124
          },
          {
            name: '行唐县',
            did: 130125
          },
          {
            name: '灵寿县',
            did: 130126
          },
          {
            name: '高邑县',
            did: 130127
          },
          {
            name: '深泽县',
            did: 130128
          },
          {
            name: '赞皇县',
            did: 130129
          },
          {
            name: '无极县',
            did: 130130
          },
          {
            name: '平山县',
            did: 130131
          },
          {
            name: '元氏县',
            did: 130132
          },
          {
            name: '赵县',
            did: 130133
          },
          {
            name: '辛集市',
            did: 130181
          },
          {
            name: '藁城市',
            did: 130182
          },
          {
            name: '晋州市',
            did: 130183
          },
          {
            name: '新乐市',
            did: 130184
          },
          {
            name: '鹿泉市',
            did: 130185
          }
        ],
        name: '石家庄市',
        cid: 130100
      },
      {
        areaList: [
          {
            name: '市辖区',
            did: 130201
          },
          {
            name: '路南区',
            did: 130202
          },
          {
            name: '路北区',
            did: 130203
          },
          {
            name: '古冶区',
            did: 130204
          },
          {
            name: '开平区',
            did: 130205
          },
          {
            name: '丰南区',
            did: 130207
          },
          {
            name: '丰润区',
            did: 130208
          },
          {
            name: '曹妃甸区',
            did: 130209
          },
          {
            name: '滦县',
            did: 130223
          },
          {
            name: '滦南县',
            did: 130224
          },
          {
            name: '乐亭县',
            did: 130225
          },
          {
            name: '迁西县',
            did: 130227
          },
          {
            name: '玉田县',
            did: 130229
          },
          {
            name: '遵化市',
            did: 130281
          },
          {
            name: '迁安市',
            did: 130283
          }
        ],
        name: '唐山市',
        cid: 130200
      },
      {
        areaList: [
          {
            name: '市辖区',
            did: 130301
          },
          {
            name: '海港区',
            did: 130302
          },
          {
            name: '山海关区',
            did: 130303
          },
          {
            name: '北戴河区',
            did: 130304
          },
          {
            name: '青龙满族自治县',
            did: 130321
          },
          {
            name: '昌黎县',
            did: 130322
          },
          {
            name: '抚宁县',
            did: 130323
          },
          {
            name: '卢龙县',
            did: 130324
          }
        ],
        name: '秦皇岛市',
        cid: 130300
      },
      {
        areaList: [
          {
            name: '市辖区',
            did: 130401
          },
          {
            name: '邯山区',
            did: 130402
          },
          {
            name: '丛台区',
            did: 130403
          },
          {
            name: '复兴区',
            did: 130404
          },
          {
            name: '峰峰矿区',
            did: 130406
          },
          {
            name: '邯郸县',
            did: 130421
          },
          {
            name: '临漳县',
            did: 130423
          },
          {
            name: '成安县',
            did: 130424
          },
          {
            name: '大名县',
            did: 130425
          },
          {
            name: '涉县',
            did: 130426
          },
          {
            name: '磁县',
            did: 130427
          },
          {
            name: '肥乡县',
            did: 130428
          },
          {
            name: '永年县',
            did: 130429
          },
          {
            name: '邱县',
            did: 130430
          },
          {
            name: '鸡泽县',
            did: 130431
          },
          {
            name: '广平县',
            did: 130432
          },
          {
            name: '馆陶县',
            did: 130433
          },
          {
            name: '魏县',
            did: 130434
          },
          {
            name: '曲周县',
            did: 130435
          },
          {
            name: '武安市',
            did: 130481
          }
        ],
        name: '邯郸市',
        cid: 130400
      },
      {
        areaList: [
          {
            name: '市辖区',
            did: 130501
          },
          {
            name: '桥东区',
            did: 130502
          },
          {
            name: '桥西区',
            did: 130503
          },
          {
            name: '邢台县',
            did: 130521
          },
          {
            name: '临城县',
            did: 130522
          },
          {
            name: '内丘县',
            did: 130523
          },
          {
            name: '柏乡县',
            did: 130524
          },
          {
            name: '隆尧县',
            did: 130525
          },
          {
            name: '任县',
            did: 130526
          },
          {
            name: '南和县',
            did: 130527
          },
          {
            name: '宁晋县',
            did: 130528
          },
          {
            name: '巨鹿县',
            did: 130529
          },
          {
            name: '新河县',
            did: 130530
          },
          {
            name: '广宗县',
            did: 130531
          },
          {
            name: '平乡县',
            did: 130532
          },
          {
            name: '威县',
            did: 130533
          },
          {
            name: '清河县',
            did: 130534
          },
          {
            name: '临西县',
            did: 130535
          },
          {
            name: '南宫市',
            did: 130581
          },
          {
            name: '沙河市',
            did: 130582
          }
        ],
        name: '邢台市',
        cid: 130500
      },
      {
        areaList: [
          {
            name: '市辖区',
            did: 130601
          },
          {
            name: '新市区',
            did: 130602
          },
          {
            name: '北市区',
            did: 130603
          },
          {
            name: '南市区',
            did: 130604
          },
          {
            name: '满城县',
            did: 130621
          },
          {
            name: '清苑县',
            did: 130622
          },
          {
            name: '涞水县',
            did: 130623
          },
          {
            name: '阜平县',
            did: 130624
          },
          {
            name: '徐水县',
            did: 130625
          },
          {
            name: '定兴县',
            did: 130626
          },
          {
            name: '唐县',
            did: 130627
          },
          {
            name: '高阳县',
            did: 130628
          },
          {
            name: '容城县',
            did: 130629
          },
          {
            name: '涞源县',
            did: 130630
          },
          {
            name: '望都县',
            did: 130631
          },
          {
            name: '安新县',
            did: 130632
          },
          {
            name: '易县',
            did: 130633
          },
          {
            name: '曲阳县',
            did: 130634
          },
          {
            name: '蠡县',
            did: 130635
          },
          {
            name: '顺平县',
            did: 130636
          },
          {
            name: '博野县',
            did: 130637
          },
          {
            name: '雄县',
            did: 130638
          },
          {
            name: '涿州市',
            did: 130681
          },
          {
            name: '定州市',
            did: 130682
          },
          {
            name: '安国市',
            did: 130683
          },
          {
            name: '高碑店市',
            did: 130684
          }
        ],
        name: '保定市',
        cid: 130600
      },
      {
        areaList: [
          {
            name: '市辖区',
            did: 130701
          },
          {
            name: '桥东区',
            did: 130702
          },
          {
            name: '桥西区',
            did: 130703
          },
          {
            name: '宣化区',
            did: 130705
          },
          {
            name: '下花园区',
            did: 130706
          },
          {
            name: '宣化县',
            did: 130721
          },
          {
            name: '张北县',
            did: 130722
          },
          {
            name: '康保县',
            did: 130723
          },
          {
            name: '沽源县',
            did: 130724
          },
          {
            name: '尚义县',
            did: 130725
          },
          {
            name: '蔚县',
            did: 130726
          },
          {
            name: '阳原县',
            did: 130727
          },
          {
            name: '怀安县',
            did: 130728
          },
          {
            name: '万全县',
            did: 130729
          },
          {
            name: '怀来县',
            did: 130730
          },
          {
            name: '涿鹿县',
            did: 130731
          },
          {
            name: '赤城县',
            did: 130732
          },
          {
            name: '崇礼县',
            did: 130733
          }
        ],
        name: '张家口市',
        cid: 130700
      },
      {
        areaList: [
          {
            name: '市辖区',
            did: 130801
          },
          {
            name: '双桥区',
            did: 130802
          },
          {
            name: '双滦区',
            did: 130803
          },
          {
            name: '鹰手营子矿区',
            did: 130804
          },
          {
            name: '承德县',
            did: 130821
          },
          {
            name: '兴隆县',
            did: 130822
          },
          {
            name: '平泉县',
            did: 130823
          },
          {
            name: '滦平县',
            did: 130824
          },
          {
            name: '隆化县',
            did: 130825
          },
          {
            name: '丰宁满族自治县',
            did: 130826
          },
          {
            name: '宽城满族自治县',
            did: 130827
          },
          {
            name: '围场满族蒙古族自治县',
            did: 130828
          }
        ],
        name: '承德市',
        cid: 130800
      },
      {
        areaList: [
          {
            name: '市辖区',
            did: 130901
          },
          {
            name: '新华区',
            did: 130902
          },
          {
            name: '运河区',
            did: 130903
          },
          {
            name: '沧县',
            did: 130921
          },
          {
            name: '青县',
            did: 130922
          },
          {
            name: '东光县',
            did: 130923
          },
          {
            name: '海兴县',
            did: 130924
          },
          {
            name: '盐山县',
            did: 130925
          },
          {
            name: '肃宁县',
            did: 130926
          },
          {
            name: '南皮县',
            did: 130927
          },
          {
            name: '吴桥县',
            did: 130928
          },
          {
            name: '献县',
            did: 130929
          },
          {
            name: '孟村回族自治县',
            did: 130930
          },
          {
            name: '泊头市',
            did: 130981
          },
          {
            name: '任丘市',
            did: 130982
          },
          {
            name: '黄骅市',
            did: 130983
          },
          {
            name: '河间市',
            did: 130984
          }
        ],
        name: '沧州市',
        cid: 130900
      },
      {
        areaList: [
          {
            name: '市辖区',
            did: 131001
          },
          {
            name: '安次区',
            did: 131002
          },
          {
            name: '广阳区',
            did: 131003
          },
          {
            name: '固安县',
            did: 131022
          },
          {
            name: '永清县',
            did: 131023
          },
          {
            name: '香河县',
            did: 131024
          },
          {
            name: '大城县',
            did: 131025
          },
          {
            name: '文安县',
            did: 131026
          },
          {
            name: '大厂回族自治县',
            did: 131028
          },
          {
            name: '霸州市',
            did: 131081
          },
          {
            name: '三河市',
            did: 131082
          }
        ],
        name: '廊坊市',
        cid: 131000
      },
      {
        areaList: [
          {
            name: '市辖区',
            did: 131101
          },
          {
            name: '桃城区',
            did: 131102
          },
          {
            name: '枣强县',
            did: 131121
          },
          {
            name: '武邑县',
            did: 131122
          },
          {
            name: '武强县',
            did: 131123
          },
          {
            name: '饶阳县',
            did: 131124
          },
          {
            name: '安平县',
            did: 131125
          },
          {
            name: '故城县',
            did: 131126
          },
          {
            name: '景县',
            did: 131127
          },
          {
            name: '阜城县',
            did: 131128
          },
          {
            name: '冀州市',
            did: 131181
          },
          {
            name: '深州市',
            did: 131182
          }
        ],
        name: '衡水市',
        cid: 131100
      }
    ]
  },
  {
    pid: 140000,
    name: '山西省',
    cityList: [
      {
        areaList: [
          {
            name: '市辖区',
            did: 140101
          },
          {
            name: '小店区',
            did: 140105
          },
          {
            name: '迎泽区',
            did: 140106
          },
          {
            name: '杏花岭区',
            did: 140107
          },
          {
            name: '尖草坪区',
            did: 140108
          },
          {
            name: '万柏林区',
            did: 140109
          },
          {
            name: '晋源区',
            did: 140110
          },
          {
            name: '清徐县',
            did: 140121
          },
          {
            name: '阳曲县',
            did: 140122
          },
          {
            name: '娄烦县',
            did: 140123
          },
          {
            name: '古交市',
            did: 140181
          }
        ],
        name: '太原市',
        cid: 140100
      },
      {
        areaList: [
          {
            name: '市辖区',
            did: 140201
          },
          {
            name: '城区',
            did: 140202
          },
          {
            name: '矿区',
            did: 140203
          },
          {
            name: '南郊区',
            did: 140211
          },
          {
            name: '新荣区',
            did: 140212
          },
          {
            name: '阳高县',
            did: 140221
          },
          {
            name: '天镇县',
            did: 140222
          },
          {
            name: '广灵县',
            did: 140223
          },
          {
            name: '灵丘县',
            did: 140224
          },
          {
            name: '浑源县',
            did: 140225
          },
          {
            name: '左云县',
            did: 140226
          },
          {
            name: '大同县',
            did: 140227
          }
        ],
        name: '大同市',
        cid: 140200
      },
      {
        areaList: [
          {
            name: '市辖区',
            did: 140301
          },
          {
            name: '城区',
            did: 140302
          },
          {
            name: '矿区',
            did: 140303
          },
          {
            name: '郊区',
            did: 140311
          },
          {
            name: '平定县',
            did: 140321
          },
          {
            name: '盂县',
            did: 140322
          }
        ],
        name: '阳泉市',
        cid: 140300
      },
      {
        areaList: [
          {
            name: '市辖区',
            did: 140401
          },
          {
            name: '城区',
            did: 140402
          },
          {
            name: '郊区',
            did: 140411
          },
          {
            name: '长治县',
            did: 140421
          },
          {
            name: '襄垣县',
            did: 140423
          },
          {
            name: '屯留县',
            did: 140424
          },
          {
            name: '平顺县',
            did: 140425
          },
          {
            name: '黎城县',
            did: 140426
          },
          {
            name: '壶关县',
            did: 140427
          },
          {
            name: '长子县',
            did: 140428
          },
          {
            name: '武乡县',
            did: 140429
          },
          {
            name: '沁县',
            did: 140430
          },
          {
            name: '沁源县',
            did: 140431
          },
          {
            name: '潞城市',
            did: 140481
          }
        ],
        name: '长治市',
        cid: 140400
      },
      {
        areaList: [
          {
            name: '市辖区',
            did: 140501
          },
          {
            name: '城区',
            did: 140502
          },
          {
            name: '沁水县',
            did: 140521
          },
          {
            name: '阳城县',
            did: 140522
          },
          {
            name: '陵川县',
            did: 140524
          },
          {
            name: '泽州县',
            did: 140525
          },
          {
            name: '高平市',
            did: 140581
          }
        ],
        name: '晋城市',
        cid: 140500
      },
      {
        areaList: [
          {
            name: '市辖区',
            did: 140601
          },
          {
            name: '朔城区',
            did: 140602
          },
          {
            name: '平鲁区',
            did: 140603
          },
          {
            name: '山阴县',
            did: 140621
          },
          {
            name: '应县',
            did: 140622
          },
          {
            name: '右玉县',
            did: 140623
          },
          {
            name: '怀仁县',
            did: 140624
          }
        ],
        name: '朔州市',
        cid: 140600
      },
      {
        areaList: [
          {
            name: '市辖区',
            did: 140701
          },
          {
            name: '榆次区',
            did: 140702
          },
          {
            name: '榆社县',
            did: 140721
          },
          {
            name: '左权县',
            did: 140722
          },
          {
            name: '和顺县',
            did: 140723
          },
          {
            name: '昔阳县',
            did: 140724
          },
          {
            name: '寿阳县',
            did: 140725
          },
          {
            name: '太谷县',
            did: 140726
          },
          {
            name: '祁县',
            did: 140727
          },
          {
            name: '平遥县',
            did: 140728
          },
          {
            name: '灵石县',
            did: 140729
          },
          {
            name: '介休市',
            did: 140781
          }
        ],
        name: '晋中市',
        cid: 140700
      },
      {
        areaList: [
          {
            name: '市辖区',
            did: 140801
          },
          {
            name: '盐湖区',
            did: 140802
          },
          {
            name: '临猗县',
            did: 140821
          },
          {
            name: '万荣县',
            did: 140822
          },
          {
            name: '闻喜县',
            did: 140823
          },
          {
            name: '稷山县',
            did: 140824
          },
          {
            name: '新绛县',
            did: 140825
          },
          {
            name: '绛县',
            did: 140826
          },
          {
            name: '垣曲县',
            did: 140827
          },
          {
            name: '夏县',
            did: 140828
          },
          {
            name: '平陆县',
            did: 140829
          },
          {
            name: '芮城县',
            did: 140830
          },
          {
            name: '永济市',
            did: 140881
          },
          {
            name: '河津市',
            did: 140882
          }
        ],
        name: '运城市',
        cid: 140800
      },
      {
        areaList: [
          {
            name: '市辖区',
            did: 140901
          },
          {
            name: '忻府区',
            did: 140902
          },
          {
            name: '定襄县',
            did: 140921
          },
          {
            name: '五台县',
            did: 140922
          },
          {
            name: '代县',
            did: 140923
          },
          {
            name: '繁峙县',
            did: 140924
          },
          {
            name: '宁武县',
            did: 140925
          },
          {
            name: '静乐县',
            did: 140926
          },
          {
            name: '神池县',
            did: 140927
          },
          {
            name: '五寨县',
            did: 140928
          },
          {
            name: '岢岚县',
            did: 140929
          },
          {
            name: '河曲县',
            did: 140930
          },
          {
            name: '保德县',
            did: 140931
          },
          {
            name: '偏关县',
            did: 140932
          },
          {
            name: '原平市',
            did: 140981
          }
        ],
        name: '忻州市',
        cid: 140900
      },
      {
        areaList: [
          {
            name: '市辖区',
            did: 141001
          },
          {
            name: '尧都区',
            did: 141002
          },
          {
            name: '曲沃县',
            did: 141021
          },
          {
            name: '翼城县',
            did: 141022
          },
          {
            name: '襄汾县',
            did: 141023
          },
          {
            name: '洪洞县',
            did: 141024
          },
          {
            name: '古县',
            did: 141025
          },
          {
            name: '安泽县',
            did: 141026
          },
          {
            name: '浮山县',
            did: 141027
          },
          {
            name: '吉县',
            did: 141028
          },
          {
            name: '乡宁县',
            did: 141029
          },
          {
            name: '大宁县',
            did: 141030
          },
          {
            name: '隰县',
            did: 141031
          },
          {
            name: '永和县',
            did: 141032
          },
          {
            name: '蒲县',
            did: 141033
          },
          {
            name: '汾西县',
            did: 141034
          },
          {
            name: '侯马市',
            did: 141081
          },
          {
            name: '霍州市',
            did: 141082
          }
        ],
        name: '临汾市',
        cid: 141000
      },
      {
        areaList: [
          {
            name: '市辖区',
            did: 141101
          },
          {
            name: '离石区',
            did: 141102
          },
          {
            name: '文水县',
            did: 141121
          },
          {
            name: '交城县',
            did: 141122
          },
          {
            name: '兴县',
            did: 141123
          },
          {
            name: '临县',
            did: 141124
          },
          {
            name: '柳林县',
            did: 141125
          },
          {
            name: '石楼县',
            did: 141126
          },
          {
            name: '岚县',
            did: 141127
          },
          {
            name: '方山县',
            did: 141128
          },
          {
            name: '中阳县',
            did: 141129
          },
          {
            name: '交口县',
            did: 141130
          },
          {
            name: '孝义市',
            did: 141181
          },
          {
            name: '汾阳市',
            did: 141182
          }
        ],
        name: '吕梁市',
        cid: 141100
      }
    ]
  },
  {
    pid: 150000,
    name: '内蒙古自治区',
    cityList: [
      {
        areaList: [
          {
            name: '市辖区',
            did: 150101
          },
          {
            name: '新城区',
            did: 150102
          },
          {
            name: '回民区',
            did: 150103
          },
          {
            name: '玉泉区',
            did: 150104
          },
          {
            name: '赛罕区',
            did: 150105
          },
          {
            name: '土默特左旗',
            did: 150121
          },
          {
            name: '托克托县',
            did: 150122
          },
          {
            name: '和林格尔县',
            did: 150123
          },
          {
            name: '清水河县',
            did: 150124
          },
          {
            name: '武川县',
            did: 150125
          }
        ],
        name: '呼和浩特市',
        cid: 150100
      },
      {
        areaList: [
          {
            name: '市辖区',
            did: 150201
          },
          {
            name: '东河区',
            did: 150202
          },
          {
            name: '昆都仑区',
            did: 150203
          },
          {
            name: '青山区',
            did: 150204
          },
          {
            name: '石拐区',
            did: 150205
          },
          {
            name: '白云鄂博矿区',
            did: 150206
          },
          {
            name: '九原区',
            did: 150207
          },
          {
            name: '土默特右旗',
            did: 150221
          },
          {
            name: '固阳县',
            did: 150222
          },
          {
            name: '达尔罕茂明安联合旗',
            did: 150223
          }
        ],
        name: '包头市',
        cid: 150200
      },
      {
        areaList: [
          {
            name: '市辖区',
            did: 150301
          },
          {
            name: '海勃湾区',
            did: 150302
          },
          {
            name: '海南区',
            did: 150303
          },
          {
            name: '乌达区',
            did: 150304
          }
        ],
        name: '乌海市',
        cid: 150300
      },
      {
        areaList: [
          {
            name: '市辖区',
            did: 150401
          },
          {
            name: '红山区',
            did: 150402
          },
          {
            name: '元宝山区',
            did: 150403
          },
          {
            name: '松山区',
            did: 150404
          },
          {
            name: '阿鲁科尔沁旗',
            did: 150421
          },
          {
            name: '巴林左旗',
            did: 150422
          },
          {
            name: '巴林右旗',
            did: 150423
          },
          {
            name: '林西县',
            did: 150424
          },
          {
            name: '克什克腾旗',
            did: 150425
          },
          {
            name: '翁牛特旗',
            did: 150426
          },
          {
            name: '喀喇沁旗',
            did: 150428
          },
          {
            name: '宁城县',
            did: 150429
          },
          {
            name: '敖汉旗',
            did: 150430
          }
        ],
        name: '赤峰市',
        cid: 150400
      },
      {
        areaList: [
          {
            name: '市辖区',
            did: 150501
          },
          {
            name: '科尔沁区',
            did: 150502
          },
          {
            name: '科尔沁左翼中旗',
            did: 150521
          },
          {
            name: '科尔沁左翼后旗',
            did: 150522
          },
          {
            name: '开鲁县',
            did: 150523
          },
          {
            name: '库伦旗',
            did: 150524
          },
          {
            name: '奈曼旗',
            did: 150525
          },
          {
            name: '扎鲁特旗',
            did: 150526
          },
          {
            name: '霍林郭勒市',
            did: 150581
          }
        ],
        name: '通辽市',
        cid: 150500
      },
      {
        areaList: [
          {
            name: '市辖区',
            did: 150601
          },
          {
            name: '东胜区',
            did: 150602
          },
          {
            name: '达拉特旗',
            did: 150621
          },
          {
            name: '准格尔旗',
            did: 150622
          },
          {
            name: '鄂托克前旗',
            did: 150623
          },
          {
            name: '鄂托克旗',
            did: 150624
          },
          {
            name: '杭锦旗',
            did: 150625
          },
          {
            name: '乌审旗',
            did: 150626
          },
          {
            name: '伊金霍洛旗',
            did: 150627
          }
        ],
        name: '鄂尔多斯市',
        cid: 150600
      },
      {
        areaList: [
          {
            name: '市辖区',
            did: 150701
          },
          {
            name: '海拉尔区',
            did: 150702
          },
          {
            name: '扎赉诺尔区',
            did: 150703
          },
          {
            name: '阿荣旗',
            did: 150721
          },
          {
            name: '莫力达瓦达斡尔族自治旗',
            did: 150722
          },
          {
            name: '鄂伦春自治旗',
            did: 150723
          },
          {
            name: '鄂温克族自治旗',
            did: 150724
          },
          {
            name: '陈巴尔虎旗',
            did: 150725
          },
          {
            name: '新巴尔虎左旗',
            did: 150726
          },
          {
            name: '新巴尔虎右旗',
            did: 150727
          },
          {
            name: '满洲里市',
            did: 150781
          },
          {
            name: '牙克石市',
            did: 150782
          },
          {
            name: '扎兰屯市',
            did: 150783
          },
          {
            name: '额尔古纳市',
            did: 150784
          },
          {
            name: '根河市',
            did: 150785
          }
        ],
        name: '呼伦贝尔市',
        cid: 150700
      },
      {
        areaList: [
          {
            name: '市辖区',
            did: 150801
          },
          {
            name: '临河区',
            did: 150802
          },
          {
            name: '五原县',
            did: 150821
          },
          {
            name: '磴口县',
            did: 150822
          },
          {
            name: '乌拉特前旗',
            did: 150823
          },
          {
            name: '乌拉特中旗',
            did: 150824
          },
          {
            name: '乌拉特后旗',
            did: 150825
          },
          {
            name: '杭锦后旗',
            did: 150826
          }
        ],
        name: '巴彦淖尔市',
        cid: 150800
      },
      {
        areaList: [
          {
            name: '市辖区',
            did: 150901
          },
          {
            name: '集宁区',
            did: 150902
          },
          {
            name: '卓资县',
            did: 150921
          },
          {
            name: '化德县',
            did: 150922
          },
          {
            name: '商都县',
            did: 150923
          },
          {
            name: '兴和县',
            did: 150924
          },
          {
            name: '凉城县',
            did: 150925
          },
          {
            name: '察哈尔右翼前旗',
            did: 150926
          },
          {
            name: '察哈尔右翼中旗',
            did: 150927
          },
          {
            name: '察哈尔右翼后旗',
            did: 150928
          },
          {
            name: '四子王旗',
            did: 150929
          },
          {
            name: '丰镇市',
            did: 150981
          }
        ],
        name: '乌兰察布市',
        cid: 150900
      },
      {
        areaList: [
          {
            name: '乌兰浩特市',
            did: 152201
          },
          {
            name: '阿尔山市',
            did: 152202
          },
          {
            name: '科尔沁右翼前旗',
            did: 152221
          },
          {
            name: '科尔沁右翼中旗',
            did: 152222
          },
          {
            name: '扎赉特旗',
            did: 152223
          },
          {
            name: '突泉县',
            did: 152224
          }
        ],
        name: '兴安盟',
        cid: 152200
      },
      {
        areaList: [
          {
            name: '二连浩特市',
            did: 152501
          },
          {
            name: '锡林浩特市',
            did: 152502
          },
          {
            name: '阿巴嘎旗',
            did: 152522
          },
          {
            name: '苏尼特左旗',
            did: 152523
          },
          {
            name: '苏尼特右旗',
            did: 152524
          },
          {
            name: '东乌珠穆沁旗',
            did: 152525
          },
          {
            name: '西乌珠穆沁旗',
            did: 152526
          },
          {
            name: '太仆寺旗',
            did: 152527
          },
          {
            name: '镶黄旗',
            did: 152528
          },
          {
            name: '正镶白旗',
            did: 152529
          },
          {
            name: '正蓝旗',
            did: 152530
          },
          {
            name: '多伦县',
            did: 152531
          }
        ],
        name: '锡林郭勒盟',
        cid: 152500
      },
      {
        areaList: [
          {
            name: '阿拉善左旗',
            did: 152921
          },
          {
            name: '阿拉善右旗',
            did: 152922
          },
          {
            name: '额济纳旗',
            did: 152923
          }
        ],
        name: '阿拉善盟',
        cid: 152900
      }
    ]
  },
  {
    pid: 210000,
    name: '辽宁省',
    cityList: [
      {
        areaList: [
          {
            name: '市辖区',
            did: 210101
          },
          {
            name: '和平区',
            did: 210102
          },
          {
            name: '沈河区',
            did: 210103
          },
          {
            name: '大东区',
            did: 210104
          },
          {
            name: '皇姑区',
            did: 210105
          },
          {
            name: '铁西区',
            did: 210106
          },
          {
            name: '苏家屯区',
            did: 210111
          },
          {
            name: '东陵区',
            did: 210112
          },
          {
            name: '沈北新区',
            did: 210113
          },
          {
            name: '于洪区',
            did: 210114
          },
          {
            name: '辽中县',
            did: 210122
          },
          {
            name: '康平县',
            did: 210123
          },
          {
            name: '法库县',
            did: 210124
          },
          {
            name: '新民市',
            did: 210181
          }
        ],
        name: '沈阳市',
        cid: 210100
      },
      {
        areaList: [
          {
            name: '市辖区',
            did: 210201
          },
          {
            name: '中山区',
            did: 210202
          },
          {
            name: '西岗区',
            did: 210203
          },
          {
            name: '沙河口区',
            did: 210204
          },
          {
            name: '甘井子区',
            did: 210211
          },
          {
            name: '旅顺口区',
            did: 210212
          },
          {
            name: '金州区',
            did: 210213
          },
          {
            name: '长海县',
            did: 210224
          },
          {
            name: '瓦房店市',
            did: 210281
          },
          {
            name: '普兰店市',
            did: 210282
          },
          {
            name: '庄河市',
            did: 210283
          }
        ],
        name: '大连市',
        cid: 210200
      },
      {
        areaList: [
          {
            name: '市辖区',
            did: 210301
          },
          {
            name: '铁东区',
            did: 210302
          },
          {
            name: '铁西区',
            did: 210303
          },
          {
            name: '立山区',
            did: 210304
          },
          {
            name: '千山区',
            did: 210311
          },
          {
            name: '台安县',
            did: 210321
          },
          {
            name: '岫岩满族自治县',
            did: 210323
          },
          {
            name: '海城市',
            did: 210381
          }
        ],
        name: '鞍山市',
        cid: 210300
      },
      {
        areaList: [
          {
            name: '市辖区',
            did: 210401
          },
          {
            name: '新抚区',
            did: 210402
          },
          {
            name: '东洲区',
            did: 210403
          },
          {
            name: '望花区',
            did: 210404
          },
          {
            name: '顺城区',
            did: 210411
          },
          {
            name: '抚顺县',
            did: 210421
          },
          {
            name: '新宾满族自治县',
            did: 210422
          },
          {
            name: '清原满族自治县',
            did: 210423
          }
        ],
        name: '抚顺市',
        cid: 210400
      },
      {
        areaList: [
          {
            name: '市辖区',
            did: 210501
          },
          {
            name: '平山区',
            did: 210502
          },
          {
            name: '溪湖区',
            did: 210503
          },
          {
            name: '明山区',
            did: 210504
          },
          {
            name: '南芬区',
            did: 210505
          },
          {
            name: '本溪满族自治县',
            did: 210521
          },
          {
            name: '桓仁满族自治县',
            did: 210522
          }
        ],
        name: '本溪市',
        cid: 210500
      },
      {
        areaList: [
          {
            name: '市辖区',
            did: 210601
          },
          {
            name: '元宝区',
            did: 210602
          },
          {
            name: '振兴区',
            did: 210603
          },
          {
            name: '振安区',
            did: 210604
          },
          {
            name: '宽甸满族自治县',
            did: 210624
          },
          {
            name: '东港市',
            did: 210681
          },
          {
            name: '凤城市',
            did: 210682
          }
        ],
        name: '丹东市',
        cid: 210600
      },
      {
        areaList: [
          {
            name: '市辖区',
            did: 210701
          },
          {
            name: '古塔区',
            did: 210702
          },
          {
            name: '凌河区',
            did: 210703
          },
          {
            name: '太和区',
            did: 210711
          },
          {
            name: '黑山县',
            did: 210726
          },
          {
            name: '义县',
            did: 210727
          },
          {
            name: '凌海市',
            did: 210781
          },
          {
            name: '北镇市',
            did: 210782
          }
        ],
        name: '锦州市',
        cid: 210700
      },
      {
        areaList: [
          {
            name: '市辖区',
            did: 210801
          },
          {
            name: '站前区',
            did: 210802
          },
          {
            name: '西市区',
            did: 210803
          },
          {
            name: '鲅鱼圈区',
            did: 210804
          },
          {
            name: '老边区',
            did: 210811
          },
          {
            name: '盖州市',
            did: 210881
          },
          {
            name: '大石桥市',
            did: 210882
          }
        ],
        name: '营口市',
        cid: 210800
      },
      {
        areaList: [
          {
            name: '市辖区',
            did: 210901
          },
          {
            name: '海州区',
            did: 210902
          },
          {
            name: '新邱区',
            did: 210903
          },
          {
            name: '太平区',
            did: 210904
          },
          {
            name: '清河门区',
            did: 210905
          },
          {
            name: '细河区',
            did: 210911
          },
          {
            name: '阜新蒙古族自治县',
            did: 210921
          },
          {
            name: '彰武县',
            did: 210922
          }
        ],
        name: '阜新市',
        cid: 210900
      },
      {
        areaList: [
          {
            name: '市辖区',
            did: 211001
          },
          {
            name: '白塔区',
            did: 211002
          },
          {
            name: '文圣区',
            did: 211003
          },
          {
            name: '宏伟区',
            did: 211004
          },
          {
            name: '弓长岭区',
            did: 211005
          },
          {
            name: '太子河区',
            did: 211011
          },
          {
            name: '辽阳县',
            did: 211021
          },
          {
            name: '灯塔市',
            did: 211081
          }
        ],
        name: '辽阳市',
        cid: 211000
      },
      {
        areaList: [
          {
            name: '市辖区',
            did: 211101
          },
          {
            name: '双台子区',
            did: 211102
          },
          {
            name: '兴隆台区',
            did: 211103
          },
          {
            name: '大洼县',
            did: 211121
          },
          {
            name: '盘山县',
            did: 211122
          }
        ],
        name: '盘锦市',
        cid: 211100
      },
      {
        areaList: [
          {
            name: '市辖区',
            did: 211201
          },
          {
            name: '银州区',
            did: 211202
          },
          {
            name: '清河区',
            did: 211204
          },
          {
            name: '铁岭县',
            did: 211221
          },
          {
            name: '西丰县',
            did: 211223
          },
          {
            name: '昌图县',
            did: 211224
          },
          {
            name: '调兵山市',
            did: 211281
          },
          {
            name: '开原市',
            did: 211282
          }
        ],
        name: '铁岭市',
        cid: 211200
      },
      {
        areaList: [
          {
            name: '市辖区',
            did: 211301
          },
          {
            name: '双塔区',
            did: 211302
          },
          {
            name: '龙城区',
            did: 211303
          },
          {
            name: '朝阳县',
            did: 211321
          },
          {
            name: '建平县',
            did: 211322
          },
          {
            name: '喀喇沁左翼蒙古族自治县',
            did: 211324
          },
          {
            name: '北票市',
            did: 211381
          },
          {
            name: '凌源市',
            did: 211382
          }
        ],
        name: '朝阳市',
        cid: 211300
      },
      {
        areaList: [
          {
            name: '市辖区',
            did: 211401
          },
          {
            name: '连山区',
            did: 211402
          },
          {
            name: '龙港区',
            did: 211403
          },
          {
            name: '南票区',
            did: 211404
          },
          {
            name: '绥中县',
            did: 211421
          },
          {
            name: '建昌县',
            did: 211422
          },
          {
            name: '兴城市',
            did: 211481
          }
        ],
        name: '葫芦岛市',
        cid: 211400
      }
    ]
  },
  {
    pid: 220000,
    name: '吉林省',
    cityList: [
      {
        areaList: [
          {
            name: '市辖区',
            did: 220101
          },
          {
            name: '南关区',
            did: 220102
          },
          {
            name: '宽城区',
            did: 220103
          },
          {
            name: '朝阳区',
            did: 220104
          },
          {
            name: '二道区',
            did: 220105
          },
          {
            name: '绿园区',
            did: 220106
          },
          {
            name: '双阳区',
            did: 220112
          },
          {
            name: '农安县',
            did: 220122
          },
          {
            name: '九台市',
            did: 220181
          },
          {
            name: '榆树市',
            did: 220182
          },
          {
            name: '德惠市',
            did: 220183
          }
        ],
        name: '长春市',
        cid: 220100
      },
      {
        areaList: [
          {
            name: '市辖区',
            did: 220201
          },
          {
            name: '昌邑区',
            did: 220202
          },
          {
            name: '龙潭区',
            did: 220203
          },
          {
            name: '船营区',
            did: 220204
          },
          {
            name: '丰满区',
            did: 220211
          },
          {
            name: '永吉县',
            did: 220221
          },
          {
            name: '蛟河市',
            did: 220281
          },
          {
            name: '桦甸市',
            did: 220282
          },
          {
            name: '舒兰市',
            did: 220283
          },
          {
            name: '磐石市',
            did: 220284
          }
        ],
        name: '吉林市',
        cid: 220200
      },
      {
        areaList: [
          {
            name: '市辖区',
            did: 220301
          },
          {
            name: '铁西区',
            did: 220302
          },
          {
            name: '铁东区',
            did: 220303
          },
          {
            name: '梨树县',
            did: 220322
          },
          {
            name: '伊通满族自治县',
            did: 220323
          },
          {
            name: '公主岭市',
            did: 220381
          },
          {
            name: '双辽市',
            did: 220382
          }
        ],
        name: '四平市',
        cid: 220300
      },
      {
        areaList: [
          {
            name: '市辖区',
            did: 220401
          },
          {
            name: '龙山区',
            did: 220402
          },
          {
            name: '西安区',
            did: 220403
          },
          {
            name: '东丰县',
            did: 220421
          },
          {
            name: '东辽县',
            did: 220422
          }
        ],
        name: '辽源市',
        cid: 220400
      },
      {
        areaList: [
          {
            name: '市辖区',
            did: 220501
          },
          {
            name: '东昌区',
            did: 220502
          },
          {
            name: '二道江区',
            did: 220503
          },
          {
            name: '通化县',
            did: 220521
          },
          {
            name: '辉南县',
            did: 220523
          },
          {
            name: '柳河县',
            did: 220524
          },
          {
            name: '梅河口市',
            did: 220581
          },
          {
            name: '集安市',
            did: 220582
          }
        ],
        name: '通化市',
        cid: 220500
      },
      {
        areaList: [
          {
            name: '市辖区',
            did: 220601
          },
          {
            name: '浑江区',
            did: 220602
          },
          {
            name: '江源区',
            did: 220605
          },
          {
            name: '抚松县',
            did: 220621
          },
          {
            name: '靖宇县',
            did: 220622
          },
          {
            name: '长白朝鲜族自治县',
            did: 220623
          },
          {
            name: '临江市',
            did: 220681
          }
        ],
        name: '白山市',
        cid: 220600
      },
      {
        areaList: [
          {
            name: '市辖区',
            did: 220701
          },
          {
            name: '宁江区',
            did: 220702
          },
          {
            name: '前郭尔罗斯蒙古族自治县',
            did: 220721
          },
          {
            name: '长岭县',
            did: 220722
          },
          {
            name: '乾安县',
            did: 220723
          },
          {
            name: '扶余市',
            did: 220781
          }
        ],
        name: '松原市',
        cid: 220700
      },
      {
        areaList: [
          {
            name: '市辖区',
            did: 220801
          },
          {
            name: '洮北区',
            did: 220802
          },
          {
            name: '镇赉县',
            did: 220821
          },
          {
            name: '通榆县',
            did: 220822
          },
          {
            name: '洮南市',
            did: 220881
          },
          {
            name: '大安市',
            did: 220882
          }
        ],
        name: '白城市',
        cid: 220800
      },
      {
        areaList: [
          {
            name: '延吉市',
            did: 222401
          },
          {
            name: '图们市',
            did: 222402
          },
          {
            name: '敦化市',
            did: 222403
          },
          {
            name: '珲春市',
            did: 222404
          },
          {
            name: '龙井市',
            did: 222405
          },
          {
            name: '和龙市',
            did: 222406
          },
          {
            name: '汪清县',
            did: 222424
          },
          {
            name: '安图县',
            did: 222426
          }
        ],
        name: '延边朝鲜族自治州',
        cid: 222400
      }
    ]
  },
  {
    pid: 230000,
    name: '黑龙江省',
    cityList: [
      {
        areaList: [
          {
            name: '市辖区',
            did: 230101
          },
          {
            name: '道里区',
            did: 230102
          },
          {
            name: '南岗区',
            did: 230103
          },
          {
            name: '道外区',
            did: 230104
          },
          {
            name: '平房区',
            did: 230108
          },
          {
            name: '松北区',
            did: 230109
          },
          {
            name: '香坊区',
            did: 230110
          },
          {
            name: '呼兰区',
            did: 230111
          },
          {
            name: '阿城区',
            did: 230112
          },
          {
            name: '依兰县',
            did: 230123
          },
          {
            name: '方正县',
            did: 230124
          },
          {
            name: '宾县',
            did: 230125
          },
          {
            name: '巴彦县',
            did: 230126
          },
          {
            name: '木兰县',
            did: 230127
          },
          {
            name: '通河县',
            did: 230128
          },
          {
            name: '延寿县',
            did: 230129
          },
          {
            name: '双城市',
            did: 230182
          },
          {
            name: '尚志市',
            did: 230183
          },
          {
            name: '五常市',
            did: 230184
          }
        ],
        name: '哈尔滨市',
        cid: 230100
      },
      {
        areaList: [
          {
            name: '市辖区',
            did: 230201
          },
          {
            name: '龙沙区',
            did: 230202
          },
          {
            name: '建华区',
            did: 230203
          },
          {
            name: '铁锋区',
            did: 230204
          },
          {
            name: '昂昂溪区',
            did: 230205
          },
          {
            name: '富拉尔基区',
            did: 230206
          },
          {
            name: '碾子山区',
            did: 230207
          },
          {
            name: '梅里斯达斡尔族区',
            did: 230208
          },
          {
            name: '龙江县',
            did: 230221
          },
          {
            name: '依安县',
            did: 230223
          },
          {
            name: '泰来县',
            did: 230224
          },
          {
            name: '甘南县',
            did: 230225
          },
          {
            name: '富裕县',
            did: 230227
          },
          {
            name: '克山县',
            did: 230229
          },
          {
            name: '克东县',
            did: 230230
          },
          {
            name: '拜泉县',
            did: 230231
          },
          {
            name: '讷河市',
            did: 230281
          }
        ],
        name: '齐齐哈尔市',
        cid: 230200
      },
      {
        areaList: [
          {
            name: '市辖区',
            did: 230301
          },
          {
            name: '鸡冠区',
            did: 230302
          },
          {
            name: '恒山区',
            did: 230303
          },
          {
            name: '滴道区',
            did: 230304
          },
          {
            name: '梨树区',
            did: 230305
          },
          {
            name: '城子河区',
            did: 230306
          },
          {
            name: '麻山区',
            did: 230307
          },
          {
            name: '鸡东县',
            did: 230321
          },
          {
            name: '虎林市',
            did: 230381
          },
          {
            name: '密山市',
            did: 230382
          }
        ],
        name: '鸡西市',
        cid: 230300
      },
      {
        areaList: [
          {
            name: '市辖区',
            did: 230401
          },
          {
            name: '向阳区',
            did: 230402
          },
          {
            name: '工农区',
            did: 230403
          },
          {
            name: '南山区',
            did: 230404
          },
          {
            name: '兴安区',
            did: 230405
          },
          {
            name: '东山区',
            did: 230406
          },
          {
            name: '兴山区',
            did: 230407
          },
          {
            name: '萝北县',
            did: 230421
          },
          {
            name: '绥滨县',
            did: 230422
          }
        ],
        name: '鹤岗市',
        cid: 230400
      },
      {
        areaList: [
          {
            name: '市辖区',
            did: 230501
          },
          {
            name: '尖山区',
            did: 230502
          },
          {
            name: '岭东区',
            did: 230503
          },
          {
            name: '四方台区',
            did: 230505
          },
          {
            name: '宝山区',
            did: 230506
          },
          {
            name: '集贤县',
            did: 230521
          },
          {
            name: '友谊县',
            did: 230522
          },
          {
            name: '宝清县',
            did: 230523
          },
          {
            name: '饶河县',
            did: 230524
          }
        ],
        name: '双鸭山市',
        cid: 230500
      },
      {
        areaList: [
          {
            name: '市辖区',
            did: 230601
          },
          {
            name: '萨尔图区',
            did: 230602
          },
          {
            name: '龙凤区',
            did: 230603
          },
          {
            name: '让胡路区',
            did: 230604
          },
          {
            name: '红岗区',
            did: 230605
          },
          {
            name: '大同区',
            did: 230606
          },
          {
            name: '肇州县',
            did: 230621
          },
          {
            name: '肇源县',
            did: 230622
          },
          {
            name: '林甸县',
            did: 230623
          },
          {
            name: '杜尔伯特蒙古族自治县',
            did: 230624
          }
        ],
        name: '大庆市',
        cid: 230600
      },
      {
        areaList: [
          {
            name: '市辖区',
            did: 230701
          },
          {
            name: '伊春区',
            did: 230702
          },
          {
            name: '南岔区',
            did: 230703
          },
          {
            name: '友好区',
            did: 230704
          },
          {
            name: '西林区',
            did: 230705
          },
          {
            name: '翠峦区',
            did: 230706
          },
          {
            name: '新青区',
            did: 230707
          },
          {
            name: '美溪区',
            did: 230708
          },
          {
            name: '金山屯区',
            did: 230709
          },
          {
            name: '五营区',
            did: 230710
          },
          {
            name: '乌马河区',
            did: 230711
          },
          {
            name: '汤旺河区',
            did: 230712
          },
          {
            name: '带岭区',
            did: 230713
          },
          {
            name: '乌伊岭区',
            did: 230714
          },
          {
            name: '红星区',
            did: 230715
          },
          {
            name: '上甘岭区',
            did: 230716
          },
          {
            name: '嘉荫县',
            did: 230722
          },
          {
            name: '铁力市',
            did: 230781
          }
        ],
        name: '伊春市',
        cid: 230700
      },
      {
        areaList: [
          {
            name: '市辖区',
            did: 230801
          },
          {
            name: '向阳区',
            did: 230803
          },
          {
            name: '前进区',
            did: 230804
          },
          {
            name: '东风区',
            did: 230805
          },
          {
            name: '郊区',
            did: 230811
          },
          {
            name: '桦南县',
            did: 230822
          },
          {
            name: '桦川县',
            did: 230826
          },
          {
            name: '汤原县',
            did: 230828
          },
          {
            name: '抚远县',
            did: 230833
          },
          {
            name: '同江市',
            did: 230881
          },
          {
            name: '富锦市',
            did: 230882
          }
        ],
        name: '佳木斯市',
        cid: 230800
      },
      {
        areaList: [
          {
            name: '市辖区',
            did: 230901
          },
          {
            name: '新兴区',
            did: 230902
          },
          {
            name: '桃山区',
            did: 230903
          },
          {
            name: '茄子河区',
            did: 230904
          },
          {
            name: '勃利县',
            did: 230921
          }
        ],
        name: '七台河市',
        cid: 230900
      },
      {
        areaList: [
          {
            name: '市辖区',
            did: 231001
          },
          {
            name: '东安区',
            did: 231002
          },
          {
            name: '阳明区',
            did: 231003
          },
          {
            name: '爱民区',
            did: 231004
          },
          {
            name: '西安区',
            did: 231005
          },
          {
            name: '东宁县',
            did: 231024
          },
          {
            name: '林口县',
            did: 231025
          },
          {
            name: '绥芬河市',
            did: 231081
          },
          {
            name: '海林市',
            did: 231083
          },
          {
            name: '宁安市',
            did: 231084
          },
          {
            name: '穆棱市',
            did: 231085
          }
        ],
        name: '牡丹江市',
        cid: 231000
      },
      {
        areaList: [
          {
            name: '市辖区',
            did: 231101
          },
          {
            name: '爱辉区',
            did: 231102
          },
          {
            name: '嫩江县',
            did: 231121
          },
          {
            name: '逊克县',
            did: 231123
          },
          {
            name: '孙吴县',
            did: 231124
          },
          {
            name: '北安市',
            did: 231181
          },
          {
            name: '五大连池市',
            did: 231182
          }
        ],
        name: '黑河市',
        cid: 231100
      },
      {
        areaList: [
          {
            name: '市辖区',
            did: 231201
          },
          {
            name: '北林区',
            did: 231202
          },
          {
            name: '望奎县',
            did: 231221
          },
          {
            name: '兰西县',
            did: 231222
          },
          {
            name: '青冈县',
            did: 231223
          },
          {
            name: '庆安县',
            did: 231224
          },
          {
            name: '明水县',
            did: 231225
          },
          {
            name: '绥棱县',
            did: 231226
          },
          {
            name: '安达市',
            did: 231281
          },
          {
            name: '肇东市',
            did: 231282
          },
          {
            name: '海伦市',
            did: 231283
          }
        ],
        name: '绥化市',
        cid: 231200
      },
      {
        areaList: [
          {
            name: '呼玛县',
            did: 232721
          },
          {
            name: '塔河县',
            did: 232722
          },
          {
            name: '漠河县',
            did: 232723
          }
        ],
        name: '大兴安岭地区',
        cid: 232700
      }
    ]
  },
  {
    pid: 310000,
    name: '上海市',
    cityList: [
      {
        areaList: [
          {
            name: '黄浦区',
            did: 310101
          },
          {
            name: '徐汇区',
            did: 310104
          },
          {
            name: '长宁区',
            did: 310105
          },
          {
            name: '静安区',
            did: 310106
          },
          {
            name: '普陀区',
            did: 310107
          },
          {
            name: '闸北区',
            did: 310108
          },
          {
            name: '虹口区',
            did: 310109
          },
          {
            name: '杨浦区',
            did: 310110
          },
          {
            name: '闵行区',
            did: 310112
          },
          {
            name: '宝山区',
            did: 310113
          },
          {
            name: '嘉定区',
            did: 310114
          },
          {
            name: '浦东新区',
            did: 310115
          },
          {
            name: '金山区',
            did: 310116
          },
          {
            name: '松江区',
            did: 310117
          },
          {
            name: '青浦区',
            did: 310118
          },
          {
            name: '奉贤区',
            did: 310120
          },
          {
            name: '崇明县',
            did: 310230
          }
        ],
        name: '上海市',
        cid: 310000
      }
    ]
  },
  {
    pid: 320000,
    name: '江苏省',
    cityList: [
      {
        areaList: [
          {
            name: '市辖区',
            did: 320101
          },
          {
            name: '玄武区',
            did: 320102
          },
          {
            name: '秦淮区',
            did: 320104
          },
          {
            name: '建邺区',
            did: 320105
          },
          {
            name: '鼓楼区',
            did: 320106
          },
          {
            name: '浦口区',
            did: 320111
          },
          {
            name: '栖霞区',
            did: 320113
          },
          {
            name: '雨花台区',
            did: 320114
          },
          {
            name: '江宁区',
            did: 320115
          },
          {
            name: '六合区',
            did: 320116
          },
          {
            name: '溧水区',
            did: 320117
          },
          {
            name: '高淳区',
            did: 320118
          }
        ],
        name: '南京市',
        cid: 320100
      },
      {
        areaList: [
          {
            name: '市辖区',
            did: 320201
          },
          {
            name: '崇安区',
            did: 320202
          },
          {
            name: '南长区',
            did: 320203
          },
          {
            name: '北塘区',
            did: 320204
          },
          {
            name: '锡山区',
            did: 320205
          },
          {
            name: '惠山区',
            did: 320206
          },
          {
            name: '滨湖区',
            did: 320211
          },
          {
            name: '江阴市',
            did: 320281
          },
          {
            name: '宜兴市',
            did: 320282
          }
        ],
        name: '无锡市',
        cid: 320200
      },
      {
        areaList: [
          {
            name: '市辖区',
            did: 320301
          },
          {
            name: '鼓楼区',
            did: 320302
          },
          {
            name: '云龙区',
            did: 320303
          },
          {
            name: '贾汪区',
            did: 320305
          },
          {
            name: '泉山区',
            did: 320311
          },
          {
            name: '铜山区',
            did: 320312
          },
          {
            name: '丰县',
            did: 320321
          },
          {
            name: '沛县',
            did: 320322
          },
          {
            name: '睢宁县',
            did: 320324
          },
          {
            name: '新沂市',
            did: 320381
          },
          {
            name: '邳州市',
            did: 320382
          }
        ],
        name: '徐州市',
        cid: 320300
      },
      {
        areaList: [
          {
            name: '市辖区',
            did: 320401
          },
          {
            name: '天宁区',
            did: 320402
          },
          {
            name: '钟楼区',
            did: 320404
          },
          {
            name: '戚墅堰区',
            did: 320405
          },
          {
            name: '新北区',
            did: 320411
          },
          {
            name: '武进区',
            did: 320412
          },
          {
            name: '溧阳市',
            did: 320481
          },
          {
            name: '金坛市',
            did: 320482
          }
        ],
        name: '常州市',
        cid: 320400
      },
      {
        areaList: [
          {
            name: '市辖区',
            did: 320501
          },
          {
            name: '虎丘区',
            did: 320505
          },
          {
            name: '吴中区',
            did: 320506
          },
          {
            name: '相城区',
            did: 320507
          },
          {
            name: '姑苏区',
            did: 320508
          },
          {
            name: '吴江区',
            did: 320509
          },
          {
            name: '常熟市',
            did: 320581
          },
          {
            name: '张家港市',
            did: 320582
          },
          {
            name: '昆山市',
            did: 320583
          },
          {
            name: '太仓市',
            did: 320585
          }
        ],
        name: '苏州市',
        cid: 320500
      },
      {
        areaList: [
          {
            name: '市辖区',
            did: 320601
          },
          {
            name: '崇川区',
            did: 320602
          },
          {
            name: '港闸区',
            did: 320611
          },
          {
            name: '通州区',
            did: 320612
          },
          {
            name: '海安县',
            did: 320621
          },
          {
            name: '如东县',
            did: 320623
          },
          {
            name: '启东市',
            did: 320681
          },
          {
            name: '如皋市',
            did: 320682
          },
          {
            name: '海门市',
            did: 320684
          }
        ],
        name: '南通市',
        cid: 320600
      },
      {
        areaList: [
          {
            name: '市辖区',
            did: 320701
          },
          {
            name: '连云区',
            did: 320703
          },
          {
            name: '新浦区',
            did: 320705
          },
          {
            name: '海州区',
            did: 320706
          },
          {
            name: '赣榆县',
            did: 320721
          },
          {
            name: '东海县',
            did: 320722
          },
          {
            name: '灌云县',
            did: 320723
          },
          {
            name: '灌南县',
            did: 320724
          }
        ],
        name: '连云港市',
        cid: 320700
      },
      {
        areaList: [
          {
            name: '市辖区',
            did: 320801
          },
          {
            name: '清河区',
            did: 320802
          },
          {
            name: '淮安区',
            did: 320803
          },
          {
            name: '淮阴区',
            did: 320804
          },
          {
            name: '清浦区',
            did: 320811
          },
          {
            name: '涟水县',
            did: 320826
          },
          {
            name: '洪泽县',
            did: 320829
          },
          {
            name: '盱眙县',
            did: 320830
          },
          {
            name: '金湖县',
            did: 320831
          }
        ],
        name: '淮安市',
        cid: 320800
      },
      {
        areaList: [
          {
            name: '市辖区',
            did: 320901
          },
          {
            name: '亭湖区',
            did: 320902
          },
          {
            name: '盐都区',
            did: 320903
          },
          {
            name: '响水县',
            did: 320921
          },
          {
            name: '滨海县',
            did: 320922
          },
          {
            name: '阜宁县',
            did: 320923
          },
          {
            name: '射阳县',
            did: 320924
          },
          {
            name: '建湖县',
            did: 320925
          },
          {
            name: '东台市',
            did: 320981
          },
          {
            name: '大丰市',
            did: 320982
          }
        ],
        name: '盐城市',
        cid: 320900
      },
      {
        areaList: [
          {
            name: '市辖区',
            did: 321001
          },
          {
            name: '广陵区',
            did: 321002
          },
          {
            name: '邗江区',
            did: 321003
          },
          {
            name: '江都区',
            did: 321012
          },
          {
            name: '宝应县',
            did: 321023
          },
          {
            name: '仪征市',
            did: 321081
          },
          {
            name: '高邮市',
            did: 321084
          }
        ],
        name: '扬州市',
        cid: 321000
      },
      {
        areaList: [
          {
            name: '市辖区',
            did: 321101
          },
          {
            name: '京口区',
            did: 321102
          },
          {
            name: '润州区',
            did: 321111
          },
          {
            name: '丹徒区',
            did: 321112
          },
          {
            name: '丹阳市',
            did: 321181
          },
          {
            name: '扬中市',
            did: 321182
          },
          {
            name: '句容市',
            did: 321183
          }
        ],
        name: '镇江市',
        cid: 321100
      },
      {
        areaList: [
          {
            name: '市辖区',
            did: 321201
          },
          {
            name: '海陵区',
            did: 321202
          },
          {
            name: '高港区',
            did: 321203
          },
          {
            name: '姜堰区',
            did: 321204
          },
          {
            name: '兴化市',
            did: 321281
          },
          {
            name: '靖江市',
            did: 321282
          },
          {
            name: '泰兴市',
            did: 321283
          }
        ],
        name: '泰州市',
        cid: 321200
      },
      {
        areaList: [
          {
            name: '市辖区',
            did: 321301
          },
          {
            name: '宿城区',
            did: 321302
          },
          {
            name: '宿豫区',
            did: 321311
          },
          {
            name: '沭阳县',
            did: 321322
          },
          {
            name: '泗阳县',
            did: 321323
          },
          {
            name: '泗洪县',
            did: 321324
          }
        ],
        name: '宿迁市',
        cid: 321300
      }
    ]
  },
  {
    pid: 330000,
    name: '浙江省',
    cityList: [
      {
        areaList: [
          {
            name: '市辖区',
            did: 330101
          },
          {
            name: '上城区',
            did: 330102
          },
          {
            name: '下城区',
            did: 330103
          },
          {
            name: '江干区',
            did: 330104
          },
          {
            name: '拱墅区',
            did: 330105
          },
          {
            name: '西湖区',
            did: 330106
          },
          {
            name: '滨江区',
            did: 330108
          },
          {
            name: '萧山区',
            did: 330109
          },
          {
            name: '余杭区',
            did: 330110
          },
          {
            name: '桐庐县',
            did: 330122
          },
          {
            name: '淳安县',
            did: 330127
          },
          {
            name: '建德市',
            did: 330182
          },
          {
            name: '富阳市',
            did: 330183
          },
          {
            name: '临安市',
            did: 330185
          }
        ],
        name: '杭州市',
        cid: 330100
      },
      {
        areaList: [
          {
            name: '市辖区',
            did: 330201
          },
          {
            name: '海曙区',
            did: 330203
          },
          {
            name: '江东区',
            did: 330204
          },
          {
            name: '江北区',
            did: 330205
          },
          {
            name: '北仑区',
            did: 330206
          },
          {
            name: '镇海区',
            did: 330211
          },
          {
            name: '鄞州区',
            did: 330212
          },
          {
            name: '象山县',
            did: 330225
          },
          {
            name: '宁海县',
            did: 330226
          },
          {
            name: '余姚市',
            did: 330281
          },
          {
            name: '慈溪市',
            did: 330282
          },
          {
            name: '奉化市',
            did: 330283
          }
        ],
        name: '宁波市',
        cid: 330200
      },
      {
        areaList: [
          {
            name: '市辖区',
            did: 330301
          },
          {
            name: '鹿城区',
            did: 330302
          },
          {
            name: '龙湾区',
            did: 330303
          },
          {
            name: '瓯海区',
            did: 330304
          },
          {
            name: '洞头县',
            did: 330322
          },
          {
            name: '永嘉县',
            did: 330324
          },
          {
            name: '平阳县',
            did: 330326
          },
          {
            name: '苍南县',
            did: 330327
          },
          {
            name: '文成县',
            did: 330328
          },
          {
            name: '泰顺县',
            did: 330329
          },
          {
            name: '瑞安市',
            did: 330381
          },
          {
            name: '乐清市',
            did: 330382
          }
        ],
        name: '温州市',
        cid: 330300
      },
      {
        areaList: [
          {
            name: '市辖区',
            did: 330401
          },
          {
            name: '南湖区',
            did: 330402
          },
          {
            name: '秀洲区',
            did: 330411
          },
          {
            name: '嘉善县',
            did: 330421
          },
          {
            name: '海盐县',
            did: 330424
          },
          {
            name: '海宁市',
            did: 330481
          },
          {
            name: '平湖市',
            did: 330482
          },
          {
            name: '桐乡市',
            did: 330483
          }
        ],
        name: '嘉兴市',
        cid: 330400
      },
      {
        areaList: [
          {
            name: '市辖区',
            did: 330501
          },
          {
            name: '吴兴区',
            did: 330502
          },
          {
            name: '南浔区',
            did: 330503
          },
          {
            name: '德清县',
            did: 330521
          },
          {
            name: '长兴县',
            did: 330522
          },
          {
            name: '安吉县',
            did: 330523
          }
        ],
        name: '湖州市',
        cid: 330500
      },
      {
        areaList: [
          {
            name: '市辖区',
            did: 330601
          },
          {
            name: '越城区',
            did: 330602
          },
          {
            name: '绍兴县',
            did: 330621
          },
          {
            name: '新昌县',
            did: 330624
          },
          {
            name: '诸暨市',
            did: 330681
          },
          {
            name: '上虞市',
            did: 330682
          },
          {
            name: '嵊州市',
            did: 330683
          }
        ],
        name: '绍兴市',
        cid: 330600
      },
      {
        areaList: [
          {
            name: '市辖区',
            did: 330701
          },
          {
            name: '婺城区',
            did: 330702
          },
          {
            name: '金东区',
            did: 330703
          },
          {
            name: '武义县',
            did: 330723
          },
          {
            name: '浦江县',
            did: 330726
          },
          {
            name: '磐安县',
            did: 330727
          },
          {
            name: '兰溪市',
            did: 330781
          },
          {
            name: '义乌市',
            did: 330782
          },
          {
            name: '东阳市',
            did: 330783
          },
          {
            name: '永康市',
            did: 330784
          }
        ],
        name: '金华市',
        cid: 330700
      },
      {
        areaList: [
          {
            name: '市辖区',
            did: 330801
          },
          {
            name: '柯城区',
            did: 330802
          },
          {
            name: '衢江区',
            did: 330803
          },
          {
            name: '常山县',
            did: 330822
          },
          {
            name: '开化县',
            did: 330824
          },
          {
            name: '龙游县',
            did: 330825
          },
          {
            name: '江山市',
            did: 330881
          }
        ],
        name: '衢州市',
        cid: 330800
      },
      {
        areaList: [
          {
            name: '市辖区',
            did: 330901
          },
          {
            name: '定海区',
            did: 330902
          },
          {
            name: '普陀区',
            did: 330903
          },
          {
            name: '岱山县',
            did: 330921
          },
          {
            name: '嵊泗县',
            did: 330922
          }
        ],
        name: '舟山市',
        cid: 330900
      },
      {
        areaList: [
          {
            name: '市辖区',
            did: 331001
          },
          {
            name: '椒江区',
            did: 331002
          },
          {
            name: '黄岩区',
            did: 331003
          },
          {
            name: '路桥区',
            did: 331004
          },
          {
            name: '玉环县',
            did: 331021
          },
          {
            name: '三门县',
            did: 331022
          },
          {
            name: '天台县',
            did: 331023
          },
          {
            name: '仙居县',
            did: 331024
          },
          {
            name: '温岭市',
            did: 331081
          },
          {
            name: '临海市',
            did: 331082
          }
        ],
        name: '台州市',
        cid: 331000
      },
      {
        areaList: [
          {
            name: '市辖区',
            did: 331101
          },
          {
            name: '莲都区',
            did: 331102
          },
          {
            name: '青田县',
            did: 331121
          },
          {
            name: '缙云县',
            did: 331122
          },
          {
            name: '遂昌县',
            did: 331123
          },
          {
            name: '松阳县',
            did: 331124
          },
          {
            name: '云和县',
            did: 331125
          },
          {
            name: '庆元县',
            did: 331126
          },
          {
            name: '景宁畲族自治县',
            did: 331127
          },
          {
            name: '龙泉市',
            did: 331181
          }
        ],
        name: '丽水市',
        cid: 331100
      }
    ]
  },
  {
    pid: 340000,
    name: '安徽省',
    cityList: [
      {
        areaList: [
          {
            name: '市辖区',
            did: 340101
          },
          {
            name: '瑶海区',
            did: 340102
          },
          {
            name: '庐阳区',
            did: 340103
          },
          {
            name: '蜀山区',
            did: 340104
          },
          {
            name: '包河区',
            did: 340111
          },
          {
            name: '长丰县',
            did: 340121
          },
          {
            name: '肥东县',
            did: 340122
          },
          {
            name: '肥西县',
            did: 340123
          },
          {
            name: '庐江县',
            did: 340124
          },
          {
            name: '巢湖市',
            did: 340181
          }
        ],
        name: '合肥市',
        cid: 340100
      },
      {
        areaList: [
          {
            name: '市辖区',
            did: 340201
          },
          {
            name: '镜湖区',
            did: 340202
          },
          {
            name: '弋江区',
            did: 340203
          },
          {
            name: '鸠江区',
            did: 340207
          },
          {
            name: '三山区',
            did: 340208
          },
          {
            name: '芜湖县',
            did: 340221
          },
          {
            name: '繁昌县',
            did: 340222
          },
          {
            name: '南陵县',
            did: 340223
          },
          {
            name: '无为县',
            did: 340225
          }
        ],
        name: '芜湖市',
        cid: 340200
      },
      {
        areaList: [
          {
            name: '市辖区',
            did: 340301
          },
          {
            name: '龙子湖区',
            did: 340302
          },
          {
            name: '蚌山区',
            did: 340303
          },
          {
            name: '禹会区',
            did: 340304
          },
          {
            name: '淮上区',
            did: 340311
          },
          {
            name: '怀远县',
            did: 340321
          },
          {
            name: '五河县',
            did: 340322
          },
          {
            name: '固镇县',
            did: 340323
          }
        ],
        name: '蚌埠市',
        cid: 340300
      },
      {
        areaList: [
          {
            name: '市辖区',
            did: 340401
          },
          {
            name: '大通区',
            did: 340402
          },
          {
            name: '田家庵区',
            did: 340403
          },
          {
            name: '谢家集区',
            did: 340404
          },
          {
            name: '八公山区',
            did: 340405
          },
          {
            name: '潘集区',
            did: 340406
          },
          {
            name: '凤台县',
            did: 340421
          }
        ],
        name: '淮南市',
        cid: 340400
      },
      {
        areaList: [
          {
            name: '市辖区',
            did: 340501
          },
          {
            name: '花山区',
            did: 340503
          },
          {
            name: '雨山区',
            did: 340504
          },
          {
            name: '博望区',
            did: 340506
          },
          {
            name: '当涂县',
            did: 340521
          },
          {
            name: '含山县',
            did: 340522
          },
          {
            name: '和县',
            did: 340523
          }
        ],
        name: '马鞍山市',
        cid: 340500
      },
      {
        areaList: [
          {
            name: '市辖区',
            did: 340601
          },
          {
            name: '杜集区',
            did: 340602
          },
          {
            name: '相山区',
            did: 340603
          },
          {
            name: '烈山区',
            did: 340604
          },
          {
            name: '濉溪县',
            did: 340621
          }
        ],
        name: '淮北市',
        cid: 340600
      },
      {
        areaList: [
          {
            name: '市辖区',
            did: 340701
          },
          {
            name: '铜官山区',
            did: 340702
          },
          {
            name: '狮子山区',
            did: 340703
          },
          {
            name: '郊区',
            did: 340711
          },
          {
            name: '铜陵县',
            did: 340721
          }
        ],
        name: '铜陵市',
        cid: 340700
      },
      {
        areaList: [
          {
            name: '市辖区',
            did: 340801
          },
          {
            name: '迎江区',
            did: 340802
          },
          {
            name: '大观区',
            did: 340803
          },
          {
            name: '宜秀区',
            did: 340811
          },
          {
            name: '怀宁县',
            did: 340822
          },
          {
            name: '枞阳县',
            did: 340823
          },
          {
            name: '潜山县',
            did: 340824
          },
          {
            name: '太湖县',
            did: 340825
          },
          {
            name: '宿松县',
            did: 340826
          },
          {
            name: '望江县',
            did: 340827
          },
          {
            name: '岳西县',
            did: 340828
          },
          {
            name: '桐城市',
            did: 340881
          }
        ],
        name: '安庆市',
        cid: 340800
      },
      {
        areaList: [
          {
            name: '市辖区',
            did: 341001
          },
          {
            name: '屯溪区',
            did: 341002
          },
          {
            name: '黄山区',
            did: 341003
          },
          {
            name: '徽州区',
            did: 341004
          },
          {
            name: '歙县',
            did: 341021
          },
          {
            name: '休宁县',
            did: 341022
          },
          {
            name: '黟县',
            did: 341023
          },
          {
            name: '祁门县',
            did: 341024
          }
        ],
        name: '黄山市',
        cid: 341000
      },
      {
        areaList: [
          {
            name: '市辖区',
            did: 341101
          },
          {
            name: '琅琊区',
            did: 341102
          },
          {
            name: '南谯区',
            did: 341103
          },
          {
            name: '来安县',
            did: 341122
          },
          {
            name: '全椒县',
            did: 341124
          },
          {
            name: '定远县',
            did: 341125
          },
          {
            name: '凤阳县',
            did: 341126
          },
          {
            name: '天长市',
            did: 341181
          },
          {
            name: '明光市',
            did: 341182
          }
        ],
        name: '滁州市',
        cid: 341100
      },
      {
        areaList: [
          {
            name: '市辖区',
            did: 341201
          },
          {
            name: '颍州区',
            did: 341202
          },
          {
            name: '颍东区',
            did: 341203
          },
          {
            name: '颍泉区',
            did: 341204
          },
          {
            name: '临泉县',
            did: 341221
          },
          {
            name: '太和县',
            did: 341222
          },
          {
            name: '阜南县',
            did: 341225
          },
          {
            name: '颍上县',
            did: 341226
          },
          {
            name: '界首市',
            did: 341282
          }
        ],
        name: '阜阳市',
        cid: 341200
      },
      {
        areaList: [
          {
            name: '市辖区',
            did: 341301
          },
          {
            name: '埇桥区',
            did: 341302
          },
          {
            name: '砀山县',
            did: 341321
          },
          {
            name: '萧县',
            did: 341322
          },
          {
            name: '灵璧县',
            did: 341323
          },
          {
            name: '泗县',
            did: 341324
          }
        ],
        name: '宿州市',
        cid: 341300
      },
      {
        areaList: [
          {
            name: '市辖区',
            did: 341501
          },
          {
            name: '金安区',
            did: 341502
          },
          {
            name: '裕安区',
            did: 341503
          },
          {
            name: '寿县',
            did: 341521
          },
          {
            name: '霍邱县',
            did: 341522
          },
          {
            name: '舒城县',
            did: 341523
          },
          {
            name: '金寨县',
            did: 341524
          },
          {
            name: '霍山县',
            did: 341525
          }
        ],
        name: '六安市',
        cid: 341500
      },
      {
        areaList: [
          {
            name: '市辖区',
            did: 341601
          },
          {
            name: '谯城区',
            did: 341602
          },
          {
            name: '涡阳县',
            did: 341621
          },
          {
            name: '蒙城县',
            did: 341622
          },
          {
            name: '利辛县',
            did: 341623
          }
        ],
        name: '亳州市',
        cid: 341600
      },
      {
        areaList: [
          {
            name: '市辖区',
            did: 341701
          },
          {
            name: '贵池区',
            did: 341702
          },
          {
            name: '东至县',
            did: 341721
          },
          {
            name: '石台县',
            did: 341722
          },
          {
            name: '青阳县',
            did: 341723
          }
        ],
        name: '池州市',
        cid: 341700
      },
      {
        areaList: [
          {
            name: '市辖区',
            did: 341801
          },
          {
            name: '宣州区',
            did: 341802
          },
          {
            name: '郎溪县',
            did: 341821
          },
          {
            name: '广德县',
            did: 341822
          },
          {
            name: '泾县',
            did: 341823
          },
          {
            name: '绩溪县',
            did: 341824
          },
          {
            name: '旌德县',
            did: 341825
          },
          {
            name: '宁国市',
            did: 341881
          }
        ],
        name: '宣城市',
        cid: 341800
      }
    ]
  },
  {
    pid: 350000,
    name: '福建省',
    cityList: [
      {
        areaList: [
          {
            name: '市辖区',
            did: 350101
          },
          {
            name: '鼓楼区',
            did: 350102
          },
          {
            name: '台江区',
            did: 350103
          },
          {
            name: '仓山区',
            did: 350104
          },
          {
            name: '马尾区',
            did: 350105
          },
          {
            name: '晋安区',
            did: 350111
          },
          {
            name: '闽侯县',
            did: 350121
          },
          {
            name: '连江县',
            did: 350122
          },
          {
            name: '罗源县',
            did: 350123
          },
          {
            name: '闽清县',
            did: 350124
          },
          {
            name: '永泰县',
            did: 350125
          },
          {
            name: '平潭县',
            did: 350128
          },
          {
            name: '福清市',
            did: 350181
          },
          {
            name: '长乐市',
            did: 350182
          }
        ],
        name: '福州市',
        cid: 350100
      },
      {
        areaList: [
          {
            name: '市辖区',
            did: 350201
          },
          {
            name: '思明区',
            did: 350203
          },
          {
            name: '海沧区',
            did: 350205
          },
          {
            name: '湖里区',
            did: 350206
          },
          {
            name: '集美区',
            did: 350211
          },
          {
            name: '同安区',
            did: 350212
          },
          {
            name: '翔安区',
            did: 350213
          }
        ],
        name: '厦门市',
        cid: 350200
      },
      {
        areaList: [
          {
            name: '市辖区',
            did: 350301
          },
          {
            name: '城厢区',
            did: 350302
          },
          {
            name: '涵江区',
            did: 350303
          },
          {
            name: '荔城区',
            did: 350304
          },
          {
            name: '秀屿区',
            did: 350305
          },
          {
            name: '仙游县',
            did: 350322
          }
        ],
        name: '莆田市',
        cid: 350300
      },
      {
        areaList: [
          {
            name: '市辖区',
            did: 350401
          },
          {
            name: '梅列区',
            did: 350402
          },
          {
            name: '三元区',
            did: 350403
          },
          {
            name: '明溪县',
            did: 350421
          },
          {
            name: '清流县',
            did: 350423
          },
          {
            name: '宁化县',
            did: 350424
          },
          {
            name: '大田县',
            did: 350425
          },
          {
            name: '尤溪县',
            did: 350426
          },
          {
            name: '沙县',
            did: 350427
          },
          {
            name: '将乐县',
            did: 350428
          },
          {
            name: '泰宁县',
            did: 350429
          },
          {
            name: '建宁县',
            did: 350430
          },
          {
            name: '永安市',
            did: 350481
          }
        ],
        name: '三明市',
        cid: 350400
      },
      {
        areaList: [
          {
            name: '市辖区',
            did: 350501
          },
          {
            name: '鲤城区',
            did: 350502
          },
          {
            name: '丰泽区',
            did: 350503
          },
          {
            name: '洛江区',
            did: 350504
          },
          {
            name: '泉港区',
            did: 350505
          },
          {
            name: '惠安县',
            did: 350521
          },
          {
            name: '安溪县',
            did: 350524
          },
          {
            name: '永春县',
            did: 350525
          },
          {
            name: '德化县',
            did: 350526
          },
          {
            name: '金门县',
            did: 350527
          },
          {
            name: '石狮市',
            did: 350581
          },
          {
            name: '晋江市',
            did: 350582
          },
          {
            name: '南安市',
            did: 350583
          }
        ],
        name: '泉州市',
        cid: 350500
      },
      {
        areaList: [
          {
            name: '市辖区',
            did: 350601
          },
          {
            name: '芗城区',
            did: 350602
          },
          {
            name: '龙文区',
            did: 350603
          },
          {
            name: '云霄县',
            did: 350622
          },
          {
            name: '漳浦县',
            did: 350623
          },
          {
            name: '诏安县',
            did: 350624
          },
          {
            name: '长泰县',
            did: 350625
          },
          {
            name: '东山县',
            did: 350626
          },
          {
            name: '南靖县',
            did: 350627
          },
          {
            name: '平和县',
            did: 350628
          },
          {
            name: '华安县',
            did: 350629
          },
          {
            name: '龙海市',
            did: 350681
          }
        ],
        name: '漳州市',
        cid: 350600
      },
      {
        areaList: [
          {
            name: '市辖区',
            did: 350701
          },
          {
            name: '延平区',
            did: 350702
          },
          {
            name: '顺昌县',
            did: 350721
          },
          {
            name: '浦城县',
            did: 350722
          },
          {
            name: '光泽县',
            did: 350723
          },
          {
            name: '松溪县',
            did: 350724
          },
          {
            name: '政和县',
            did: 350725
          },
          {
            name: '邵武市',
            did: 350781
          },
          {
            name: '武夷山市',
            did: 350782
          },
          {
            name: '建瓯市',
            did: 350783
          },
          {
            name: '建阳市',
            did: 350784
          }
        ],
        name: '南平市',
        cid: 350700
      },
      {
        areaList: [
          {
            name: '市辖区',
            did: 350801
          },
          {
            name: '新罗区',
            did: 350802
          },
          {
            name: '长汀县',
            did: 350821
          },
          {
            name: '永定县',
            did: 350822
          },
          {
            name: '上杭县',
            did: 350823
          },
          {
            name: '武平县',
            did: 350824
          },
          {
            name: '连城县',
            did: 350825
          },
          {
            name: '漳平市',
            did: 350881
          }
        ],
        name: '龙岩市',
        cid: 350800
      },
      {
        areaList: [
          {
            name: '市辖区',
            did: 350901
          },
          {
            name: '蕉城区',
            did: 350902
          },
          {
            name: '霞浦县',
            did: 350921
          },
          {
            name: '古田县',
            did: 350922
          },
          {
            name: '屏南县',
            did: 350923
          },
          {
            name: '寿宁县',
            did: 350924
          },
          {
            name: '周宁县',
            did: 350925
          },
          {
            name: '柘荣县',
            did: 350926
          },
          {
            name: '福安市',
            did: 350981
          },
          {
            name: '福鼎市',
            did: 350982
          }
        ],
        name: '宁德市',
        cid: 350900
      }
    ]
  },
  {
    pid: 360000,
    name: '江西省',
    cityList: [
      {
        areaList: [
          {
            name: '市辖区',
            did: 360101
          },
          {
            name: '东湖区',
            did: 360102
          },
          {
            name: '西湖区',
            did: 360103
          },
          {
            name: '青云谱区',
            did: 360104
          },
          {
            name: '湾里区',
            did: 360105
          },
          {
            name: '青山湖区',
            did: 360111
          },
          {
            name: '南昌县',
            did: 360121
          },
          {
            name: '新增县',
            did: 360122
          },
          {
            name: '安义县',
            did: 360123
          },
          {
            name: '进贤县',
            did: 360124
          }
        ],
        name: '南昌市',
        cid: 360100
      },
      {
        areaList: [
          {
            name: '市辖区',
            did: 360201
          },
          {
            name: '昌江区',
            did: 360202
          },
          {
            name: '珠山区',
            did: 360203
          },
          {
            name: '浮梁县',
            did: 360222
          },
          {
            name: '乐平市',
            did: 360281
          }
        ],
        name: '景德镇市',
        cid: 360200
      },
      {
        areaList: [
          {
            name: '市辖区',
            did: 360301
          },
          {
            name: '安源区',
            did: 360302
          },
          {
            name: '湘东区',
            did: 360313
          },
          {
            name: '莲花县',
            did: 360321
          },
          {
            name: '上栗县',
            did: 360322
          },
          {
            name: '芦溪县',
            did: 360323
          }
        ],
        name: '萍乡市',
        cid: 360300
      },
      {
        areaList: [
          {
            name: '市辖区',
            did: 360401
          },
          {
            name: '庐山区',
            did: 360402
          },
          {
            name: '浔阳区',
            did: 360403
          },
          {
            name: '九江县',
            did: 360421
          },
          {
            name: '武宁县',
            did: 360423
          },
          {
            name: '修水县',
            did: 360424
          },
          {
            name: '永修县',
            did: 360425
          },
          {
            name: '德安县',
            did: 360426
          },
          {
            name: '星子县',
            did: 360427
          },
          {
            name: '都昌县',
            did: 360428
          },
          {
            name: '湖口县',
            did: 360429
          },
          {
            name: '彭泽县',
            did: 360430
          },
          {
            name: '瑞昌市',
            did: 360481
          },
          {
            name: '共青城市',
            did: 360482
          }
        ],
        name: '九江市',
        cid: 360400
      },
      {
        areaList: [
          {
            name: '市辖区',
            did: 360501
          },
          {
            name: '渝水区',
            did: 360502
          },
          {
            name: '分宜县',
            did: 360521
          }
        ],
        name: '新余市',
        cid: 360500
      },
      {
        areaList: [
          {
            name: '市辖区',
            did: 360601
          },
          {
            name: '月湖区',
            did: 360602
          },
          {
            name: '余江县',
            did: 360622
          },
          {
            name: '贵溪市',
            did: 360681
          }
        ],
        name: '鹰潭市',
        cid: 360600
      },
      {
        areaList: [
          {
            name: '市辖区',
            did: 360701
          },
          {
            name: '章贡区',
            did: 360702
          },
          {
            name: '赣县',
            did: 360721
          },
          {
            name: '信丰县',
            did: 360722
          },
          {
            name: '大余县',
            did: 360723
          },
          {
            name: '上犹县',
            did: 360724
          },
          {
            name: '崇义县',
            did: 360725
          },
          {
            name: '安远县',
            did: 360726
          },
          {
            name: '龙南县',
            did: 360727
          },
          {
            name: '定南县',
            did: 360728
          },
          {
            name: '全南县',
            did: 360729
          },
          {
            name: '宁都县',
            did: 360730
          },
          {
            name: '于都县',
            did: 360731
          },
          {
            name: '兴国县',
            did: 360732
          },
          {
            name: '会昌县',
            did: 360733
          },
          {
            name: '寻乌县',
            did: 360734
          },
          {
            name: '石城县',
            did: 360735
          },
          {
            name: '瑞金市',
            did: 360781
          },
          {
            name: '南康市',
            did: 360782
          }
        ],
        name: '赣州市',
        cid: 360700
      },
      {
        areaList: [
          {
            name: '市辖区',
            did: 360801
          },
          {
            name: '吉州区',
            did: 360802
          },
          {
            name: '青原区',
            did: 360803
          },
          {
            name: '吉安县',
            did: 360821
          },
          {
            name: '吉水县',
            did: 360822
          },
          {
            name: '峡江县',
            did: 360823
          },
          {
            name: '新干县',
            did: 360824
          },
          {
            name: '永丰县',
            did: 360825
          },
          {
            name: '泰和县',
            did: 360826
          },
          {
            name: '遂川县',
            did: 360827
          },
          {
            name: '万安县',
            did: 360828
          },
          {
            name: '安福县',
            did: 360829
          },
          {
            name: '永新县',
            did: 360830
          },
          {
            name: '井冈山市',
            did: 360881
          }
        ],
        name: '吉安市',
        cid: 360800
      },
      {
        areaList: [
          {
            name: '市辖区',
            did: 360901
          },
          {
            name: '袁州区',
            did: 360902
          },
          {
            name: '奉新县',
            did: 360921
          },
          {
            name: '万载县',
            did: 360922
          },
          {
            name: '上高县',
            did: 360923
          },
          {
            name: '宜丰县',
            did: 360924
          },
          {
            name: '靖安县',
            did: 360925
          },
          {
            name: '铜鼓县',
            did: 360926
          },
          {
            name: '丰城市',
            did: 360981
          },
          {
            name: '樟树市',
            did: 360982
          },
          {
            name: '高安市',
            did: 360983
          }
        ],
        name: '宜春市',
        cid: 360900
      },
      {
        areaList: [
          {
            name: '市辖区',
            did: 361001
          },
          {
            name: '临川区',
            did: 361002
          },
          {
            name: '南城县',
            did: 361021
          },
          {
            name: '黎川县',
            did: 361022
          },
          {
            name: '南丰县',
            did: 361023
          },
          {
            name: '崇仁县',
            did: 361024
          },
          {
            name: '乐安县',
            did: 361025
          },
          {
            name: '宜黄县',
            did: 361026
          },
          {
            name: '金溪县',
            did: 361027
          },
          {
            name: '资溪县',
            did: 361028
          },
          {
            name: '东乡县',
            did: 361029
          },
          {
            name: '广昌县',
            did: 361030
          }
        ],
        name: '抚州市',
        cid: 361000
      },
      {
        areaList: [
          {
            name: '市辖区',
            did: 361101
          },
          {
            name: '信州区',
            did: 361102
          },
          {
            name: '上饶县',
            did: 361121
          },
          {
            name: '广丰县',
            did: 361122
          },
          {
            name: '玉山县',
            did: 361123
          },
          {
            name: '铅山县',
            did: 361124
          },
          {
            name: '横峰县',
            did: 361125
          },
          {
            name: '弋阳县',
            did: 361126
          },
          {
            name: '余干县',
            did: 361127
          },
          {
            name: '鄱阳县',
            did: 361128
          },
          {
            name: '万年县',
            did: 361129
          },
          {
            name: '婺源县',
            did: 361130
          },
          {
            name: '德兴市',
            did: 361181
          }
        ],
        name: '上饶市',
        cid: 361100
      }
    ]
  },
  {
    pid: 370000,
    name: '山东省',
    cityList: [
      {
        areaList: [
          {
            name: '市辖区',
            did: 370101
          },
          {
            name: '历下区',
            did: 370102
          },
          {
            name: '市中区',
            did: 370103
          },
          {
            name: '槐荫区',
            did: 370104
          },
          {
            name: '天桥区',
            did: 370105
          },
          {
            name: '历城区',
            did: 370112
          },
          {
            name: '长清区',
            did: 370113
          },
          {
            name: '平阴县',
            did: 370124
          },
          {
            name: '济阳县',
            did: 370125
          },
          {
            name: '商河县',
            did: 370126
          },
          {
            name: '章丘市',
            did: 370181
          }
        ],
        name: '济南市',
        cid: 370100
      },
      {
        areaList: [
          {
            name: '市辖区',
            did: 370201
          },
          {
            name: '市南区',
            did: 370202
          },
          {
            name: '市北区',
            did: 370203
          },
          {
            name: '黄岛区',
            did: 370211
          },
          {
            name: '崂山区',
            did: 370212
          },
          {
            name: '李沧区',
            did: 370213
          },
          {
            name: '城阳区',
            did: 370214
          },
          {
            name: '胶州市',
            did: 370281
          },
          {
            name: '即墨市',
            did: 370282
          },
          {
            name: '平度市',
            did: 370283
          },
          {
            name: '莱西市',
            did: 370285
          }
        ],
        name: '青岛市',
        cid: 370200
      },
      {
        areaList: [
          {
            name: '市辖区',
            did: 370301
          },
          {
            name: '淄川区',
            did: 370302
          },
          {
            name: '张店区',
            did: 370303
          },
          {
            name: '博山区',
            did: 370304
          },
          {
            name: '临淄区',
            did: 370305
          },
          {
            name: '周村区',
            did: 370306
          },
          {
            name: '桓台县',
            did: 370321
          },
          {
            name: '高青县',
            did: 370322
          },
          {
            name: '沂源县',
            did: 370323
          }
        ],
        name: '淄博市',
        cid: 370300
      },
      {
        areaList: [
          {
            name: '市辖区',
            did: 370401
          },
          {
            name: '市中区',
            did: 370402
          },
          {
            name: '薛城区',
            did: 370403
          },
          {
            name: '峄城区',
            did: 370404
          },
          {
            name: '台儿庄区',
            did: 370405
          },
          {
            name: '山亭区',
            did: 370406
          },
          {
            name: '滕州市',
            did: 370481
          }
        ],
        name: '枣庄市',
        cid: 370400
      },
      {
        areaList: [
          {
            name: '市辖区',
            did: 370501
          },
          {
            name: '东营区',
            did: 370502
          },
          {
            name: '河口区',
            did: 370503
          },
          {
            name: '垦利县',
            did: 370521
          },
          {
            name: '利津县',
            did: 370522
          },
          {
            name: '广饶县',
            did: 370523
          }
        ],
        name: '东营市',
        cid: 370500
      },
      {
        areaList: [
          {
            name: '市辖区',
            did: 370601
          },
          {
            name: '芝罘区',
            did: 370602
          },
          {
            name: '福山区',
            did: 370611
          },
          {
            name: '牟平区',
            did: 370612
          },
          {
            name: '莱山区',
            did: 370613
          },
          {
            name: '长岛县',
            did: 370634
          },
          {
            name: '龙口市',
            did: 370681
          },
          {
            name: '莱阳市',
            did: 370682
          },
          {
            name: '莱州市',
            did: 370683
          },
          {
            name: '蓬莱市',
            did: 370684
          },
          {
            name: '招远市',
            did: 370685
          },
          {
            name: '栖霞市',
            did: 370686
          },
          {
            name: '海阳市',
            did: 370687
          }
        ],
        name: '烟台市',
        cid: 370600
      },
      {
        areaList: [
          {
            name: '市辖区',
            did: 370701
          },
          {
            name: '潍城区',
            did: 370702
          },
          {
            name: '寒亭区',
            did: 370703
          },
          {
            name: '坊子区',
            did: 370704
          },
          {
            name: '奎文区',
            did: 370705
          },
          {
            name: '临朐县',
            did: 370724
          },
          {
            name: '昌乐县',
            did: 370725
          },
          {
            name: '青州市',
            did: 370781
          },
          {
            name: '诸城市',
            did: 370782
          },
          {
            name: '寿光市',
            did: 370783
          },
          {
            name: '安丘市',
            did: 370784
          },
          {
            name: '高密市',
            did: 370785
          },
          {
            name: '昌邑市',
            did: 370786
          }
        ],
        name: '潍坊市',
        cid: 370700
      },
      {
        areaList: [
          {
            name: '市辖区',
            did: 370801
          },
          {
            name: '市中区',
            did: 370802
          },
          {
            name: '任城区',
            did: 370811
          },
          {
            name: '微山县',
            did: 370826
          },
          {
            name: '鱼台县',
            did: 370827
          },
          {
            name: '金乡县',
            did: 370828
          },
          {
            name: '嘉祥县',
            did: 370829
          },
          {
            name: '汶上县',
            did: 370830
          },
          {
            name: '泗水县',
            did: 370831
          },
          {
            name: '梁山县',
            did: 370832
          },
          {
            name: '曲阜市',
            did: 370881
          },
          {
            name: '兖州市',
            did: 370882
          },
          {
            name: '邹城市',
            did: 370883
          }
        ],
        name: '济宁市',
        cid: 370800
      },
      {
        areaList: [
          {
            name: '市辖区',
            did: 370901
          },
          {
            name: '泰山区',
            did: 370902
          },
          {
            name: '岱岳区',
            did: 370911
          },
          {
            name: '宁阳县',
            did: 370921
          },
          {
            name: '东平县',
            did: 370923
          },
          {
            name: '新泰市',
            did: 370982
          },
          {
            name: '肥城市',
            did: 370983
          }
        ],
        name: '泰安市',
        cid: 370900
      },
      {
        areaList: [
          {
            name: '市辖区',
            did: 371001
          },
          {
            name: '环翠区',
            did: 371002
          },
          {
            name: '文登市',
            did: 371081
          },
          {
            name: '荣成市',
            did: 371082
          },
          {
            name: '乳山市',
            did: 371083
          }
        ],
        name: '威海市',
        cid: 371000
      },
      {
        areaList: [
          {
            name: '市辖区',
            did: 371101
          },
          {
            name: '东港区',
            did: 371102
          },
          {
            name: '岚山区',
            did: 371103
          },
          {
            name: '五莲县',
            did: 371121
          },
          {
            name: '莒县',
            did: 371122
          }
        ],
        name: '日照市',
        cid: 371100
      },
      {
        areaList: [
          {
            name: '市辖区',
            did: 371201
          },
          {
            name: '莱城区',
            did: 371202
          },
          {
            name: '钢城区',
            did: 371203
          }
        ],
        name: '莱芜市',
        cid: 371200
      },
      {
        areaList: [
          {
            name: '市辖区',
            did: 371301
          },
          {
            name: '兰山区',
            did: 371302
          },
          {
            name: '罗庄区',
            did: 371311
          },
          {
            name: '河东区',
            did: 371312
          },
          {
            name: '沂南县',
            did: 371321
          },
          {
            name: '郯城县',
            did: 371322
          },
          {
            name: '沂水县',
            did: 371323
          },
          {
            name: '苍山县',
            did: 371324
          },
          {
            name: '费县',
            did: 371325
          },
          {
            name: '平邑县',
            did: 371326
          },
          {
            name: '莒南县',
            did: 371327
          },
          {
            name: '蒙阴县',
            did: 371328
          },
          {
            name: '临沭县',
            did: 371329
          }
        ],
        name: '临沂市',
        cid: 371300
      },
      {
        areaList: [
          {
            name: '市辖区',
            did: 371401
          },
          {
            name: '德城区',
            did: 371402
          },
          {
            name: '陵县',
            did: 371421
          },
          {
            name: '宁津县',
            did: 371422
          },
          {
            name: '庆云县',
            did: 371423
          },
          {
            name: '临邑县',
            did: 371424
          },
          {
            name: '齐河县',
            did: 371425
          },
          {
            name: '平原县',
            did: 371426
          },
          {
            name: '夏津县',
            did: 371427
          },
          {
            name: '武城县',
            did: 371428
          },
          {
            name: '乐陵市',
            did: 371481
          },
          {
            name: '禹城市',
            did: 371482
          }
        ],
        name: '德州市',
        cid: 371400
      },
      {
        areaList: [
          {
            name: '市辖区',
            did: 371501
          },
          {
            name: '东昌府区',
            did: 371502
          },
          {
            name: '阳谷县',
            did: 371521
          },
          {
            name: '莘县',
            did: 371522
          },
          {
            name: '茌平县',
            did: 371523
          },
          {
            name: '东阿县',
            did: 371524
          },
          {
            name: '冠县',
            did: 371525
          },
          {
            name: '高唐县',
            did: 371526
          },
          {
            name: '临清市',
            did: 371581
          }
        ],
        name: '聊城市',
        cid: 371500
      },
      {
        areaList: [
          {
            name: '市辖区',
            did: 371601
          },
          {
            name: '滨城区',
            did: 371602
          },
          {
            name: '惠民县',
            did: 371621
          },
          {
            name: '阳信县',
            did: 371622
          },
          {
            name: '无棣县',
            did: 371623
          },
          {
            name: '沾化县',
            did: 371624
          },
          {
            name: '博兴县',
            did: 371625
          },
          {
            name: '邹平县',
            did: 371626
          }
        ],
        name: '滨州市',
        cid: 371600
      },
      {
        areaList: [
          {
            name: '市辖区',
            did: 371701
          },
          {
            name: '牡丹区',
            did: 371702
          },
          {
            name: '曹县',
            did: 371721
          },
          {
            name: '单县',
            did: 371722
          },
          {
            name: '成武县',
            did: 371723
          },
          {
            name: '巨野县',
            did: 371724
          },
          {
            name: '郓城县',
            did: 371725
          },
          {
            name: '鄄城县',
            did: 371726
          },
          {
            name: '定陶县',
            did: 371727
          },
          {
            name: '东明县',
            did: 371728
          }
        ],
        name: '菏泽市',
        cid: 371700
      }
    ]
  },
  {
    pid: 410000,
    name: '河南省',
    cityList: [
      {
        areaList: [
          {
            name: '市辖区',
            did: 410101
          },
          {
            name: '中原区',
            did: 410102
          },
          {
            name: '二七区',
            did: 410103
          },
          {
            name: '管城回族区',
            did: 410104
          },
          {
            name: '金水区',
            did: 410105
          },
          {
            name: '上街区',
            did: 410106
          },
          {
            name: '惠济区',
            did: 410108
          },
          {
            name: '中牟县',
            did: 410122
          },
          {
            name: '巩义市',
            did: 410181
          },
          {
            name: '荥阳市',
            did: 410182
          },
          {
            name: '新密市',
            did: 410183
          },
          {
            name: '新郑市',
            did: 410184
          },
          {
            name: '登封市',
            did: 410185
          }
        ],
        name: '郑州市',
        cid: 410100
      },
      {
        areaList: [
          {
            name: '市辖区',
            did: 410201
          },
          {
            name: '龙亭区',
            did: 410202
          },
          {
            name: '顺河回族区',
            did: 410203
          },
          {
            name: '鼓楼区',
            did: 410204
          },
          {
            name: '禹王台区',
            did: 410205
          },
          {
            name: '金明区',
            did: 410211
          },
          {
            name: '杞县',
            did: 410221
          },
          {
            name: '通许县',
            did: 410222
          },
          {
            name: '尉氏县',
            did: 410223
          },
          {
            name: '开封县',
            did: 410224
          },
          {
            name: '兰考县',
            did: 410225
          }
        ],
        name: '开封市',
        cid: 410200
      },
      {
        areaList: [
          {
            name: '市辖区',
            did: 410301
          },
          {
            name: '老城区',
            did: 410302
          },
          {
            name: '西工区',
            did: 410303
          },
          {
            name: '瀍河回族区',
            did: 410304
          },
          {
            name: '涧西区',
            did: 410305
          },
          {
            name: '吉利区',
            did: 410306
          },
          {
            name: '洛龙区',
            did: 410311
          },
          {
            name: '孟津县',
            did: 410322
          },
          {
            name: '新安县',
            did: 410323
          },
          {
            name: '栾川县',
            did: 410324
          },
          {
            name: '嵩县',
            did: 410325
          },
          {
            name: '汝阳县',
            did: 410326
          },
          {
            name: '宜阳县',
            did: 410327
          },
          {
            name: '洛宁县',
            did: 410328
          },
          {
            name: '伊川县',
            did: 410329
          },
          {
            name: '偃师市',
            did: 410381
          }
        ],
        name: '洛阳市',
        cid: 410300
      },
      {
        areaList: [
          {
            name: '市辖区',
            did: 410401
          },
          {
            name: '新华区',
            did: 410402
          },
          {
            name: '卫东区',
            did: 410403
          },
          {
            name: '石龙区',
            did: 410404
          },
          {
            name: '湛河区',
            did: 410411
          },
          {
            name: '宝丰县',
            did: 410421
          },
          {
            name: '叶县',
            did: 410422
          },
          {
            name: '鲁山县',
            did: 410423
          },
          {
            name: '郏县',
            did: 410425
          },
          {
            name: '舞钢市',
            did: 410481
          },
          {
            name: '汝州市',
            did: 410482
          }
        ],
        name: '平顶山市',
        cid: 410400
      },
      {
        areaList: [
          {
            name: '市辖区',
            did: 410501
          },
          {
            name: '文峰区',
            did: 410502
          },
          {
            name: '北关区',
            did: 410503
          },
          {
            name: '殷都区',
            did: 410505
          },
          {
            name: '龙安区',
            did: 410506
          },
          {
            name: '安阳县',
            did: 410522
          },
          {
            name: '汤阴县',
            did: 410523
          },
          {
            name: '滑县',
            did: 410526
          },
          {
            name: '内黄县',
            did: 410527
          },
          {
            name: '林州市',
            did: 410581
          }
        ],
        name: '安阳市',
        cid: 410500
      },
      {
        areaList: [
          {
            name: '市辖区',
            did: 410601
          },
          {
            name: '鹤山区',
            did: 410602
          },
          {
            name: '山城区',
            did: 410603
          },
          {
            name: '淇滨区',
            did: 410611
          },
          {
            name: '浚县',
            did: 410621
          },
          {
            name: '淇县',
            did: 410622
          }
        ],
        name: '鹤壁市',
        cid: 410600
      },
      {
        areaList: [
          {
            name: '市辖区',
            did: 410701
          },
          {
            name: '红旗区',
            did: 410702
          },
          {
            name: '卫滨区',
            did: 410703
          },
          {
            name: '凤泉区',
            did: 410704
          },
          {
            name: '牧野区',
            did: 410711
          },
          {
            name: '新乡县',
            did: 410721
          },
          {
            name: '获嘉县',
            did: 410724
          },
          {
            name: '原阳县',
            did: 410725
          },
          {
            name: '延津县',
            did: 410726
          },
          {
            name: '封丘县',
            did: 410727
          },
          {
            name: '长垣县',
            did: 410728
          },
          {
            name: '卫辉市',
            did: 410781
          },
          {
            name: '辉县市',
            did: 410782
          }
        ],
        name: '新乡市',
        cid: 410700
      },
      {
        areaList: [
          {
            name: '市辖区',
            did: 410801
          },
          {
            name: '解放区',
            did: 410802
          },
          {
            name: '中站区',
            did: 410803
          },
          {
            name: '马村区',
            did: 410804
          },
          {
            name: '山阳区',
            did: 410811
          },
          {
            name: '修武县',
            did: 410821
          },
          {
            name: '博爱县',
            did: 410822
          },
          {
            name: '武陟县',
            did: 410823
          },
          {
            name: '温县',
            did: 410825
          },
          {
            name: '沁阳市',
            did: 410882
          },
          {
            name: '孟州市',
            did: 410883
          }
        ],
        name: '焦作市',
        cid: 410800
      },
      {
        areaList: [
          {
            name: '市辖区',
            did: 410901
          },
          {
            name: '华龙区',
            did: 410902
          },
          {
            name: '清丰县',
            did: 410922
          },
          {
            name: '南乐县',
            did: 410923
          },
          {
            name: '范县',
            did: 410926
          },
          {
            name: '台前县',
            did: 410927
          },
          {
            name: '濮阳县',
            did: 410928
          }
        ],
        name: '濮阳市',
        cid: 410900
      },
      {
        areaList: [
          {
            name: '市辖区',
            did: 411001
          },
          {
            name: '魏都区',
            did: 411002
          },
          {
            name: '许昌县',
            did: 411023
          },
          {
            name: '鄢陵县',
            did: 411024
          },
          {
            name: '襄城县',
            did: 411025
          },
          {
            name: '禹州市',
            did: 411081
          },
          {
            name: '长葛市',
            did: 411082
          }
        ],
        name: '许昌市',
        cid: 411000
      },
      {
        areaList: [
          {
            name: '市辖区',
            did: 411101
          },
          {
            name: '源汇区',
            did: 411102
          },
          {
            name: '郾城区',
            did: 411103
          },
          {
            name: '召陵区',
            did: 411104
          },
          {
            name: '舞阳县',
            did: 411121
          },
          {
            name: '临颍县',
            did: 411122
          }
        ],
        name: '漯河市',
        cid: 411100
      },
      {
        areaList: [
          {
            name: '市辖区',
            did: 411201
          },
          {
            name: '湖滨区',
            did: 411202
          },
          {
            name: '渑池县',
            did: 411221
          },
          {
            name: '陕县',
            did: 411222
          },
          {
            name: '卢氏县',
            did: 411224
          },
          {
            name: '义马市',
            did: 411281
          },
          {
            name: '灵宝市',
            did: 411282
          }
        ],
        name: '三门峡市',
        cid: 411200
      },
      {
        areaList: [
          {
            name: '市辖区',
            did: 411301
          },
          {
            name: '宛城区',
            did: 411302
          },
          {
            name: '卧龙区',
            did: 411303
          },
          {
            name: '南召县',
            did: 411321
          },
          {
            name: '方城县',
            did: 411322
          },
          {
            name: '西峡县',
            did: 411323
          },
          {
            name: '镇平县',
            did: 411324
          },
          {
            name: '内乡县',
            did: 411325
          },
          {
            name: '淅川县',
            did: 411326
          },
          {
            name: '社旗县',
            did: 411327
          },
          {
            name: '唐河县',
            did: 411328
          },
          {
            name: '新野县',
            did: 411329
          },
          {
            name: '桐柏县',
            did: 411330
          },
          {
            name: '邓州市',
            did: 411381
          }
        ],
        name: '南阳市',
        cid: 411300
      },
      {
        areaList: [
          {
            name: '市辖区',
            did: 411401
          },
          {
            name: '梁园区',
            did: 411402
          },
          {
            name: '睢阳区',
            did: 411403
          },
          {
            name: '民权县',
            did: 411421
          },
          {
            name: '睢县',
            did: 411422
          },
          {
            name: '宁陵县',
            did: 411423
          },
          {
            name: '柘城县',
            did: 411424
          },
          {
            name: '虞城县',
            did: 411425
          },
          {
            name: '夏邑县',
            did: 411426
          },
          {
            name: '永城市',
            did: 411481
          }
        ],
        name: '商丘市',
        cid: 411400
      },
      {
        areaList: [
          {
            name: '市辖区',
            did: 411501
          },
          {
            name: '浉河区',
            did: 411502
          },
          {
            name: '平桥区',
            did: 411503
          },
          {
            name: '罗山县',
            did: 411521
          },
          {
            name: '光山县',
            did: 411522
          },
          {
            name: '新县',
            did: 411523
          },
          {
            name: '商城县',
            did: 411524
          },
          {
            name: '固始县',
            did: 411525
          },
          {
            name: '潢川县',
            did: 411526
          },
          {
            name: '淮滨县',
            did: 411527
          },
          {
            name: '息县',
            did: 411528
          }
        ],
        name: '信阳市',
        cid: 411500
      },
      {
        areaList: [
          {
            name: '市辖区',
            did: 411601
          },
          {
            name: '川汇区',
            did: 411602
          },
          {
            name: '扶沟县',
            did: 411621
          },
          {
            name: '西华县',
            did: 411622
          },
          {
            name: '商水县',
            did: 411623
          },
          {
            name: '沈丘县',
            did: 411624
          },
          {
            name: '郸城县',
            did: 411625
          },
          {
            name: '淮阳县',
            did: 411626
          },
          {
            name: '太康县',
            did: 411627
          },
          {
            name: '鹿邑县',
            did: 411628
          },
          {
            name: '项城市',
            did: 411681
          }
        ],
        name: '周口市',
        cid: 411600
      },
      {
        areaList: [
          {
            name: '市辖区',
            did: 411701
          },
          {
            name: '驿城区',
            did: 411702
          },
          {
            name: '西平县',
            did: 411721
          },
          {
            name: '上蔡县',
            did: 411722
          },
          {
            name: '平舆县',
            did: 411723
          },
          {
            name: '正阳县',
            did: 411724
          },
          {
            name: '确山县',
            did: 411725
          },
          {
            name: '泌阳县',
            did: 411726
          },
          {
            name: '汝南县',
            did: 411727
          },
          {
            name: '遂平县',
            did: 411728
          },
          {
            name: '新蔡县',
            did: 411729
          }
        ],
        name: '驻马店市',
        cid: 411700
      },
      {
        areaList: [
          {
            name: '济源市',
            did: 419001
          }
        ],
        name: '省直辖县级行政区划',
        cid: 419000
      }
    ]
  },
  {
    pid: 420000,
    name: '湖北省',
    cityList: [
      {
        areaList: [
          {
            name: '市辖区',
            did: 420101
          },
          {
            name: '江岸区',
            did: 420102
          },
          {
            name: '江汉区',
            did: 420103
          },
          {
            name: '硚口区',
            did: 420104
          },
          {
            name: '汉阳区',
            did: 420105
          },
          {
            name: '武昌区',
            did: 420106
          },
          {
            name: '青山区',
            did: 420107
          },
          {
            name: '洪山区',
            did: 420111
          },
          {
            name: '东西湖区',
            did: 420112
          },
          {
            name: '汉南区',
            did: 420113
          },
          {
            name: '蔡甸区',
            did: 420114
          },
          {
            name: '江夏区',
            did: 420115
          },
          {
            name: '黄陂区',
            did: 420116
          },
          {
            name: '新洲区',
            did: 420117
          }
        ],
        name: '武汉市',
        cid: 420100
      },
      {
        areaList: [
          {
            name: '市辖区',
            did: 420201
          },
          {
            name: '黄石港区',
            did: 420202
          },
          {
            name: '西塞山区',
            did: 420203
          },
          {
            name: '下陆区',
            did: 420204
          },
          {
            name: '铁山区',
            did: 420205
          },
          {
            name: '阳新县',
            did: 420222
          },
          {
            name: '大冶市',
            did: 420281
          }
        ],
        name: '黄石市',
        cid: 420200
      },
      {
        areaList: [
          {
            name: '市辖区',
            did: 420301
          },
          {
            name: '茅箭区',
            did: 420302
          },
          {
            name: '张湾区',
            did: 420303
          },
          {
            name: '郧县',
            did: 420321
          },
          {
            name: '郧西县',
            did: 420322
          },
          {
            name: '竹山县',
            did: 420323
          },
          {
            name: '竹溪县',
            did: 420324
          },
          {
            name: '房县',
            did: 420325
          },
          {
            name: '丹江口市',
            did: 420381
          }
        ],
        name: '十堰市',
        cid: 420300
      },
      {
        areaList: [
          {
            name: '市辖区',
            did: 420501
          },
          {
            name: '西陵区',
            did: 420502
          },
          {
            name: '伍家岗区',
            did: 420503
          },
          {
            name: '点军区',
            did: 420504
          },
          {
            name: '猇亭区',
            did: 420505
          },
          {
            name: '夷陵区',
            did: 420506
          },
          {
            name: '远安县',
            did: 420525
          },
          {
            name: '兴山县',
            did: 420526
          },
          {
            name: '秭归县',
            did: 420527
          },
          {
            name: '长阳土家族自治县',
            did: 420528
          },
          {
            name: '五峰土家族自治县',
            did: 420529
          },
          {
            name: '宜都市',
            did: 420581
          },
          {
            name: '当阳市',
            did: 420582
          },
          {
            name: '枝江市',
            did: 420583
          }
        ],
        name: '宜昌市',
        cid: 420500
      },
      {
        areaList: [
          {
            name: '市辖区',
            did: 420601
          },
          {
            name: '襄城区',
            did: 420602
          },
          {
            name: '樊城区',
            did: 420606
          },
          {
            name: '襄州区',
            did: 420607
          },
          {
            name: '南漳县',
            did: 420624
          },
          {
            name: '谷城县',
            did: 420625
          },
          {
            name: '保康县',
            did: 420626
          },
          {
            name: '老河口市',
            did: 420682
          },
          {
            name: '枣阳市',
            did: 420683
          },
          {
            name: '宜城市',
            did: 420684
          }
        ],
        name: '襄阳市',
        cid: 420600
      },
      {
        areaList: [
          {
            name: '市辖区',
            did: 420701
          },
          {
            name: '梁子湖区',
            did: 420702
          },
          {
            name: '华容区',
            did: 420703
          },
          {
            name: '鄂城区',
            did: 420704
          }
        ],
        name: '鄂州市',
        cid: 420700
      },
      {
        areaList: [
          {
            name: '市辖区',
            did: 420801
          },
          {
            name: '东宝区',
            did: 420802
          },
          {
            name: '掇刀区',
            did: 420804
          },
          {
            name: '京山县',
            did: 420821
          },
          {
            name: '沙洋县',
            did: 420822
          },
          {
            name: '钟祥市',
            did: 420881
          }
        ],
        name: '荆门市',
        cid: 420800
      },
      {
        areaList: [
          {
            name: '市辖区',
            did: 420901
          },
          {
            name: '孝南区',
            did: 420902
          },
          {
            name: '孝昌县',
            did: 420921
          },
          {
            name: '大悟县',
            did: 420922
          },
          {
            name: '云梦县',
            did: 420923
          },
          {
            name: '应城市',
            did: 420981
          },
          {
            name: '安陆市',
            did: 420982
          },
          {
            name: '汉川市',
            did: 420984
          }
        ],
        name: '孝感市',
        cid: 420900
      },
      {
        areaList: [
          {
            name: '市辖区',
            did: 421001
          },
          {
            name: '沙市区',
            did: 421002
          },
          {
            name: '荆州区',
            did: 421003
          },
          {
            name: '公安县',
            did: 421022
          },
          {
            name: '监利县',
            did: 421023
          },
          {
            name: '江陵县',
            did: 421024
          },
          {
            name: '石首市',
            did: 421081
          },
          {
            name: '洪湖市',
            did: 421083
          },
          {
            name: '松滋市',
            did: 421087
          }
        ],
        name: '荆州市',
        cid: 421000
      },
      {
        areaList: [
          {
            name: '市辖区',
            did: 421101
          },
          {
            name: '黄州区',
            did: 421102
          },
          {
            name: '团风县',
            did: 421121
          },
          {
            name: '红安县',
            did: 421122
          },
          {
            name: '罗田县',
            did: 421123
          },
          {
            name: '英山县',
            did: 421124
          },
          {
            name: '浠水县',
            did: 421125
          },
          {
            name: '蕲春县',
            did: 421126
          },
          {
            name: '黄梅县',
            did: 421127
          },
          {
            name: '麻城市',
            did: 421181
          },
          {
            name: '武穴市',
            did: 421182
          }
        ],
        name: '黄冈市',
        cid: 421100
      },
      {
        areaList: [
          {
            name: '市辖区',
            did: 421201
          },
          {
            name: '咸安区',
            did: 421202
          },
          {
            name: '嘉鱼县',
            did: 421221
          },
          {
            name: '通城县',
            did: 421222
          },
          {
            name: '崇阳县',
            did: 421223
          },
          {
            name: '通山县',
            did: 421224
          },
          {
            name: '赤壁市',
            did: 421281
          }
        ],
        name: '咸宁市',
        cid: 421200
      },
      {
        areaList: [
          {
            name: '市辖区',
            did: 421301
          },
          {
            name: '曾都区',
            did: 421303
          },
          {
            name: '随县',
            did: 421321
          },
          {
            name: '广水市',
            did: 421381
          }
        ],
        name: '随州市',
        cid: 421300
      },
      {
        areaList: [
          {
            name: '恩施市',
            did: 422801
          },
          {
            name: '利川市',
            did: 422802
          },
          {
            name: '建始县',
            did: 422822
          },
          {
            name: '巴东县',
            did: 422823
          },
          {
            name: '宣恩县',
            did: 422825
          },
          {
            name: '咸丰县',
            did: 422826
          },
          {
            name: '来凤县',
            did: 422827
          },
          {
            name: '鹤峰县',
            did: 422828
          }
        ],
        name: '恩施土家族苗族自治州',
        cid: 422800
      },
      {
        areaList: [
          {
            name: '仙桃市',
            did: 429004
          },
          {
            name: '潜江市',
            did: 429005
          },
          {
            name: '天门市',
            did: 429006
          },
          {
            name: '神农架林区',
            did: 429021
          }
        ],
        name: '省直辖县级行政区划',
        cid: 429000
      }
    ]
  },
  {
    pid: 430000,
    name: '湖南省',
    cityList: [
      {
        areaList: [
          {
            name: '市辖区',
            did: 430101
          },
          {
            name: '芙蓉区',
            did: 430102
          },
          {
            name: '天心区',
            did: 430103
          },
          {
            name: '岳麓区',
            did: 430104
          },
          {
            name: '开福区',
            did: 430105
          },
          {
            name: '雨花区',
            did: 430111
          },
          {
            name: '望城区',
            did: 430112
          },
          {
            name: '长沙县',
            did: 430121
          },
          {
            name: '宁乡县',
            did: 430124
          },
          {
            name: '浏阳市',
            did: 430181
          }
        ],
        name: '长沙市',
        cid: 430100
      },
      {
        areaList: [
          {
            name: '市辖区',
            did: 430201
          },
          {
            name: '荷塘区',
            did: 430202
          },
          {
            name: '芦淞区',
            did: 430203
          },
          {
            name: '石峰区',
            did: 430204
          },
          {
            name: '天元区',
            did: 430211
          },
          {
            name: '株洲县',
            did: 430221
          },
          {
            name: '攸县',
            did: 430223
          },
          {
            name: '茶陵县',
            did: 430224
          },
          {
            name: '炎陵县',
            did: 430225
          },
          {
            name: '醴陵市',
            did: 430281
          }
        ],
        name: '株洲市',
        cid: 430200
      },
      {
        areaList: [
          {
            name: '市辖区',
            did: 430301
          },
          {
            name: '雨湖区',
            did: 430302
          },
          {
            name: '岳塘区',
            did: 430304
          },
          {
            name: '湘潭县',
            did: 430321
          },
          {
            name: '湘乡市',
            did: 430381
          },
          {
            name: '韶山市',
            did: 430382
          }
        ],
        name: '湘潭市',
        cid: 430300
      },
      {
        areaList: [
          {
            name: '市辖区',
            did: 430401
          },
          {
            name: '珠晖区',
            did: 430405
          },
          {
            name: '雁峰区',
            did: 430406
          },
          {
            name: '石鼓区',
            did: 430407
          },
          {
            name: '蒸湘区',
            did: 430408
          },
          {
            name: '南岳区',
            did: 430412
          },
          {
            name: '衡阳县',
            did: 430421
          },
          {
            name: '衡南县',
            did: 430422
          },
          {
            name: '衡山县',
            did: 430423
          },
          {
            name: '衡东县',
            did: 430424
          },
          {
            name: '祁东县',
            did: 430426
          },
          {
            name: '耒阳市',
            did: 430481
          },
          {
            name: '常宁市',
            did: 430482
          }
        ],
        name: '衡阳市',
        cid: 430400
      },
      {
        areaList: [
          {
            name: '市辖区',
            did: 430501
          },
          {
            name: '双清区',
            did: 430502
          },
          {
            name: '大祥区',
            did: 430503
          },
          {
            name: '北塔区',
            did: 430511
          },
          {
            name: '邵东县',
            did: 430521
          },
          {
            name: '新邵县',
            did: 430522
          },
          {
            name: '邵阳县',
            did: 430523
          },
          {
            name: '隆回县',
            did: 430524
          },
          {
            name: '洞口县',
            did: 430525
          },
          {
            name: '绥宁县',
            did: 430527
          },
          {
            name: '新宁县',
            did: 430528
          },
          {
            name: '城步苗族自治县',
            did: 430529
          },
          {
            name: '武冈市',
            did: 430581
          }
        ],
        name: '邵阳市',
        cid: 430500
      },
      {
        areaList: [
          {
            name: '市辖区',
            did: 430601
          },
          {
            name: '岳阳楼区',
            did: 430602
          },
          {
            name: '云溪区',
            did: 430603
          },
          {
            name: '君山区',
            did: 430611
          },
          {
            name: '岳阳县',
            did: 430621
          },
          {
            name: '华容县',
            did: 430623
          },
          {
            name: '湘阴县',
            did: 430624
          },
          {
            name: '平江县',
            did: 430626
          },
          {
            name: '汨罗市',
            did: 430681
          },
          {
            name: '临湘市',
            did: 430682
          }
        ],
        name: '岳阳市',
        cid: 430600
      },
      {
        areaList: [
          {
            name: '市辖区',
            did: 430701
          },
          {
            name: '武陵区',
            did: 430702
          },
          {
            name: '鼎城区',
            did: 430703
          },
          {
            name: '安乡县',
            did: 430721
          },
          {
            name: '汉寿县',
            did: 430722
          },
          {
            name: '澧县',
            did: 430723
          },
          {
            name: '临澧县',
            did: 430724
          },
          {
            name: '桃源县',
            did: 430725
          },
          {
            name: '石门县',
            did: 430726
          },
          {
            name: '津市市',
            did: 430781
          }
        ],
        name: '常德市',
        cid: 430700
      },
      {
        areaList: [
          {
            name: '市辖区',
            did: 430801
          },
          {
            name: '永定区',
            did: 430802
          },
          {
            name: '武陵源区',
            did: 430811
          },
          {
            name: '慈利县',
            did: 430821
          },
          {
            name: '桑植县',
            did: 430822
          }
        ],
        name: '张家界市',
        cid: 430800
      },
      {
        areaList: [
          {
            name: '市辖区',
            did: 430901
          },
          {
            name: '资阳区',
            did: 430902
          },
          {
            name: '赫山区',
            did: 430903
          },
          {
            name: '南县',
            did: 430921
          },
          {
            name: '桃江县',
            did: 430922
          },
          {
            name: '安化县',
            did: 430923
          },
          {
            name: '沅江市',
            did: 430981
          }
        ],
        name: '益阳市',
        cid: 430900
      },
      {
        areaList: [
          {
            name: '市辖区',
            did: 431001
          },
          {
            name: '北湖区',
            did: 431002
          },
          {
            name: '苏仙区',
            did: 431003
          },
          {
            name: '桂阳县',
            did: 431021
          },
          {
            name: '宜章县',
            did: 431022
          },
          {
            name: '永兴县',
            did: 431023
          },
          {
            name: '嘉禾县',
            did: 431024
          },
          {
            name: '临武县',
            did: 431025
          },
          {
            name: '汝城县',
            did: 431026
          },
          {
            name: '桂东县',
            did: 431027
          },
          {
            name: '安仁县',
            did: 431028
          },
          {
            name: '资兴市',
            did: 431081
          }
        ],
        name: '郴州市',
        cid: 431000
      },
      {
        areaList: [
          {
            name: '市辖区',
            did: 431101
          },
          {
            name: '零陵区',
            did: 431102
          },
          {
            name: '冷水滩区',
            did: 431103
          },
          {
            name: '祁阳县',
            did: 431121
          },
          {
            name: '东安县',
            did: 431122
          },
          {
            name: '双牌县',
            did: 431123
          },
          {
            name: '道县',
            did: 431124
          },
          {
            name: '江永县',
            did: 431125
          },
          {
            name: '宁远县',
            did: 431126
          },
          {
            name: '蓝山县',
            did: 431127
          },
          {
            name: '新田县',
            did: 431128
          },
          {
            name: '江华瑶族自治县',
            did: 431129
          }
        ],
        name: '永州市',
        cid: 431100
      },
      {
        areaList: [
          {
            name: '市辖区',
            did: 431201
          },
          {
            name: '鹤城区',
            did: 431202
          },
          {
            name: '中方县',
            did: 431221
          },
          {
            name: '沅陵县',
            did: 431222
          },
          {
            name: '辰溪县',
            did: 431223
          },
          {
            name: '溆浦县',
            did: 431224
          },
          {
            name: '会同县',
            did: 431225
          },
          {
            name: '麻阳苗族自治县',
            did: 431226
          },
          {
            name: '新晃侗族自治县',
            did: 431227
          },
          {
            name: '芷江侗族自治县',
            did: 431228
          },
          {
            name: '靖州苗族侗族自治县',
            did: 431229
          },
          {
            name: '通道侗族自治县',
            did: 431230
          },
          {
            name: '洪江市',
            did: 431281
          }
        ],
        name: '怀化市',
        cid: 431200
      },
      {
        areaList: [
          {
            name: '市辖区',
            did: 431301
          },
          {
            name: '娄星区',
            did: 431302
          },
          {
            name: '双峰县',
            did: 431321
          },
          {
            name: '新化县',
            did: 431322
          },
          {
            name: '冷水江市',
            did: 431381
          },
          {
            name: '涟源市',
            did: 431382
          }
        ],
        name: '娄底市',
        cid: 431300
      },
      {
        areaList: [
          {
            name: '吉首市',
            did: 433101
          },
          {
            name: '泸溪县',
            did: 433122
          },
          {
            name: '凤凰县',
            did: 433123
          },
          {
            name: '花垣县',
            did: 433124
          },
          {
            name: '保靖县',
            did: 433125
          },
          {
            name: '古丈县',
            did: 433126
          },
          {
            name: '永顺县',
            did: 433127
          },
          {
            name: '龙山县',
            did: 433130
          }
        ],
        name: '湘西土家族苗族自治州',
        cid: 433100
      }
    ]
  },
  {
    pid: 440000,
    name: '广东省',
    cityList: [
      {
        areaList: [
          {
            name: '市辖区',
            did: 440101
          },
          {
            name: '荔湾区',
            did: 440103
          },
          {
            name: '越秀区',
            did: 440104
          },
          {
            name: '海珠区',
            did: 440105
          },
          {
            name: '天河区',
            did: 440106
          },
          {
            name: '白云区',
            did: 440111
          },
          {
            name: '黄埔区',
            did: 440112
          },
          {
            name: '番禺区',
            did: 440113
          },
          {
            name: '花都区',
            did: 440114
          },
          {
            name: '南沙区',
            did: 440115
          },
          {
            name: '萝岗区',
            did: 440116
          },
          {
            name: '增城市',
            did: 440183
          },
          {
            name: '从化市',
            did: 440184
          }
        ],
        name: '广州市',
        cid: 440100
      },
      {
        areaList: [
          {
            name: '市辖区',
            did: 440201
          },
          {
            name: '武江区',
            did: 440203
          },
          {
            name: '浈江区',
            did: 440204
          },
          {
            name: '曲江区',
            did: 440205
          },
          {
            name: '始兴县',
            did: 440222
          },
          {
            name: '仁化县',
            did: 440224
          },
          {
            name: '翁源县',
            did: 440229
          },
          {
            name: '乳源瑶族自治县',
            did: 440232
          },
          {
            name: '新丰县',
            did: 440233
          },
          {
            name: '乐昌市',
            did: 440281
          },
          {
            name: '南雄市',
            did: 440282
          }
        ],
        name: '韶关市',
        cid: 440200
      },
      {
        areaList: [
          {
            name: '市辖区',
            did: 440301
          },
          {
            name: '罗湖区',
            did: 440303
          },
          {
            name: '福田区',
            did: 440304
          },
          {
            name: '南山区',
            did: 440305
          },
          {
            name: '宝安区',
            did: 440306
          },
          {
            name: '龙岗区',
            did: 440307
          },
          {
            name: '盐田区',
            did: 440308
          },
          {
            name: '龙华区',
            did: 440309
          },
          {
            name: '坪山区',
            did: 440310
          },
          {
            name: '光明区',
            did: 440311
          }
        ],
        name: '深圳市',
        cid: 440300
      },
      {
        areaList: [
          {
            name: '市辖区',
            did: 440401
          },
          {
            name: '香洲区',
            did: 440402
          },
          {
            name: '斗门区',
            did: 440403
          },
          {
            name: '金湾区',
            did: 440404
          }
        ],
        name: '珠海市',
        cid: 440400
      },
      {
        areaList: [
          {
            name: '市辖区',
            did: 440501
          },
          {
            name: '龙湖区',
            did: 440507
          },
          {
            name: '金平区',
            did: 440511
          },
          {
            name: '濠江区',
            did: 440512
          },
          {
            name: '潮阳区',
            did: 440513
          },
          {
            name: '潮南区',
            did: 440514
          },
          {
            name: '澄海区',
            did: 440515
          },
          {
            name: '南澳县',
            did: 440523
          }
        ],
        name: '汕头市',
        cid: 440500
      },
      {
        areaList: [
          {
            name: '市辖区',
            did: 440601
          },
          {
            name: '禅城区',
            did: 440604
          },
          {
            name: '南海区',
            did: 440605
          },
          {
            name: '顺德区',
            did: 440606
          },
          {
            name: '三水区',
            did: 440607
          },
          {
            name: '高明区',
            did: 440608
          }
        ],
        name: '佛山市',
        cid: 440600
      },
      {
        areaList: [
          {
            name: '市辖区',
            did: 440701
          },
          {
            name: '蓬江区',
            did: 440703
          },
          {
            name: '江海区',
            did: 440704
          },
          {
            name: '新会区',
            did: 440705
          },
          {
            name: '台山市',
            did: 440781
          },
          {
            name: '开平市',
            did: 440783
          },
          {
            name: '鹤山市',
            did: 440784
          },
          {
            name: '恩平市',
            did: 440785
          }
        ],
        name: '江门市',
        cid: 440700
      },
      {
        areaList: [
          {
            name: '市辖区',
            did: 440801
          },
          {
            name: '赤坎区',
            did: 440802
          },
          {
            name: '霞山区',
            did: 440803
          },
          {
            name: '坡头区',
            did: 440804
          },
          {
            name: '麻章区',
            did: 440811
          },
          {
            name: '遂溪县',
            did: 440823
          },
          {
            name: '徐闻县',
            did: 440825
          },
          {
            name: '廉江市',
            did: 440881
          },
          {
            name: '雷州市',
            did: 440882
          },
          {
            name: '吴川市',
            did: 440883
          }
        ],
        name: '湛江市',
        cid: 440800
      },
      {
        areaList: [
          {
            name: '市辖区',
            did: 440901
          },
          {
            name: '茂南区',
            did: 440902
          },
          {
            name: '茂港区',
            did: 440903
          },
          {
            name: '电白县',
            did: 440923
          },
          {
            name: '高州市',
            did: 440981
          },
          {
            name: '化州市',
            did: 440982
          },
          {
            name: '信宜市',
            did: 440983
          }
        ],
        name: '茂名市',
        cid: 440900
      },
      {
        areaList: [
          {
            name: '市辖区',
            did: 441201
          },
          {
            name: '端州区',
            did: 441202
          },
          {
            name: '鼎湖区',
            did: 441203
          },
          {
            name: '广宁县',
            did: 441223
          },
          {
            name: '怀集县',
            did: 441224
          },
          {
            name: '封开县',
            did: 441225
          },
          {
            name: '德庆县',
            did: 441226
          },
          {
            name: '高要市',
            did: 441283
          },
          {
            name: '四会市',
            did: 441284
          }
        ],
        name: '肇庆市',
        cid: 441200
      },
      {
        areaList: [
          {
            name: '市辖区',
            did: 441301
          },
          {
            name: '惠城区',
            did: 441302
          },
          {
            name: '惠阳区',
            did: 441303
          },
          {
            name: '博罗县',
            did: 441322
          },
          {
            name: '惠东县',
            did: 441323
          },
          {
            name: '龙门县',
            did: 441324
          }
        ],
        name: '惠州市',
        cid: 441300
      },
      {
        areaList: [
          {
            name: '市辖区',
            did: 441401
          },
          {
            name: '梅江区',
            did: 441402
          },
          {
            name: '梅县',
            did: 441421
          },
          {
            name: '大埔县',
            did: 441422
          },
          {
            name: '丰顺县',
            did: 441423
          },
          {
            name: '五华县',
            did: 441424
          },
          {
            name: '平远县',
            did: 441426
          },
          {
            name: '蕉岭县',
            did: 441427
          },
          {
            name: '兴宁市',
            did: 441481
          }
        ],
        name: '梅州市',
        cid: 441400
      },
      {
        areaList: [
          {
            name: '市辖区',
            did: 441501
          },
          {
            name: '城区',
            did: 441502
          },
          {
            name: '海丰县',
            did: 441521
          },
          {
            name: '陆河县',
            did: 441523
          },
          {
            name: '陆丰市',
            did: 441581
          }
        ],
        name: '汕尾市',
        cid: 441500
      },
      {
        areaList: [
          {
            name: '市辖区',
            did: 441601
          },
          {
            name: '源城区',
            did: 441602
          },
          {
            name: '紫金县',
            did: 441621
          },
          {
            name: '龙川县',
            did: 441622
          },
          {
            name: '连平县',
            did: 441623
          },
          {
            name: '和平县',
            did: 441624
          },
          {
            name: '东源县',
            did: 441625
          }
        ],
        name: '河源市',
        cid: 441600
      },
      {
        areaList: [
          {
            name: '市辖区',
            did: 441701
          },
          {
            name: '江城区',
            did: 441702
          },
          {
            name: '阳西县',
            did: 441721
          },
          {
            name: '阳东县',
            did: 441723
          },
          {
            name: '阳春市',
            did: 441781
          }
        ],
        name: '阳江市',
        cid: 441700
      },
      {
        areaList: [
          {
            name: '市辖区',
            did: 441801
          },
          {
            name: '清城区',
            did: 441802
          },
          {
            name: '清新区',
            did: 441803
          },
          {
            name: '佛冈县',
            did: 441821
          },
          {
            name: '阳山县',
            did: 441823
          },
          {
            name: '连山壮族瑶族自治县',
            did: 441825
          },
          {
            name: '连南瑶族自治县',
            did: 441826
          },
          {
            name: '英德市',
            did: 441881
          },
          {
            name: '连州市',
            did: 441882
          }
        ],
        name: '清远市',
        cid: 441800
      },
      {
        areaList: [
          {
            name: '莞城区',
            did: 441901
          },
          {
            name: '东城区',
            did: 441902
          },
          {
            name: '南城区',
            did: 441903
          },
          {
            name: '万江区',
            did: 441904
          }
        ],
        name: '东莞市',
        cid: 441900
      },
      {
        areaList: [
          {
            name: '中山市',
            did: 442000
          }
        ],
        name: '中山市',
        cid: 442000
      },
      {
        areaList: [
          {
            name: '市辖区',
            did: 445101
          },
          {
            name: '湘桥区',
            did: 445102
          },
          {
            name: '潮安区',
            did: 445103
          },
          {
            name: '饶平县',
            did: 445122
          }
        ],
        name: '潮州市',
        cid: 445100
      },
      {
        areaList: [
          {
            name: '市辖区',
            did: 445201
          },
          {
            name: '榕城区',
            did: 445202
          },
          {
            name: '揭东区',
            did: 445203
          },
          {
            name: '揭西县',
            did: 445222
          },
          {
            name: '惠来县',
            did: 445224
          },
          {
            name: '普宁市',
            did: 445281
          }
        ],
        name: '揭阳市',
        cid: 445200
      },
      {
        areaList: [
          {
            name: '市辖区',
            did: 445301
          },
          {
            name: '云城区',
            did: 445302
          },
          {
            name: '新兴县',
            did: 445321
          },
          {
            name: '郁南县',
            did: 445322
          },
          {
            name: '云安县',
            did: 445323
          },
          {
            name: '罗定市',
            did: 445381
          }
        ],
        name: '云浮市',
        cid: 445300
      }
    ]
  },
  {
    pid: 450000,
    name: '广西壮族自治区',
    cityList: [
      {
        areaList: [
          {
            name: '市辖区',
            did: 450101
          },
          {
            name: '兴宁区',
            did: 450102
          },
          {
            name: '青秀区',
            did: 450103
          },
          {
            name: '江南区',
            did: 450105
          },
          {
            name: '西乡塘区',
            did: 450107
          },
          {
            name: '良庆区',
            did: 450108
          },
          {
            name: '邕宁区',
            did: 450109
          },
          {
            name: '武鸣县',
            did: 450122
          },
          {
            name: '隆安县',
            did: 450123
          },
          {
            name: '马山县',
            did: 450124
          },
          {
            name: '上林县',
            did: 450125
          },
          {
            name: '宾阳县',
            did: 450126
          },
          {
            name: '横县',
            did: 450127
          }
        ],
        name: '南宁市',
        cid: 450100
      },
      {
        areaList: [
          {
            name: '市辖区',
            did: 450201
          },
          {
            name: '城中区',
            did: 450202
          },
          {
            name: '鱼峰区',
            did: 450203
          },
          {
            name: '柳南区',
            did: 450204
          },
          {
            name: '柳北区',
            did: 450205
          },
          {
            name: '柳江县',
            did: 450221
          },
          {
            name: '柳城县',
            did: 450222
          },
          {
            name: '鹿寨县',
            did: 450223
          },
          {
            name: '融安县',
            did: 450224
          },
          {
            name: '融水苗族自治县',
            did: 450225
          },
          {
            name: '三江侗族自治县',
            did: 450226
          }
        ],
        name: '柳州市',
        cid: 450200
      },
      {
        areaList: [
          {
            name: '市辖区',
            did: 450301
          },
          {
            name: '秀峰区',
            did: 450302
          },
          {
            name: '叠彩区',
            did: 450303
          },
          {
            name: '象山区',
            did: 450304
          },
          {
            name: '七星区',
            did: 450305
          },
          {
            name: '雁山区',
            did: 450311
          },
          {
            name: '临桂区',
            did: 450312
          },
          {
            name: '阳朔县',
            did: 450321
          },
          {
            name: '灵川县',
            did: 450323
          },
          {
            name: '全州县',
            did: 450324
          },
          {
            name: '兴安县',
            did: 450325
          },
          {
            name: '永福县',
            did: 450326
          },
          {
            name: '灌阳县',
            did: 450327
          },
          {
            name: '龙胜各族自治县',
            did: 450328
          },
          {
            name: '资源县',
            did: 450329
          },
          {
            name: '平乐县',
            did: 450330
          },
          {
            name: '荔浦县',
            did: 450331
          },
          {
            name: '恭城瑶族自治县',
            did: 450332
          }
        ],
        name: '桂林市',
        cid: 450300
      },
      {
        areaList: [
          {
            name: '市辖区',
            did: 450401
          },
          {
            name: '万秀区',
            did: 450403
          },
          {
            name: '长洲区',
            did: 450405
          },
          {
            name: '龙圩区',
            did: 450406
          },
          {
            name: '苍梧县',
            did: 450421
          },
          {
            name: '藤县',
            did: 450422
          },
          {
            name: '蒙山县',
            did: 450423
          },
          {
            name: '岑溪市',
            did: 450481
          }
        ],
        name: '梧州市',
        cid: 450400
      },
      {
        areaList: [
          {
            name: '市辖区',
            did: 450501
          },
          {
            name: '海城区',
            did: 450502
          },
          {
            name: '银海区',
            did: 450503
          },
          {
            name: '铁山港区',
            did: 450512
          },
          {
            name: '合浦县',
            did: 450521
          }
        ],
        name: '北海市',
        cid: 450500
      },
      {
        areaList: [
          {
            name: '市辖区',
            did: 450601
          },
          {
            name: '港口区',
            did: 450602
          },
          {
            name: '防城区',
            did: 450603
          },
          {
            name: '上思县',
            did: 450621
          },
          {
            name: '东兴市',
            did: 450681
          }
        ],
        name: '防城港市',
        cid: 450600
      },
      {
        areaList: [
          {
            name: '市辖区',
            did: 450701
          },
          {
            name: '钦南区',
            did: 450702
          },
          {
            name: '钦北区',
            did: 450703
          },
          {
            name: '灵山县',
            did: 450721
          },
          {
            name: '浦北县',
            did: 450722
          }
        ],
        name: '钦州市',
        cid: 450700
      },
      {
        areaList: [
          {
            name: '市辖区',
            did: 450801
          },
          {
            name: '港北区',
            did: 450802
          },
          {
            name: '港南区',
            did: 450803
          },
          {
            name: '覃塘区',
            did: 450804
          },
          {
            name: '平南县',
            did: 450821
          },
          {
            name: '桂平市',
            did: 450881
          }
        ],
        name: '贵港市',
        cid: 450800
      },
      {
        areaList: [
          {
            name: '市辖区',
            did: 450901
          },
          {
            name: '玉州区',
            did: 450902
          },
          {
            name: '福绵区',
            did: 450903
          },
          {
            name: '容县',
            did: 450921
          },
          {
            name: '陆川县',
            did: 450922
          },
          {
            name: '博白县',
            did: 450923
          },
          {
            name: '兴业县',
            did: 450924
          },
          {
            name: '北流市',
            did: 450981
          }
        ],
        name: '玉林市',
        cid: 450900
      },
      {
        areaList: [
          {
            name: '市辖区',
            did: 451001
          },
          {
            name: '右江区',
            did: 451002
          },
          {
            name: '田阳县',
            did: 451021
          },
          {
            name: '田东县',
            did: 451022
          },
          {
            name: '平果县',
            did: 451023
          },
          {
            name: '德保县',
            did: 451024
          },
          {
            name: '靖西县',
            did: 451025
          },
          {
            name: '那坡县',
            did: 451026
          },
          {
            name: '凌云县',
            did: 451027
          },
          {
            name: '乐业县',
            did: 451028
          },
          {
            name: '田林县',
            did: 451029
          },
          {
            name: '西林县',
            did: 451030
          },
          {
            name: '隆林各族自治县',
            did: 451031
          }
        ],
        name: '百色市',
        cid: 451000
      },
      {
        areaList: [
          {
            name: '市辖区',
            did: 451101
          },
          {
            name: '八步区',
            did: 451102
          },
          {
            name: '昭平县',
            did: 451121
          },
          {
            name: '钟山县',
            did: 451122
          },
          {
            name: '富川瑶族自治县',
            did: 451123
          }
        ],
        name: '贺州市',
        cid: 451100
      },
      {
        areaList: [
          {
            name: '市辖区',
            did: 451201
          },
          {
            name: '金城江区',
            did: 451202
          },
          {
            name: '南丹县',
            did: 451221
          },
          {
            name: '天峨县',
            did: 451222
          },
          {
            name: '凤山县',
            did: 451223
          },
          {
            name: '东兰县',
            did: 451224
          },
          {
            name: '罗城仫佬族自治县',
            did: 451225
          },
          {
            name: '环江毛南族自治县',
            did: 451226
          },
          {
            name: '巴马瑶族自治县',
            did: 451227
          },
          {
            name: '都安瑶族自治县',
            did: 451228
          },
          {
            name: '大化瑶族自治县',
            did: 451229
          },
          {
            name: '宜州市',
            did: 451281
          }
        ],
        name: '河池市',
        cid: 451200
      },
      {
        areaList: [
          {
            name: '市辖区',
            did: 451301
          },
          {
            name: '兴宾区',
            did: 451302
          },
          {
            name: '忻城县',
            did: 451321
          },
          {
            name: '象州县',
            did: 451322
          },
          {
            name: '武宣县',
            did: 451323
          },
          {
            name: '金秀瑶族自治县',
            did: 451324
          },
          {
            name: '合山市',
            did: 451381
          }
        ],
        name: '来宾市',
        cid: 451300
      },
      {
        areaList: [
          {
            name: '市辖区',
            did: 451401
          },
          {
            name: '江州区',
            did: 451402
          },
          {
            name: '扶绥县',
            did: 451421
          },
          {
            name: '宁明县',
            did: 451422
          },
          {
            name: '龙州县',
            did: 451423
          },
          {
            name: '大新县',
            did: 451424
          },
          {
            name: '天等县',
            did: 451425
          },
          {
            name: '凭祥市',
            did: 451481
          }
        ],
        name: '崇左市',
        cid: 451400
      }
    ]
  },
  {
    pid: 460000,
    name: '海南省',
    cityList: [
      {
        areaList: [
          {
            name: '市辖区',
            did: 460101
          },
          {
            name: '秀英区',
            did: 460105
          },
          {
            name: '龙华区',
            did: 460106
          },
          {
            name: '琼山区',
            did: 460107
          },
          {
            name: '美兰区',
            did: 460108
          }
        ],
        name: '海口市',
        cid: 460100
      },
      {
        areaList: [
          {
            name: '市辖区',
            did: 460201
          }
        ],
        name: '三亚市',
        cid: 460200
      },
      {
        areaList: [
          {
            name: '西沙群岛',
            did: 460321
          },
          {
            name: '南沙群岛',
            did: 460322
          },
          {
            name: '中沙群岛的岛礁及其海域',
            did: 460323
          }
        ],
        name: '三沙市',
        cid: 460300
      },
      {
        areaList: [
          {
            name: '五指山市',
            did: 469001
          },
          {
            name: '琼海市',
            did: 469002
          },
          {
            name: '儋州市',
            did: 469003
          },
          {
            name: '文昌市',
            did: 469005
          },
          {
            name: '万宁市',
            did: 469006
          },
          {
            name: '东方市',
            did: 469007
          },
          {
            name: '定安县',
            did: 469021
          },
          {
            name: '屯昌县',
            did: 469022
          },
          {
            name: '澄迈县',
            did: 469023
          },
          {
            name: '临高县',
            did: 469024
          },
          {
            name: '白沙黎族自治县',
            did: 469025
          },
          {
            name: '昌江黎族自治县',
            did: 469026
          },
          {
            name: '乐东黎族自治县',
            did: 469027
          },
          {
            name: '陵水黎族自治县',
            did: 469028
          },
          {
            name: '保亭黎族苗族自治县',
            did: 469029
          },
          {
            name: '琼中黎族苗族自治县',
            did: 469030
          }
        ],
        name: '省直辖县级行政区划',
        cid: 469000
      }
    ]
  },
  {
    pid: 500000,
    name: '重庆市',
    cityList: [
      {
        areaList: [
          {
            name: '万州区',
            did: 500101
          },
          {
            name: '涪陵区',
            did: 500102
          },
          {
            name: '渝中区',
            did: 500103
          },
          {
            name: '大渡口区',
            did: 500104
          },
          {
            name: '江北区',
            did: 500105
          },
          {
            name: '沙坪坝区',
            did: 500106
          },
          {
            name: '九龙坡区',
            did: 500107
          },
          {
            name: '南岸区',
            did: 500108
          },
          {
            name: '北碚区',
            did: 500109
          },
          {
            name: '綦江区',
            did: 500110
          },
          {
            name: '大足区',
            did: 500111
          },
          {
            name: '渝北区',
            did: 500112
          },
          {
            name: '巴南区',
            did: 500113
          },
          {
            name: '黔江区',
            did: 500114
          },
          {
            name: '长寿区',
            did: 500115
          },
          {
            name: '江津区',
            did: 500116
          },
          {
            name: '合川区',
            did: 500117
          },
          {
            name: '永川区',
            did: 500118
          },
          {
            name: '南川区',
            did: 500119
          },
          {
            name: '潼南县',
            did: 500223
          },
          {
            name: '铜梁县',
            did: 500224
          },
          {
            name: '荣昌县',
            did: 500226
          },
          {
            name: '璧山县',
            did: 500227
          },
          {
            name: '梁平县',
            did: 500228
          },
          {
            name: '城口县',
            did: 500229
          },
          {
            name: '丰都县',
            did: 500230
          },
          {
            name: '垫江县',
            did: 500231
          },
          {
            name: '武隆县',
            did: 500232
          },
          {
            name: '忠县',
            did: 500233
          },
          {
            name: '开县',
            did: 500234
          },
          {
            name: '云阳县',
            did: 500235
          },
          {
            name: '奉节县',
            did: 500236
          },
          {
            name: '巫山县',
            did: 500237
          },
          {
            name: '巫溪县',
            did: 500238
          },
          {
            name: '石柱土家族自治县',
            did: 500240
          },
          {
            name: '秀山土家族苗族自治县',
            did: 500241
          },
          {
            name: '酉阳土家族苗族自治县',
            did: 500242
          },
          {
            name: '彭水苗族土家族自治县',
            did: 500243
          }
        ],
        name: '重庆市',
        cid: 500000
      }
    ]
  },
  {
    pid: 510000,
    name: '四川省',
    cityList: [
      {
        areaList: [
          {
            name: '市辖区',
            did: 510101
          },
          {
            name: '锦江区',
            did: 510104
          },
          {
            name: '青羊区',
            did: 510105
          },
          {
            name: '金牛区',
            did: 510106
          },
          {
            name: '武侯区',
            did: 510107
          },
          {
            name: '成华区',
            did: 510108
          },
          {
            name: '龙泉驿区',
            did: 510112
          },
          {
            name: '青白江区',
            did: 510113
          },
          {
            name: '新都区',
            did: 510114
          },
          {
            name: '温江区',
            did: 510115
          },
          {
            name: '金堂县',
            did: 510121
          },
          {
            name: '双流县',
            did: 510122
          },
          {
            name: '郫县',
            did: 510124
          },
          {
            name: '大邑县',
            did: 510129
          },
          {
            name: '蒲江县',
            did: 510131
          },
          {
            name: '新津县',
            did: 510132
          },
          {
            name: '都江堰市',
            did: 510181
          },
          {
            name: '彭州市',
            did: 510182
          },
          {
            name: '邛崃市',
            did: 510183
          },
          {
            name: '崇州市',
            did: 510184
          }
        ],
        name: '成都市',
        cid: 510100
      },
      {
        areaList: [
          {
            name: '市辖区',
            did: 510301
          },
          {
            name: '自流井区',
            did: 510302
          },
          {
            name: '贡井区',
            did: 510303
          },
          {
            name: '大安区',
            did: 510304
          },
          {
            name: '沿滩区',
            did: 510311
          },
          {
            name: '荣县',
            did: 510321
          },
          {
            name: '富顺县',
            did: 510322
          }
        ],
        name: '自贡市',
        cid: 510300
      },
      {
        areaList: [
          {
            name: '市辖区',
            did: 510401
          },
          {
            name: '东区',
            did: 510402
          },
          {
            name: '西区',
            did: 510403
          },
          {
            name: '仁和区',
            did: 510411
          },
          {
            name: '米易县',
            did: 510421
          },
          {
            name: '盐边县',
            did: 510422
          }
        ],
        name: '攀枝花市',
        cid: 510400
      },
      {
        areaList: [
          {
            name: '市辖区',
            did: 510501
          },
          {
            name: '江阳区',
            did: 510502
          },
          {
            name: '纳溪区',
            did: 510503
          },
          {
            name: '龙马潭区',
            did: 510504
          },
          {
            name: '泸县',
            did: 510521
          },
          {
            name: '合江县',
            did: 510522
          },
          {
            name: '叙永县',
            did: 510524
          },
          {
            name: '古蔺县',
            did: 510525
          }
        ],
        name: '泸州市',
        cid: 510500
      },
      {
        areaList: [
          {
            name: '市辖区',
            did: 510601
          },
          {
            name: '旌阳区',
            did: 510603
          },
          {
            name: '中江县',
            did: 510623
          },
          {
            name: '罗江县',
            did: 510626
          },
          {
            name: '广汉市',
            did: 510681
          },
          {
            name: '什邡市',
            did: 510682
          },
          {
            name: '绵竹市',
            did: 510683
          }
        ],
        name: '德阳市',
        cid: 510600
      },
      {
        areaList: [
          {
            name: '市辖区',
            did: 510701
          },
          {
            name: '涪城区',
            did: 510703
          },
          {
            name: '游仙区',
            did: 510704
          },
          {
            name: '三台县',
            did: 510722
          },
          {
            name: '盐亭县',
            did: 510723
          },
          {
            name: '安县',
            did: 510724
          },
          {
            name: '梓潼县',
            did: 510725
          },
          {
            name: '北川羌族自治县',
            did: 510726
          },
          {
            name: '平武县',
            did: 510727
          },
          {
            name: '江油市',
            did: 510781
          }
        ],
        name: '绵阳市',
        cid: 510700
      },
      {
        areaList: [
          {
            name: '市辖区',
            did: 510801
          },
          {
            name: '利州区',
            did: 510802
          },
          {
            name: '元坝区',
            did: 510811
          },
          {
            name: '朝天区',
            did: 510812
          },
          {
            name: '旺苍县',
            did: 510821
          },
          {
            name: '青川县',
            did: 510822
          },
          {
            name: '剑阁县',
            did: 510823
          },
          {
            name: '苍溪县',
            did: 510824
          }
        ],
        name: '广元市',
        cid: 510800
      },
      {
        areaList: [
          {
            name: '市辖区',
            did: 510901
          },
          {
            name: '船山区',
            did: 510903
          },
          {
            name: '安居区',
            did: 510904
          },
          {
            name: '蓬溪县',
            did: 510921
          },
          {
            name: '射洪县',
            did: 510922
          },
          {
            name: '大英县',
            did: 510923
          }
        ],
        name: '遂宁市',
        cid: 510900
      },
      {
        areaList: [
          {
            name: '市辖区',
            did: 511001
          },
          {
            name: '市中区',
            did: 511002
          },
          {
            name: '东兴区',
            did: 511011
          },
          {
            name: '威远县',
            did: 511024
          },
          {
            name: '资中县',
            did: 511025
          },
          {
            name: '隆昌县',
            did: 511028
          }
        ],
        name: '内江市',
        cid: 511000
      },
      {
        areaList: [
          {
            name: '市辖区',
            did: 511101
          },
          {
            name: '市中区',
            did: 511102
          },
          {
            name: '沙湾区',
            did: 511111
          },
          {
            name: '五通桥区',
            did: 511112
          },
          {
            name: '金口河区',
            did: 511113
          },
          {
            name: '犍为县',
            did: 511123
          },
          {
            name: '井研县',
            did: 511124
          },
          {
            name: '夹江县',
            did: 511126
          },
          {
            name: '沐川县',
            did: 511129
          },
          {
            name: '峨边彝族自治县',
            did: 511132
          },
          {
            name: '马边彝族自治县',
            did: 511133
          },
          {
            name: '峨眉山市',
            did: 511181
          }
        ],
        name: '乐山市',
        cid: 511100
      },
      {
        areaList: [
          {
            name: '市辖区',
            did: 511301
          },
          {
            name: '顺庆区',
            did: 511302
          },
          {
            name: '高坪区',
            did: 511303
          },
          {
            name: '嘉陵区',
            did: 511304
          },
          {
            name: '南部县',
            did: 511321
          },
          {
            name: '营山县',
            did: 511322
          },
          {
            name: '蓬安县',
            did: 511323
          },
          {
            name: '仪陇县',
            did: 511324
          },
          {
            name: '西充县',
            did: 511325
          },
          {
            name: '阆中市',
            did: 511381
          }
        ],
        name: '南充市',
        cid: 511300
      },
      {
        areaList: [
          {
            name: '市辖区',
            did: 511401
          },
          {
            name: '东坡区',
            did: 511402
          },
          {
            name: '仁寿县',
            did: 511421
          },
          {
            name: '彭山县',
            did: 511422
          },
          {
            name: '洪雅县',
            did: 511423
          },
          {
            name: '丹棱县',
            did: 511424
          },
          {
            name: '青神县',
            did: 511425
          }
        ],
        name: '眉山市',
        cid: 511400
      },
      {
        areaList: [
          {
            name: '市辖区',
            did: 511501
          },
          {
            name: '翠屏区',
            did: 511502
          },
          {
            name: '南溪区',
            did: 511503
          },
          {
            name: '宜宾县',
            did: 511521
          },
          {
            name: '江安县',
            did: 511523
          },
          {
            name: '长宁县',
            did: 511524
          },
          {
            name: '高县',
            did: 511525
          },
          {
            name: '珙县',
            did: 511526
          },
          {
            name: '筠连县',
            did: 511527
          },
          {
            name: '兴文县',
            did: 511528
          },
          {
            name: '屏山县',
            did: 511529
          }
        ],
        name: '宜宾市',
        cid: 511500
      },
      {
        areaList: [
          {
            name: '市辖区',
            did: 511601
          },
          {
            name: '广安区',
            did: 511602
          },
          {
            name: '前锋区',
            did: 511603
          },
          {
            name: '岳池县',
            did: 511621
          },
          {
            name: '武胜县',
            did: 511622
          },
          {
            name: '邻水县',
            did: 511623
          },
          {
            name: '华蓥市',
            did: 511681
          }
        ],
        name: '广安市',
        cid: 511600
      },
      {
        areaList: [
          {
            name: '市辖区',
            did: 511701
          },
          {
            name: '通川区',
            did: 511702
          },
          {
            name: '达川区',
            did: 511703
          },
          {
            name: '宣汉县',
            did: 511722
          },
          {
            name: '开江县',
            did: 511723
          },
          {
            name: '大竹县',
            did: 511724
          },
          {
            name: '渠县',
            did: 511725
          },
          {
            name: '万源市',
            did: 511781
          }
        ],
        name: '达州市',
        cid: 511700
      },
      {
        areaList: [
          {
            name: '市辖区',
            did: 511801
          },
          {
            name: '雨城区',
            did: 511802
          },
          {
            name: '名山区',
            did: 511803
          },
          {
            name: '荥经县',
            did: 511822
          },
          {
            name: '汉源县',
            did: 511823
          },
          {
            name: '石棉县',
            did: 511824
          },
          {
            name: '天全县',
            did: 511825
          },
          {
            name: '芦山县',
            did: 511826
          },
          {
            name: '宝兴县',
            did: 511827
          }
        ],
        name: '雅安市',
        cid: 511800
      },
      {
        areaList: [
          {
            name: '市辖区',
            did: 511901
          },
          {
            name: '巴州区',
            did: 511902
          },
          {
            name: '恩阳区',
            did: 511903
          },
          {
            name: '通江县',
            did: 511921
          },
          {
            name: '南江县',
            did: 511922
          },
          {
            name: '平昌县',
            did: 511923
          }
        ],
        name: '巴中市',
        cid: 511900
      },
      {
        areaList: [
          {
            name: '市辖区',
            did: 512001
          },
          {
            name: '雁江区',
            did: 512002
          },
          {
            name: '安岳县',
            did: 512021
          },
          {
            name: '乐至县',
            did: 512022
          },
          {
            name: '简阳市',
            did: 512081
          }
        ],
        name: '资阳市',
        cid: 512000
      },
      {
        areaList: [
          {
            name: '汶川县',
            did: 513221
          },
          {
            name: '理县',
            did: 513222
          },
          {
            name: '茂县',
            did: 513223
          },
          {
            name: '松潘县',
            did: 513224
          },
          {
            name: '九寨沟县',
            did: 513225
          },
          {
            name: '金川县',
            did: 513226
          },
          {
            name: '小金县',
            did: 513227
          },
          {
            name: '黑水县',
            did: 513228
          },
          {
            name: '马尔康县',
            did: 513229
          },
          {
            name: '壤塘县',
            did: 513230
          },
          {
            name: '阿坝县',
            did: 513231
          },
          {
            name: '若尔盖县',
            did: 513232
          },
          {
            name: '红原县',
            did: 513233
          }
        ],
        name: '阿坝藏族羌族自治州',
        cid: 513200
      },
      {
        areaList: [
          {
            name: '康定县',
            did: 513321
          },
          {
            name: '泸定县',
            did: 513322
          },
          {
            name: '丹巴县',
            did: 513323
          },
          {
            name: '九龙县',
            did: 513324
          },
          {
            name: '雅江县',
            did: 513325
          },
          {
            name: '道孚县',
            did: 513326
          },
          {
            name: '炉霍县',
            did: 513327
          },
          {
            name: '甘孜县',
            did: 513328
          },
          {
            name: '新龙县',
            did: 513329
          },
          {
            name: '德格县',
            did: 513330
          },
          {
            name: '白玉县',
            did: 513331
          },
          {
            name: '石渠县',
            did: 513332
          },
          {
            name: '色达县',
            did: 513333
          },
          {
            name: '理塘县',
            did: 513334
          },
          {
            name: '巴塘县',
            did: 513335
          },
          {
            name: '乡城县',
            did: 513336
          },
          {
            name: '稻城县',
            did: 513337
          },
          {
            name: '得荣县',
            did: 513338
          }
        ],
        name: '甘孜藏族自治州',
        cid: 513300
      },
      {
        areaList: [
          {
            name: '西昌市',
            did: 513401
          },
          {
            name: '木里藏族自治县',
            did: 513422
          },
          {
            name: '盐源县',
            did: 513423
          },
          {
            name: '德昌县',
            did: 513424
          },
          {
            name: '会理县',
            did: 513425
          },
          {
            name: '会东县',
            did: 513426
          },
          {
            name: '宁南县',
            did: 513427
          },
          {
            name: '普格县',
            did: 513428
          },
          {
            name: '布拖县',
            did: 513429
          },
          {
            name: '金阳县',
            did: 513430
          },
          {
            name: '昭觉县',
            did: 513431
          },
          {
            name: '喜德县',
            did: 513432
          },
          {
            name: '冕宁县',
            did: 513433
          },
          {
            name: '越西县',
            did: 513434
          },
          {
            name: '甘洛县',
            did: 513435
          },
          {
            name: '美姑县',
            did: 513436
          },
          {
            name: '雷波县',
            did: 513437
          }
        ],
        name: '凉山彝族自治州',
        cid: 513400
      }
    ]
  },
  {
    pid: 520000,
    name: '贵州省',
    cityList: [
      {
        areaList: [
          {
            name: '市辖区',
            did: 520101
          },
          {
            name: '南明区',
            did: 520102
          },
          {
            name: '云岩区',
            did: 520103
          },
          {
            name: '花溪区',
            did: 520111
          },
          {
            name: '乌当区',
            did: 520112
          },
          {
            name: '白云区',
            did: 520113
          },
          {
            name: '观山湖区',
            did: 520115
          },
          {
            name: '开阳县',
            did: 520121
          },
          {
            name: '息烽县',
            did: 520122
          },
          {
            name: '修文县',
            did: 520123
          },
          {
            name: '清镇市',
            did: 520181
          }
        ],
        name: '贵阳市',
        cid: 520100
      },
      {
        areaList: [
          {
            name: '钟山区',
            did: 520201
          },
          {
            name: '六枝特区',
            did: 520203
          },
          {
            name: '水城县',
            did: 520221
          },
          {
            name: '盘县',
            did: 520222
          }
        ],
        name: '六盘水市',
        cid: 520200
      },
      {
        areaList: [
          {
            name: '市辖区',
            did: 520301
          },
          {
            name: '红花岗区',
            did: 520302
          },
          {
            name: '汇川区',
            did: 520303
          },
          {
            name: '遵义县',
            did: 520321
          },
          {
            name: '桐梓县',
            did: 520322
          },
          {
            name: '绥阳县',
            did: 520323
          },
          {
            name: '正安县',
            did: 520324
          },
          {
            name: '道真仡佬族苗族自治县',
            did: 520325
          },
          {
            name: '务川仡佬族苗族自治县',
            did: 520326
          },
          {
            name: '凤冈县',
            did: 520327
          },
          {
            name: '湄潭县',
            did: 520328
          },
          {
            name: '余庆县',
            did: 520329
          },
          {
            name: '习水县',
            did: 520330
          },
          {
            name: '赤水市',
            did: 520381
          },
          {
            name: '仁怀市',
            did: 520382
          }
        ],
        name: '遵义市',
        cid: 520300
      },
      {
        areaList: [
          {
            name: '市辖区',
            did: 520401
          },
          {
            name: '西秀区',
            did: 520402
          },
          {
            name: '平坝县',
            did: 520421
          },
          {
            name: '普定县',
            did: 520422
          },
          {
            name: '镇宁布依族苗族自治县',
            did: 520423
          },
          {
            name: '关岭布依族苗族自治县',
            did: 520424
          },
          {
            name: '紫云苗族布依族自治县',
            did: 520425
          }
        ],
        name: '安顺市',
        cid: 520400
      },
      {
        areaList: [
          {
            name: '市辖区',
            did: 520501
          },
          {
            name: '七星关区',
            did: 520502
          },
          {
            name: '大方县',
            did: 520521
          },
          {
            name: '黔西县',
            did: 520522
          },
          {
            name: '金沙县',
            did: 520523
          },
          {
            name: '织金县',
            did: 520524
          },
          {
            name: '纳雍县',
            did: 520525
          },
          {
            name: '威宁彝族回族苗族自治县',
            did: 520526
          },
          {
            name: '赫章县',
            did: 520527
          }
        ],
        name: '毕节市',
        cid: 520500
      },
      {
        areaList: [
          {
            name: '市辖区',
            did: 520601
          },
          {
            name: '碧江区',
            did: 520602
          },
          {
            name: '万山区',
            did: 520603
          },
          {
            name: '江口县',
            did: 520621
          },
          {
            name: '玉屏侗族自治县',
            did: 520622
          },
          {
            name: '石阡县',
            did: 520623
          },
          {
            name: '思南县',
            did: 520624
          },
          {
            name: '印江土家族苗族自治县',
            did: 520625
          },
          {
            name: '德江县',
            did: 520626
          },
          {
            name: '沿河土家族自治县',
            did: 520627
          },
          {
            name: '松桃苗族自治县',
            did: 520628
          }
        ],
        name: '铜仁市',
        cid: 520600
      },
      {
        areaList: [
          {
            name: '兴义市',
            did: 522301
          },
          {
            name: '兴仁县',
            did: 522322
          },
          {
            name: '普安县',
            did: 522323
          },
          {
            name: '晴隆县',
            did: 522324
          },
          {
            name: '贞丰县',
            did: 522325
          },
          {
            name: '望谟县',
            did: 522326
          },
          {
            name: '册亨县',
            did: 522327
          },
          {
            name: '安龙县',
            did: 522328
          }
        ],
        name: '黔西南布依族苗族自治州',
        cid: 522300
      },
      {
        areaList: [
          {
            name: '凯里市',
            did: 522601
          },
          {
            name: '黄平县',
            did: 522622
          },
          {
            name: '施秉县',
            did: 522623
          },
          {
            name: '三穗县',
            did: 522624
          },
          {
            name: '镇远县',
            did: 522625
          },
          {
            name: '岑巩县',
            did: 522626
          },
          {
            name: '天柱县',
            did: 522627
          },
          {
            name: '锦屏县',
            did: 522628
          },
          {
            name: '剑河县',
            did: 522629
          },
          {
            name: '台江县',
            did: 522630
          },
          {
            name: '黎平县',
            did: 522631
          },
          {
            name: '榕江县',
            did: 522632
          },
          {
            name: '从江县',
            did: 522633
          },
          {
            name: '雷山县',
            did: 522634
          },
          {
            name: '麻江县',
            did: 522635
          },
          {
            name: '丹寨县',
            did: 522636
          }
        ],
        name: '黔东南苗族侗族自治州',
        cid: 522600
      },
      {
        areaList: [
          {
            name: '都匀市',
            did: 522701
          },
          {
            name: '福泉市',
            did: 522702
          },
          {
            name: '荔波县',
            did: 522722
          },
          {
            name: '贵定县',
            did: 522723
          },
          {
            name: '瓮安县',
            did: 522725
          },
          {
            name: '独山县',
            did: 522726
          },
          {
            name: '平塘县',
            did: 522727
          },
          {
            name: '罗甸县',
            did: 522728
          },
          {
            name: '长顺县',
            did: 522729
          },
          {
            name: '龙里县',
            did: 522730
          },
          {
            name: '惠水县',
            did: 522731
          },
          {
            name: '三都水族自治县',
            did: 522732
          }
        ],
        name: '黔南布依族苗族自治州',
        cid: 522700
      }
    ]
  },
  {
    pid: 530000,
    name: '云南省',
    cityList: [
      {
        areaList: [
          {
            name: '市辖区',
            did: 530101
          },
          {
            name: '五华区',
            did: 530102
          },
          {
            name: '盘龙区',
            did: 530103
          },
          {
            name: '官渡区',
            did: 530111
          },
          {
            name: '西山区',
            did: 530112
          },
          {
            name: '东川区',
            did: 530113
          },
          {
            name: '呈贡区',
            did: 530114
          },
          {
            name: '晋宁县',
            did: 530122
          },
          {
            name: '富民县',
            did: 530124
          },
          {
            name: '宜良县',
            did: 530125
          },
          {
            name: '石林彝族自治县',
            did: 530126
          },
          {
            name: '嵩明县',
            did: 530127
          },
          {
            name: '禄劝彝族苗族自治县',
            did: 530128
          },
          {
            name: '寻甸回族彝族自治县',
            did: 530129
          },
          {
            name: '安宁市',
            did: 530181
          }
        ],
        name: '昆明市',
        cid: 530100
      },
      {
        areaList: [
          {
            name: '市辖区',
            did: 530301
          },
          {
            name: '麒麟区',
            did: 530302
          },
          {
            name: '马龙县',
            did: 530321
          },
          {
            name: '陆良县',
            did: 530322
          },
          {
            name: '师宗县',
            did: 530323
          },
          {
            name: '罗平县',
            did: 530324
          },
          {
            name: '富源县',
            did: 530325
          },
          {
            name: '会泽县',
            did: 530326
          },
          {
            name: '沾益县',
            did: 530328
          },
          {
            name: '宣威市',
            did: 530381
          }
        ],
        name: '曲靖市',
        cid: 530300
      },
      {
        areaList: [
          {
            name: '市辖区',
            did: 530401
          },
          {
            name: '红塔区',
            did: 530402
          },
          {
            name: '江川县',
            did: 530421
          },
          {
            name: '澄江县',
            did: 530422
          },
          {
            name: '通海县',
            did: 530423
          },
          {
            name: '华宁县',
            did: 530424
          },
          {
            name: '易门县',
            did: 530425
          },
          {
            name: '峨山彝族自治县',
            did: 530426
          },
          {
            name: '新平彝族傣族自治县',
            did: 530427
          },
          {
            name: '元江哈尼族彝族傣族自治县',
            did: 530428
          }
        ],
        name: '玉溪市',
        cid: 530400
      },
      {
        areaList: [
          {
            name: '市辖区',
            did: 530501
          },
          {
            name: '隆阳区',
            did: 530502
          },
          {
            name: '施甸县',
            did: 530521
          },
          {
            name: '腾冲县',
            did: 530522
          },
          {
            name: '龙陵县',
            did: 530523
          },
          {
            name: '昌宁县',
            did: 530524
          }
        ],
        name: '保山市',
        cid: 530500
      },
      {
        areaList: [
          {
            name: '市辖区',
            did: 530601
          },
          {
            name: '昭阳区',
            did: 530602
          },
          {
            name: '鲁甸县',
            did: 530621
          },
          {
            name: '巧家县',
            did: 530622
          },
          {
            name: '盐津县',
            did: 530623
          },
          {
            name: '大关县',
            did: 530624
          },
          {
            name: '永善县',
            did: 530625
          },
          {
            name: '绥江县',
            did: 530626
          },
          {
            name: '镇雄县',
            did: 530627
          },
          {
            name: '彝良县',
            did: 530628
          },
          {
            name: '威信县',
            did: 530629
          },
          {
            name: '水富县',
            did: 530630
          }
        ],
        name: '昭通市',
        cid: 530600
      },
      {
        areaList: [
          {
            name: '市辖区',
            did: 530701
          },
          {
            name: '古城区',
            did: 530702
          },
          {
            name: '玉龙纳西族自治县',
            did: 530721
          },
          {
            name: '永胜县',
            did: 530722
          },
          {
            name: '华坪县',
            did: 530723
          },
          {
            name: '宁蒗彝族自治县',
            did: 530724
          }
        ],
        name: '丽江市',
        cid: 530700
      },
      {
        areaList: [
          {
            name: '市辖区',
            did: 530801
          },
          {
            name: '思茅区',
            did: 530802
          },
          {
            name: '宁洱哈尼族彝族自治县',
            did: 530821
          },
          {
            name: '墨江哈尼族自治县',
            did: 530822
          },
          {
            name: '景东彝族自治县',
            did: 530823
          },
          {
            name: '景谷傣族彝族自治县',
            did: 530824
          },
          {
            name: '镇沅彝族哈尼族拉祜族自治县',
            did: 530825
          },
          {
            name: '江城哈尼族彝族自治县',
            did: 530826
          },
          {
            name: '孟连傣族拉祜族佤族自治县',
            did: 530827
          },
          {
            name: '澜沧拉祜族自治县',
            did: 530828
          },
          {
            name: '西盟佤族自治县',
            did: 530829
          }
        ],
        name: '普洱市',
        cid: 530800
      },
      {
        areaList: [
          {
            name: '市辖区',
            did: 530901
          },
          {
            name: '临翔区',
            did: 530902
          },
          {
            name: '凤庆县',
            did: 530921
          },
          {
            name: '云县',
            did: 530922
          },
          {
            name: '永德县',
            did: 530923
          },
          {
            name: '镇康县',
            did: 530924
          },
          {
            name: '双江拉祜族佤族布朗族傣族自治县',
            did: 530925
          },
          {
            name: '耿马傣族佤族自治县',
            did: 530926
          },
          {
            name: '沧源佤族自治县',
            did: 530927
          }
        ],
        name: '临沧市',
        cid: 530900
      },
      {
        areaList: [
          {
            name: '楚雄市',
            did: 532301
          },
          {
            name: '双柏县',
            did: 532322
          },
          {
            name: '牟定县',
            did: 532323
          },
          {
            name: '南华县',
            did: 532324
          },
          {
            name: '姚安县',
            did: 532325
          },
          {
            name: '大姚县',
            did: 532326
          },
          {
            name: '永仁县',
            did: 532327
          },
          {
            name: '元谋县',
            did: 532328
          },
          {
            name: '武定县',
            did: 532329
          },
          {
            name: '禄丰县',
            did: 532331
          }
        ],
        name: '楚雄彝族自治州',
        cid: 532300
      },
      {
        areaList: [
          {
            name: '个旧市',
            did: 532501
          },
          {
            name: '开远市',
            did: 532502
          },
          {
            name: '蒙自市',
            did: 532503
          },
          {
            name: '弥勒市',
            did: 532504
          },
          {
            name: '屏边苗族自治县',
            did: 532523
          },
          {
            name: '建水县',
            did: 532524
          },
          {
            name: '石屏县',
            did: 532525
          },
          {
            name: '泸西县',
            did: 532527
          },
          {
            name: '元阳县',
            did: 532528
          },
          {
            name: '红河县',
            did: 532529
          },
          {
            name: '金平苗族瑶族傣族自治县',
            did: 532530
          },
          {
            name: '绿春县',
            did: 532531
          },
          {
            name: '河口瑶族自治县',
            did: 532532
          }
        ],
        name: '红河哈尼族彝族自治州',
        cid: 532500
      },
      {
        areaList: [
          {
            name: '文山市',
            did: 532601
          },
          {
            name: '砚山县',
            did: 532622
          },
          {
            name: '西畴县',
            did: 532623
          },
          {
            name: '麻栗坡县',
            did: 532624
          },
          {
            name: '马关县',
            did: 532625
          },
          {
            name: '丘北县',
            did: 532626
          },
          {
            name: '广南县',
            did: 532627
          },
          {
            name: '富宁县',
            did: 532628
          }
        ],
        name: '文山壮族苗族自治州',
        cid: 532600
      },
      {
        areaList: [
          {
            name: '景洪市',
            did: 532801
          },
          {
            name: '勐海县',
            did: 532822
          },
          {
            name: '勐腊县',
            did: 532823
          }
        ],
        name: '西双版纳傣族自治州',
        cid: 532800
      },
      {
        areaList: [
          {
            name: '大理市',
            did: 532901
          },
          {
            name: '漾濞彝族自治县',
            did: 532922
          },
          {
            name: '祥云县',
            did: 532923
          },
          {
            name: '宾川县',
            did: 532924
          },
          {
            name: '弥渡县',
            did: 532925
          },
          {
            name: '南涧彝族自治县',
            did: 532926
          },
          {
            name: '巍山彝族回族自治县',
            did: 532927
          },
          {
            name: '永平县',
            did: 532928
          },
          {
            name: '云龙县',
            did: 532929
          },
          {
            name: '洱源县',
            did: 532930
          },
          {
            name: '剑川县',
            did: 532931
          },
          {
            name: '鹤庆县',
            did: 532932
          }
        ],
        name: '大理白族自治州',
        cid: 532900
      },
      {
        areaList: [
          {
            name: '瑞丽市',
            did: 533102
          },
          {
            name: '芒市',
            did: 533103
          },
          {
            name: '梁河县',
            did: 533122
          },
          {
            name: '盈江县',
            did: 533123
          },
          {
            name: '陇川县',
            did: 533124
          }
        ],
        name: '德宏傣族景颇族自治州',
        cid: 533100
      },
      {
        areaList: [
          {
            name: '泸水县',
            did: 533321
          },
          {
            name: '福贡县',
            did: 533323
          },
          {
            name: '贡山独龙族怒族自治县',
            did: 533324
          },
          {
            name: '兰坪白族普米族自治县',
            did: 533325
          }
        ],
        name: '怒江傈僳族自治州',
        cid: 533300
      },
      {
        areaList: [
          {
            name: '香格里拉县',
            did: 533421
          },
          {
            name: '德钦县',
            did: 533422
          },
          {
            name: '维西傈僳族自治县',
            did: 533423
          }
        ],
        name: '迪庆藏族自治州',
        cid: 533400
      }
    ]
  },
  {
    pid: 540000,
    name: '西藏自治区',
    cityList: [
      {
        areaList: [
          {
            name: '市辖区',
            did: 540101
          },
          {
            name: '城关区',
            did: 540102
          },
          {
            name: '林周县',
            did: 540121
          },
          {
            name: '当雄县',
            did: 540122
          },
          {
            name: '尼木县',
            did: 540123
          },
          {
            name: '曲水县',
            did: 540124
          },
          {
            name: '堆龙德庆县',
            did: 540125
          },
          {
            name: '达孜县',
            did: 540126
          },
          {
            name: '墨竹工卡县',
            did: 540127
          }
        ],
        name: '拉萨市',
        cid: 540100
      },
      {
        areaList: [
          {
            name: '昌都县',
            did: 542121
          },
          {
            name: '江达县',
            did: 542122
          },
          {
            name: '贡觉县',
            did: 542123
          },
          {
            name: '类乌齐县',
            did: 542124
          },
          {
            name: '丁青县',
            did: 542125
          },
          {
            name: '察雅县',
            did: 542126
          },
          {
            name: '八宿县',
            did: 542127
          },
          {
            name: '左贡县',
            did: 542128
          },
          {
            name: '芒康县',
            did: 542129
          },
          {
            name: '洛隆县',
            did: 542132
          },
          {
            name: '边坝县',
            did: 542133
          }
        ],
        name: '昌都地区',
        cid: 542100
      },
      {
        areaList: [
          {
            name: '乃东县',
            did: 542221
          },
          {
            name: '扎囊县',
            did: 542222
          },
          {
            name: '贡嘎县',
            did: 542223
          },
          {
            name: '桑日县',
            did: 542224
          },
          {
            name: '琼结县',
            did: 542225
          },
          {
            name: '曲松县',
            did: 542226
          },
          {
            name: '措美县',
            did: 542227
          },
          {
            name: '洛扎县',
            did: 542228
          },
          {
            name: '加查县',
            did: 542229
          },
          {
            name: '隆子县',
            did: 542231
          },
          {
            name: '错那县',
            did: 542232
          },
          {
            name: '浪卡子县',
            did: 542233
          }
        ],
        name: '山南地区',
        cid: 542200
      },
      {
        areaList: [
          {
            name: '日喀则市',
            did: 542301
          },
          {
            name: '南木林县',
            did: 542322
          },
          {
            name: '江孜县',
            did: 542323
          },
          {
            name: '定日县',
            did: 542324
          },
          {
            name: '萨迦县',
            did: 542325
          },
          {
            name: '拉孜县',
            did: 542326
          },
          {
            name: '昂仁县',
            did: 542327
          },
          {
            name: '谢通门县',
            did: 542328
          },
          {
            name: '白朗县',
            did: 542329
          },
          {
            name: '仁布县',
            did: 542330
          },
          {
            name: '康马县',
            did: 542331
          },
          {
            name: '定结县',
            did: 542332
          },
          {
            name: '仲巴县',
            did: 542333
          },
          {
            name: '亚东县',
            did: 542334
          },
          {
            name: '吉隆县',
            did: 542335
          },
          {
            name: '聂拉木县',
            did: 542336
          },
          {
            name: '萨嘎县',
            did: 542337
          },
          {
            name: '岗巴县',
            did: 542338
          }
        ],
        name: '日喀则地区',
        cid: 542300
      },
      {
        areaList: [
          {
            name: '那曲县',
            did: 542421
          },
          {
            name: '嘉黎县',
            did: 542422
          },
          {
            name: '比如县',
            did: 542423
          },
          {
            name: '聂荣县',
            did: 542424
          },
          {
            name: '安多县',
            did: 542425
          },
          {
            name: '申扎县',
            did: 542426
          },
          {
            name: '索县',
            did: 542427
          },
          {
            name: '班戈县',
            did: 542428
          },
          {
            name: '巴青县',
            did: 542429
          },
          {
            name: '尼玛县',
            did: 542430
          },
          {
            name: '双湖县',
            did: 542431
          }
        ],
        name: '那曲地区',
        cid: 542400
      },
      {
        areaList: [
          {
            name: '普兰县',
            did: 542521
          },
          {
            name: '札达县',
            did: 542522
          },
          {
            name: '噶尔县',
            did: 542523
          },
          {
            name: '日土县',
            did: 542524
          },
          {
            name: '革吉县',
            did: 542525
          },
          {
            name: '改则县',
            did: 542526
          },
          {
            name: '措勤县',
            did: 542527
          }
        ],
        name: '阿里地区',
        cid: 542500
      },
      {
        areaList: [
          {
            name: '林芝县',
            did: 542621
          },
          {
            name: '工布江达县',
            did: 542622
          },
          {
            name: '米林县',
            did: 542623
          },
          {
            name: '墨脱县',
            did: 542624
          },
          {
            name: '波密县',
            did: 542625
          },
          {
            name: '察隅县',
            did: 542626
          },
          {
            name: '朗县',
            did: 542627
          }
        ],
        name: '林芝地区',
        cid: 542600
      }
    ]
  },
  {
    pid: 610000,
    name: '陕西省',
    cityList: [
      {
        areaList: [
          {
            name: '市辖区',
            did: 610101
          },
          {
            name: '新城区',
            did: 610102
          },
          {
            name: '碑林区',
            did: 610103
          },
          {
            name: '莲湖区',
            did: 610104
          },
          {
            name: '灞桥区',
            did: 610111
          },
          {
            name: '未央区',
            did: 610112
          },
          {
            name: '雁塔区',
            did: 610113
          },
          {
            name: '阎良区',
            did: 610114
          },
          {
            name: '临潼区',
            did: 610115
          },
          {
            name: '长安区',
            did: 610116
          },
          {
            name: '蓝田县',
            did: 610122
          },
          {
            name: '周至县',
            did: 610124
          },
          {
            name: '户县',
            did: 610125
          },
          {
            name: '高陵县',
            did: 610126
          }
        ],
        name: '西安市',
        cid: 610100
      },
      {
        areaList: [
          {
            name: '市辖区',
            did: 610201
          },
          {
            name: '王益区',
            did: 610202
          },
          {
            name: '印台区',
            did: 610203
          },
          {
            name: '耀州区',
            did: 610204
          },
          {
            name: '宜君县',
            did: 610222
          }
        ],
        name: '铜川市',
        cid: 610200
      },
      {
        areaList: [
          {
            name: '市辖区',
            did: 610301
          },
          {
            name: '渭滨区',
            did: 610302
          },
          {
            name: '金台区',
            did: 610303
          },
          {
            name: '陈仓区',
            did: 610304
          },
          {
            name: '凤翔县',
            did: 610322
          },
          {
            name: '岐山县',
            did: 610323
          },
          {
            name: '扶风县',
            did: 610324
          },
          {
            name: '眉县',
            did: 610326
          },
          {
            name: '陇县',
            did: 610327
          },
          {
            name: '千阳县',
            did: 610328
          },
          {
            name: '麟游县',
            did: 610329
          },
          {
            name: '凤县',
            did: 610330
          },
          {
            name: '太白县',
            did: 610331
          }
        ],
        name: '宝鸡市',
        cid: 610300
      },
      {
        areaList: [
          {
            name: '市辖区',
            did: 610401
          },
          {
            name: '秦都区',
            did: 610402
          },
          {
            name: '杨陵区',
            did: 610403
          },
          {
            name: '渭城区',
            did: 610404
          },
          {
            name: '三原县',
            did: 610422
          },
          {
            name: '泾阳县',
            did: 610423
          },
          {
            name: '乾县',
            did: 610424
          },
          {
            name: '礼泉县',
            did: 610425
          },
          {
            name: '永寿县',
            did: 610426
          },
          {
            name: '彬县',
            did: 610427
          },
          {
            name: '长武县',
            did: 610428
          },
          {
            name: '旬邑县',
            did: 610429
          },
          {
            name: '淳化县',
            did: 610430
          },
          {
            name: '武功县',
            did: 610431
          },
          {
            name: '兴平市',
            did: 610481
          }
        ],
        name: '咸阳市',
        cid: 610400
      },
      {
        areaList: [
          {
            name: '市辖区',
            did: 610501
          },
          {
            name: '临渭区',
            did: 610502
          },
          {
            name: '华县',
            did: 610521
          },
          {
            name: '潼关县',
            did: 610522
          },
          {
            name: '大荔县',
            did: 610523
          },
          {
            name: '合阳县',
            did: 610524
          },
          {
            name: '澄城县',
            did: 610525
          },
          {
            name: '蒲城县',
            did: 610526
          },
          {
            name: '白水县',
            did: 610527
          },
          {
            name: '富平县',
            did: 610528
          },
          {
            name: '韩城市',
            did: 610581
          },
          {
            name: '华阴市',
            did: 610582
          }
        ],
        name: '渭南市',
        cid: 610500
      },
      {
        areaList: [
          {
            name: '市辖区',
            did: 610601
          },
          {
            name: '宝塔区',
            did: 610602
          },
          {
            name: '延长县',
            did: 610621
          },
          {
            name: '延川县',
            did: 610622
          },
          {
            name: '子长县',
            did: 610623
          },
          {
            name: '安塞县',
            did: 610624
          },
          {
            name: '志丹县',
            did: 610625
          },
          {
            name: '吴起县',
            did: 610626
          },
          {
            name: '甘泉县',
            did: 610627
          },
          {
            name: '富县',
            did: 610628
          },
          {
            name: '洛川县',
            did: 610629
          },
          {
            name: '宜川县',
            did: 610630
          },
          {
            name: '黄龙县',
            did: 610631
          },
          {
            name: '黄陵县',
            did: 610632
          }
        ],
        name: '延安市',
        cid: 610600
      },
      {
        areaList: [
          {
            name: '市辖区',
            did: 610701
          },
          {
            name: '汉台区',
            did: 610702
          },
          {
            name: '南郑县',
            did: 610721
          },
          {
            name: '城固县',
            did: 610722
          },
          {
            name: '洋县',
            did: 610723
          },
          {
            name: '西乡县',
            did: 610724
          },
          {
            name: '勉县',
            did: 610725
          },
          {
            name: '宁强县',
            did: 610726
          },
          {
            name: '略阳县',
            did: 610727
          },
          {
            name: '镇巴县',
            did: 610728
          },
          {
            name: '留坝县',
            did: 610729
          },
          {
            name: '佛坪县',
            did: 610730
          }
        ],
        name: '汉中市',
        cid: 610700
      },
      {
        areaList: [
          {
            name: '市辖区',
            did: 610801
          },
          {
            name: '榆阳区',
            did: 610802
          },
          {
            name: '神木县',
            did: 610821
          },
          {
            name: '府谷县',
            did: 610822
          },
          {
            name: '横山县',
            did: 610823
          },
          {
            name: '靖边县',
            did: 610824
          },
          {
            name: '定边县',
            did: 610825
          },
          {
            name: '绥德县',
            did: 610826
          },
          {
            name: '米脂县',
            did: 610827
          },
          {
            name: '佳县',
            did: 610828
          },
          {
            name: '吴堡县',
            did: 610829
          },
          {
            name: '清涧县',
            did: 610830
          },
          {
            name: '子洲县',
            did: 610831
          }
        ],
        name: '榆林市',
        cid: 610800
      },
      {
        areaList: [
          {
            name: '市辖区',
            did: 610901
          },
          {
            name: '汉滨区',
            did: 610902
          },
          {
            name: '汉阴县',
            did: 610921
          },
          {
            name: '石泉县',
            did: 610922
          },
          {
            name: '宁陕县',
            did: 610923
          },
          {
            name: '紫阳县',
            did: 610924
          },
          {
            name: '岚皋县',
            did: 610925
          },
          {
            name: '平利县',
            did: 610926
          },
          {
            name: '镇坪县',
            did: 610927
          },
          {
            name: '旬阳县',
            did: 610928
          },
          {
            name: '白河县',
            did: 610929
          }
        ],
        name: '安康市',
        cid: 610900
      },
      {
        areaList: [
          {
            name: '市辖区',
            did: 611001
          },
          {
            name: '商州区',
            did: 611002
          },
          {
            name: '洛南县',
            did: 611021
          },
          {
            name: '丹凤县',
            did: 611022
          },
          {
            name: '商南县',
            did: 611023
          },
          {
            name: '山阳县',
            did: 611024
          },
          {
            name: '镇安县',
            did: 611025
          },
          {
            name: '柞水县',
            did: 611026
          }
        ],
        name: '商洛市',
        cid: 611000
      }
    ]
  },
  {
    pid: 620000,
    name: '甘肃省',
    cityList: [
      {
        areaList: [
          {
            name: '市辖区',
            did: 620101
          },
          {
            name: '城关区',
            did: 620102
          },
          {
            name: '七里河区',
            did: 620103
          },
          {
            name: '西固区',
            did: 620104
          },
          {
            name: '安宁区',
            did: 620105
          },
          {
            name: '红古区',
            did: 620111
          },
          {
            name: '永登县',
            did: 620121
          },
          {
            name: '皋兰县',
            did: 620122
          },
          {
            name: '榆中县',
            did: 620123
          }
        ],
        name: '兰州市',
        cid: 620100
      },
      {
        areaList: [
          {
            name: '市辖区',
            did: 620201
          }
        ],
        name: '嘉峪关市',
        cid: 620200
      },
      {
        areaList: [
          {
            name: '市辖区',
            did: 620301
          },
          {
            name: '金川区',
            did: 620302
          },
          {
            name: '永昌县',
            did: 620321
          }
        ],
        name: '金昌市',
        cid: 620300
      },
      {
        areaList: [
          {
            name: '市辖区',
            did: 620401
          },
          {
            name: '白银区',
            did: 620402
          },
          {
            name: '平川区',
            did: 620403
          },
          {
            name: '靖远县',
            did: 620421
          },
          {
            name: '会宁县',
            did: 620422
          },
          {
            name: '景泰县',
            did: 620423
          }
        ],
        name: '白银市',
        cid: 620400
      },
      {
        areaList: [
          {
            name: '市辖区',
            did: 620501
          },
          {
            name: '秦州区',
            did: 620502
          },
          {
            name: '麦积区',
            did: 620503
          },
          {
            name: '清水县',
            did: 620521
          },
          {
            name: '秦安县',
            did: 620522
          },
          {
            name: '甘谷县',
            did: 620523
          },
          {
            name: '武山县',
            did: 620524
          },
          {
            name: '张家川回族自治县',
            did: 620525
          }
        ],
        name: '天水市',
        cid: 620500
      },
      {
        areaList: [
          {
            name: '市辖区',
            did: 620601
          },
          {
            name: '凉州区',
            did: 620602
          },
          {
            name: '民勤县',
            did: 620621
          },
          {
            name: '古浪县',
            did: 620622
          },
          {
            name: '天祝藏族自治县',
            did: 620623
          }
        ],
        name: '武威市',
        cid: 620600
      },
      {
        areaList: [
          {
            name: '市辖区',
            did: 620701
          },
          {
            name: '甘州区',
            did: 620702
          },
          {
            name: '肃南裕固族自治县',
            did: 620721
          },
          {
            name: '民乐县',
            did: 620722
          },
          {
            name: '临泽县',
            did: 620723
          },
          {
            name: '高台县',
            did: 620724
          },
          {
            name: '山丹县',
            did: 620725
          }
        ],
        name: '张掖市',
        cid: 620700
      },
      {
        areaList: [
          {
            name: '市辖区',
            did: 620801
          },
          {
            name: '崆峒区',
            did: 620802
          },
          {
            name: '泾川县',
            did: 620821
          },
          {
            name: '灵台县',
            did: 620822
          },
          {
            name: '崇信县',
            did: 620823
          },
          {
            name: '华亭县',
            did: 620824
          },
          {
            name: '庄浪县',
            did: 620825
          },
          {
            name: '静宁县',
            did: 620826
          }
        ],
        name: '平凉市',
        cid: 620800
      },
      {
        areaList: [
          {
            name: '市辖区',
            did: 620901
          },
          {
            name: '肃州区',
            did: 620902
          },
          {
            name: '金塔县',
            did: 620921
          },
          {
            name: '瓜州县',
            did: 620922
          },
          {
            name: '肃北蒙古族自治县',
            did: 620923
          },
          {
            name: '阿克塞哈萨克族自治县',
            did: 620924
          },
          {
            name: '玉门市',
            did: 620981
          },
          {
            name: '敦煌市',
            did: 620982
          }
        ],
        name: '酒泉市',
        cid: 620900
      },
      {
        areaList: [
          {
            name: '市辖区',
            did: 621001
          },
          {
            name: '西峰区',
            did: 621002
          },
          {
            name: '庆城县',
            did: 621021
          },
          {
            name: '环县',
            did: 621022
          },
          {
            name: '华池县',
            did: 621023
          },
          {
            name: '合水县',
            did: 621024
          },
          {
            name: '正宁县',
            did: 621025
          },
          {
            name: '宁县',
            did: 621026
          },
          {
            name: '镇原县',
            did: 621027
          }
        ],
        name: '庆阳市',
        cid: 621000
      },
      {
        areaList: [
          {
            name: '市辖区',
            did: 621101
          },
          {
            name: '安定区',
            did: 621102
          },
          {
            name: '通渭县',
            did: 621121
          },
          {
            name: '陇西县',
            did: 621122
          },
          {
            name: '渭源县',
            did: 621123
          },
          {
            name: '临洮县',
            did: 621124
          },
          {
            name: '漳县',
            did: 621125
          },
          {
            name: '岷县',
            did: 621126
          }
        ],
        name: '定西市',
        cid: 621100
      },
      {
        areaList: [
          {
            name: '市辖区',
            did: 621201
          },
          {
            name: '武都区',
            did: 621202
          },
          {
            name: '成县',
            did: 621221
          },
          {
            name: '文县',
            did: 621222
          },
          {
            name: '宕昌县',
            did: 621223
          },
          {
            name: '康县',
            did: 621224
          },
          {
            name: '西和县',
            did: 621225
          },
          {
            name: '礼县',
            did: 621226
          },
          {
            name: '徽县',
            did: 621227
          },
          {
            name: '两当县',
            did: 621228
          }
        ],
        name: '陇南市',
        cid: 621200
      },
      {
        areaList: [
          {
            name: '临夏市',
            did: 622901
          },
          {
            name: '临夏县',
            did: 622921
          },
          {
            name: '康乐县',
            did: 622922
          },
          {
            name: '永靖县',
            did: 622923
          },
          {
            name: '广河县',
            did: 622924
          },
          {
            name: '和政县',
            did: 622925
          },
          {
            name: '东乡族自治县',
            did: 622926
          },
          {
            name: '积石山保安族东乡族撒拉族自治县',
            did: 622927
          }
        ],
        name: '临夏回族自治州',
        cid: 622900
      },
      {
        areaList: [
          {
            name: '合作市',
            did: 623001
          },
          {
            name: '临潭县',
            did: 623021
          },
          {
            name: '卓尼县',
            did: 623022
          },
          {
            name: '舟曲县',
            did: 623023
          },
          {
            name: '迭部县',
            did: 623024
          },
          {
            name: '玛曲县',
            did: 623025
          },
          {
            name: '碌曲县',
            did: 623026
          },
          {
            name: '夏河县',
            did: 623027
          }
        ],
        name: '甘南藏族自治州',
        cid: 623000
      }
    ]
  },
  {
    pid: 630000,
    name: '青海省',
    cityList: [
      {
        areaList: [
          {
            name: '市辖区',
            did: 630101
          },
          {
            name: '城东区',
            did: 630102
          },
          {
            name: '城中区',
            did: 630103
          },
          {
            name: '城西区',
            did: 630104
          },
          {
            name: '城北区',
            did: 630105
          },
          {
            name: '大通回族土族自治县',
            did: 630121
          },
          {
            name: '湟中县',
            did: 630122
          },
          {
            name: '湟源县',
            did: 630123
          }
        ],
        name: '西宁市',
        cid: 630100
      },
      {
        areaList: [
          {
            name: '乐都区',
            did: 630202
          },
          {
            name: '平安县',
            did: 630221
          },
          {
            name: '民和回族土族自治县',
            did: 630222
          },
          {
            name: '互助土族自治县',
            did: 630223
          },
          {
            name: '化隆回族自治县',
            did: 630224
          },
          {
            name: '循化撒拉族自治县',
            did: 630225
          }
        ],
        name: '海东市',
        cid: 630200
      },
      {
        areaList: [
          {
            name: '门源回族自治县',
            did: 632221
          },
          {
            name: '祁连县',
            did: 632222
          },
          {
            name: '海晏县',
            did: 632223
          },
          {
            name: '刚察县',
            did: 632224
          }
        ],
        name: '海北藏族自治州',
        cid: 632200
      },
      {
        areaList: [
          {
            name: '同仁县',
            did: 632321
          },
          {
            name: '尖扎县',
            did: 632322
          },
          {
            name: '泽库县',
            did: 632323
          },
          {
            name: '河南蒙古族自治县',
            did: 632324
          }
        ],
        name: '黄南藏族自治州',
        cid: 632300
      },
      {
        areaList: [
          {
            name: '共和县',
            did: 632521
          },
          {
            name: '同德县',
            did: 632522
          },
          {
            name: '贵德县',
            did: 632523
          },
          {
            name: '兴海县',
            did: 632524
          },
          {
            name: '贵南县',
            did: 632525
          }
        ],
        name: '海南藏族自治州',
        cid: 632500
      },
      {
        areaList: [
          {
            name: '玛沁县',
            did: 632621
          },
          {
            name: '班玛县',
            did: 632622
          },
          {
            name: '甘德县',
            did: 632623
          },
          {
            name: '达日县',
            did: 632624
          },
          {
            name: '久治县',
            did: 632625
          },
          {
            name: '玛多县',
            did: 632626
          }
        ],
        name: '果洛藏族自治州',
        cid: 632600
      },
      {
        areaList: [
          {
            name: '玉树市',
            did: 632701
          },
          {
            name: '杂多县',
            did: 632722
          },
          {
            name: '称多县',
            did: 632723
          },
          {
            name: '治多县',
            did: 632724
          },
          {
            name: '囊谦县',
            did: 632725
          },
          {
            name: '曲麻莱县',
            did: 632726
          }
        ],
        name: '玉树藏族自治州',
        cid: 632700
      },
      {
        areaList: [
          {
            name: '格尔木市',
            did: 632801
          },
          {
            name: '德令哈市',
            did: 632802
          },
          {
            name: '乌兰县',
            did: 632821
          },
          {
            name: '都兰县',
            did: 632822
          },
          {
            name: '天峻县',
            did: 632823
          }
        ],
        name: '海西蒙古族藏族自治州',
        cid: 632800
      }
    ]
  },
  {
    pid: 640000,
    name: '宁夏回族自治区',
    cityList: [
      {
        areaList: [
          {
            name: '市辖区',
            did: 640101
          },
          {
            name: '兴庆区',
            did: 640104
          },
          {
            name: '西夏区',
            did: 640105
          },
          {
            name: '金凤区',
            did: 640106
          },
          {
            name: '永宁县',
            did: 640121
          },
          {
            name: '贺兰县',
            did: 640122
          },
          {
            name: '灵武市',
            did: 640181
          }
        ],
        name: '银川市',
        cid: 640100
      },
      {
        areaList: [
          {
            name: '市辖区',
            did: 640201
          },
          {
            name: '大武口区',
            did: 640202
          },
          {
            name: '惠农区',
            did: 640205
          },
          {
            name: '平罗县',
            did: 640221
          }
        ],
        name: '石嘴山市',
        cid: 640200
      },
      {
        areaList: [
          {
            name: '市辖区',
            did: 640301
          },
          {
            name: '利通区',
            did: 640302
          },
          {
            name: '红寺堡区',
            did: 640303
          },
          {
            name: '盐池县',
            did: 640323
          },
          {
            name: '同心县',
            did: 640324
          },
          {
            name: '青铜峡市',
            did: 640381
          }
        ],
        name: '吴忠市',
        cid: 640300
      },
      {
        areaList: [
          {
            name: '市辖区',
            did: 640401
          },
          {
            name: '原州区',
            did: 640402
          },
          {
            name: '西吉县',
            did: 640422
          },
          {
            name: '隆德县',
            did: 640423
          },
          {
            name: '泾源县',
            did: 640424
          },
          {
            name: '彭阳县',
            did: 640425
          }
        ],
        name: '固原市',
        cid: 640400
      },
      {
        areaList: [
          {
            name: '市辖区',
            did: 640501
          },
          {
            name: '沙坡头区',
            did: 640502
          },
          {
            name: '中宁县',
            did: 640521
          },
          {
            name: '海原县',
            did: 640522
          }
        ],
        name: '中卫市',
        cid: 640500
      }
    ]
  },
  {
    pid: 650000,
    name: '新疆维吾尔自治区',
    cityList: [
      {
        areaList: [
          {
            name: '市辖区',
            did: 650101
          },
          {
            name: '天山区',
            did: 650102
          },
          {
            name: '沙依巴克区',
            did: 650103
          },
          {
            name: '新市区',
            did: 650104
          },
          {
            name: '水磨沟区',
            did: 650105
          },
          {
            name: '头屯河区',
            did: 650106
          },
          {
            name: '达坂城区',
            did: 650107
          },
          {
            name: '米东区',
            did: 650109
          },
          {
            name: '乌鲁木齐县',
            did: 650121
          }
        ],
        name: '乌鲁木齐市',
        cid: 650100
      },
      {
        areaList: [
          {
            name: '市辖区',
            did: 650201
          },
          {
            name: '独山子区',
            did: 650202
          },
          {
            name: '克拉玛依区',
            did: 650203
          },
          {
            name: '白碱滩区',
            did: 650204
          },
          {
            name: '乌尔禾区',
            did: 650205
          }
        ],
        name: '克拉玛依市',
        cid: 650200
      },
      {
        areaList: [
          {
            name: '吐鲁番市',
            did: 652101
          },
          {
            name: '鄯善县',
            did: 652122
          },
          {
            name: '托克逊县',
            did: 652123
          }
        ],
        name: '吐鲁番地区',
        cid: 652100
      },
      {
        areaList: [
          {
            name: '哈密市',
            did: 652201
          },
          {
            name: '巴里坤哈萨克自治县',
            did: 652222
          },
          {
            name: '伊吾县',
            did: 652223
          }
        ],
        name: '哈密地区',
        cid: 652200
      },
      {
        areaList: [
          {
            name: '昌吉市',
            did: 652301
          },
          {
            name: '阜康市',
            did: 652302
          },
          {
            name: '呼图壁县',
            did: 652323
          },
          {
            name: '玛纳斯县',
            did: 652324
          },
          {
            name: '奇台县',
            did: 652325
          },
          {
            name: '吉木萨尔县',
            did: 652327
          },
          {
            name: '木垒哈萨克自治县',
            did: 652328
          }
        ],
        name: '昌吉回族自治州',
        cid: 652300
      },
      {
        areaList: [
          {
            name: '博乐市',
            did: 652701
          },
          {
            name: '阿拉山口市',
            did: 652702
          },
          {
            name: '精河县',
            did: 652722
          },
          {
            name: '温泉县',
            did: 652723
          }
        ],
        name: '博尔塔拉蒙古自治州',
        cid: 652700
      },
      {
        areaList: [
          {
            name: '库尔勒市',
            did: 652801
          },
          {
            name: '轮台县',
            did: 652822
          },
          {
            name: '尉犁县',
            did: 652823
          },
          {
            name: '若羌县',
            did: 652824
          },
          {
            name: '且末县',
            did: 652825
          },
          {
            name: '焉耆回族自治县',
            did: 652826
          },
          {
            name: '和静县',
            did: 652827
          },
          {
            name: '和硕县',
            did: 652828
          },
          {
            name: '博湖县',
            did: 652829
          }
        ],
        name: '巴音郭楞蒙古自治州',
        cid: 652800
      },
      {
        areaList: [
          {
            name: '阿克苏市',
            did: 652901
          },
          {
            name: '温宿县',
            did: 652922
          },
          {
            name: '库车县',
            did: 652923
          },
          {
            name: '沙雅县',
            did: 652924
          },
          {
            name: '新和县',
            did: 652925
          },
          {
            name: '拜城县',
            did: 652926
          },
          {
            name: '乌什县',
            did: 652927
          },
          {
            name: '阿瓦提县',
            did: 652928
          },
          {
            name: '柯坪县',
            did: 652929
          }
        ],
        name: '阿克苏地区',
        cid: 652900
      },
      {
        areaList: [
          {
            name: '阿图什市',
            did: 653001
          },
          {
            name: '阿克陶县',
            did: 653022
          },
          {
            name: '阿合奇县',
            did: 653023
          },
          {
            name: '乌恰县',
            did: 653024
          }
        ],
        name: '克孜勒苏柯尔克孜自治州',
        cid: 653000
      },
      {
        areaList: [
          {
            name: '喀什市',
            did: 653101
          },
          {
            name: '疏附县',
            did: 653121
          },
          {
            name: '疏勒县',
            did: 653122
          },
          {
            name: '英吉沙县',
            did: 653123
          },
          {
            name: '泽普县',
            did: 653124
          },
          {
            name: '莎车县',
            did: 653125
          },
          {
            name: '叶城县',
            did: 653126
          },
          {
            name: '麦盖提县',
            did: 653127
          },
          {
            name: '岳普湖县',
            did: 653128
          },
          {
            name: '伽师县',
            did: 653129
          },
          {
            name: '巴楚县',
            did: 653130
          },
          {
            name: '塔什库尔干塔吉克自治县',
            did: 653131
          }
        ],
        name: '喀什地区',
        cid: 653100
      },
      {
        areaList: [
          {
            name: '和田市',
            did: 653201
          },
          {
            name: '和田县',
            did: 653221
          },
          {
            name: '墨玉县',
            did: 653222
          },
          {
            name: '皮山县',
            did: 653223
          },
          {
            name: '洛浦县',
            did: 653224
          },
          {
            name: '策勒县',
            did: 653225
          },
          {
            name: '于田县',
            did: 653226
          },
          {
            name: '民丰县',
            did: 653227
          }
        ],
        name: '和田地区',
        cid: 653200
      },
      {
        areaList: [
          {
            name: '伊宁市',
            did: 654002
          },
          {
            name: '奎屯市',
            did: 654003
          },
          {
            name: '伊宁县',
            did: 654021
          },
          {
            name: '察布查尔锡伯自治县',
            did: 654022
          },
          {
            name: '霍城县',
            did: 654023
          },
          {
            name: '巩留县',
            did: 654024
          },
          {
            name: '新源县',
            did: 654025
          },
          {
            name: '昭苏县',
            did: 654026
          },
          {
            name: '特克斯县',
            did: 654027
          },
          {
            name: '尼勒克县',
            did: 654028
          }
        ],
        name: '伊犁哈萨克自治州',
        cid: 654000
      },
      {
        areaList: [
          {
            name: '塔城市',
            did: 654201
          },
          {
            name: '乌苏市',
            did: 654202
          },
          {
            name: '额敏县',
            did: 654221
          },
          {
            name: '沙湾县',
            did: 654223
          },
          {
            name: '托里县',
            did: 654224
          },
          {
            name: '裕民县',
            did: 654225
          },
          {
            name: '和布克赛尔蒙古自治县',
            did: 654226
          }
        ],
        name: '塔城地区',
        cid: 654200
      },
      {
        areaList: [
          {
            name: '阿勒泰市',
            did: 654301
          },
          {
            name: '布尔津县',
            did: 654321
          },
          {
            name: '富蕴县',
            did: 654322
          },
          {
            name: '福海县',
            did: 654323
          },
          {
            name: '哈巴河县',
            did: 654324
          },
          {
            name: '青河县',
            did: 654325
          },
          {
            name: '吉木乃县',
            did: 654326
          }
        ],
        name: '阿勒泰地区',
        cid: 654300
      },
      {
        areaList: [
          {
            name: '石河子市',
            did: 659001
          },
          {
            name: '阿拉尔市',
            did: 659002
          },
          {
            name: '图木舒克市',
            did: 659003
          },
          {
            name: '五家渠市',
            did: 659004
          }
        ],
        name: '自治区直辖县级行政区划',
        cid: 659000
      }
    ]
  },
  {
    pid: 810000,
    name: '香港特别行政区',
    cityList: [
      {
        areaList: [
          {
            name: '香港特别行政区',
            did: 810000
          }
        ],
        name: '香港特别行政区',
        cid: 810000
      }
    ]
  },
  {
    pid: 820000,
    name: '澳门特别行政区',
    cityList: [
      {
        areaList: [
          {
            name: '澳门特别行政区',
            did: 820000
          }
        ],
        name: '澳门特别行政区',
        cid: 820000
      }
    ]
  }
]
